export default {
	"access.organization.name": "Access to organization card",
	"access.user.card": "Access to user card",
	"action.customize.view": "Widok spersonalizowany",
	"action.default.view": "Widok domyślny",
	"action.viewcart": "Widok koszyka",
	"active": "Aktywny",
	"add-suborg.add-suborg": "Dodaj podorganizację",
	"add-suborg.admin-info": "Informacje dotyczące administratora",
	"add-suborg.administrator": "Administrator",
	"add-suborg.confirmation": "Potwierdzenie",
	"add-suborg.email": "Adres e-mail administratora",
	"add-suborg.firstname": "Imię administratora",
	"add-suborg.id": "Nr identyfikacyjny organizacji",
	"add-suborg.intro": "W przypadku organizacji Arcelormittal Europe wybierz istniejącą organizację lub utwórz nową:",
	"add-suborg.lastname": "Nazwisko administratora",
	"add-suborg.matchin-org-intro": "Użyj danych z pasującej organizacji:",
	"add-suborg.matching-organizations": "Pasujące organizacje",
	"add-suborg.new-org-intro": "Utwórz nową podorganizację od podstaw:",
	"add-suborg.org-info": "Informacje na temat organizacji",
	"add-suborg.org-name": "Nazwa organizacji",
	"add-suborg.organization-details": "Szczegółowe dane organizacji",
	"add-suborg.please-select": "Wybierz opcję",
	"add-suborg.quick-search": "Wyszukaj użytkownika",
	"add-suborg.vat-num-already-exists": "Numer Vat już istnieje. Prosimy o podanie nowego numeru vat",
	"add-suborg.vat-number": "Nr VAT",
	"add-user.add-user": "Dodaj użytkownika",
	"add-user.admin-user": "Awansuj na administratora tej organizacji",
	"add-user.confirmation": "Potwierdzenie",
	"add-user.email": "E-mail",
	"add-user.email-exist": "Nr id. e-maila już istnieje",
	"add-user.intro": "W przypadku organizacji Arcelormittal Europe wybierz istniejącego użytkownika lub utwórz nowego:",
	"add-user.matchin-users-intro": "Użyj danych od pasujących użytkowników:",
	"add-user.matching-users": "Pasujący użytkownicy",
	"add-user.name": "Nazwa",
	"add-user.new-user-intro": "  Utwórz nowego użytkownika od podstaw:",
	"add-user.please-select": "Wybierz opcję",
	"add-user.proceed-to-creation": "Rozpocznij tworzenie",
	"add-user.referal-organization": "Organizacja polecająca",
	"add-user.required": "Obowiązkowe",
	"add-user.services": "Usługi",
	"add-user.services-management": "Zarządzanie usługami",
	"add-user.user-creation": "Utworzenie użytkownika",
	"add-user.user-email": "E-mail",
	"add-user.user-exists": "Wybrany użytkownik już istnieje w organizacji",
	"add-user.user-firstname": "Imię",
	"add-user.user-informations": "Informacje dotyczące użytkownika",
	"add-user.user-lastname": "Nazwisko",
	"add-user.user-not-active": "Wybrany użytkownik jest nieaktywny",
	"add-user.user-type": "Type of user",
	"add.item.to.cart.error.msg": "Coś poszło nie tak podczas dodawania produktów do koszyka, spróbuj ponownie za jakiś czas.",
	"add.to.cart.label": "Dodaj do koszyka",
	"administrator.message": "jest administratorem organizacji:",
	"ag-grid.copy": "Kopiuj",
	"ag-grid.copyWithHeaders": "Kopiuj z nagłówkami",
	"ag-grid.csvExport": "Eksport pliku CSV",
	"ag-grid.excelExport": "Eksport pliku Excel (.xlsx)&lrm;",
	"ag-grid.excelXmlExport": "Eksport pliku Excel (.xml)&lrm;",
	"ag-grid.export": "Eksportuj",
	"ag-grid.paste": "Wklej",
	"all.productsFamilies.not.available": "All productFamilies are not available",
	"application.procurement.supplier.rfqNumber": "Numer RFQ dostawcy",
	"aqdb.N.of.dispatch.note": "N of Dispatch Note",
	"aqdb.ageing.duration": "Duration of ageing",
	"aqdb.ageing.temp": "Temperature of ageing",
	"aqdb.aluminium": "% Al",
	"aqdb.anisotropy.avg.r": "R average",
	"aqdb.anisotropy.direction": "Cutting Direction Compared to Rolling",
	"aqdb.anisotropy.r": "Value R",
	"aqdb.arsenic": "% Ar",
	"aqdb.article.reference": "Article reference",
	"aqdb.aspect.side.1": "Aspect side 1 code",
	"aqdb.aspect.side.2": "Aspect side 2 code",
	"aqdb.av.date": "Available date",
	"aqdb.avg.hardening.ratio": "Coefficient of Average Work Hardening",
	"aqdb.axis": "Axis",
	"aqdb.bakeHardening.with.elongation": "Bake-hardening with 2% elongation",
	"aqdb.bakeHardening.without.elongation": "Bake-hardening without elongation",
	"aqdb.base.product.number": "Base product number",
	"aqdb.base.product.release": "Base product release",
	"aqdb.batch": "Batch",
	"aqdb.batch.reference": "Batch reference",
	"aqdb.bend.indicator": "Code folding",
	"aqdb.boron": "% B",
	"aqdb.calcium": "% Ca",
	"aqdb.carbon": "% C",
	"aqdb.carbon.eq.formula": "Formula carbon-equivalent",
	"aqdb.carbon.equivalent": "Carbon equivalent",
	"aqdb.casting.date": "Casting date",
	"aqdb.casting.mill": "Casting Mill",
	"aqdb.cerium": "% Ce",
	"aqdb.chemical.characteristics": "Chemical characteristics",
	"aqdb.chemical.characteristics.cast.analysis": "Chemical characteristics - Cast analysis",
	"aqdb.chemical.characteristics.product.analysis": "Chemical characteristics - Product analysis",
	"aqdb.chemical.formula": "Another combination",
	"aqdb.chemical.surface.chemical.treatment.avg1": "Average value 1",
	"aqdb.chemical.surface.chemical.treatment.avg2": "Average value 2",
	"aqdb.chemical.surface.chemical.treatment.avg3": "Average value 3",
	"aqdb.chemical.surface.chemical.treatment.avg4": "Average value 4",
	"aqdb.chemical.surface.chemical.treatment.avg5": "Average value 5",
	"aqdb.chemical.surface.chemical.treatment.element1": "Chemical element 1",
	"aqdb.chemical.surface.chemical.treatment.element2": "Chemical element 2",
	"aqdb.chemical.surface.chemical.treatment.element3": "Chemical element 3",
	"aqdb.chemical.surface.chemical.treatment.element4": "Chemical element 4",
	"aqdb.chemical.surface.chemical.treatment.element5": "Chemical element 5",
	"aqdb.chemical.surface.chemical.treatment.type": "Type of chemical coating",
	"aqdb.chemical.surface.treatment": "Coating / Surface characteristics - Inorganic coating",
	"aqdb.chromium": "% Cr",
	"aqdb.coating.surface.face": "Face",
	"aqdb.coating.surface.side": "Side",
	"aqdb.code": "Code",
	"aqdb.combination.value": "Value combination",
	"aqdb.commercial.quality": "Commercial quality",
	"aqdb.complete.message": "Indicator of complete message",
	"aqdb.copper": "% Cu",
	"aqdb.customer.article.ref": "Customer Article Ref.",
	"aqdb.customer.product": "Customer product",
	"aqdb.customer.product.data": "Customer products data",
	"aqdb.datas.transmitted.on.certificate": "Data transmitted on certificate",
	"aqdb.date": "Date",
	"aqdb.date.chemical": "Identification Date",
	"aqdb.delivery.mill": "Delivery mill",
	"aqdb.description": "Technical Quality Label",
	"aqdb.dimensions.form": "Dimensions & Form",
	"aqdb.direction.L": "Longitudinal",
	"aqdb.direction.T": "Transverse",
	"aqdb.dis.elongation": "Lengthening distributed",
	"aqdb.dispatch.advice.number": "Dispatch advice number",
	"aqdb.dispatch.date": "Dispatch Date",
	"aqdb.erichsen.index": "Erichsen index",
	"aqdb.external.diameter": "External diameter of MU",
	"aqdb.face.appearance.code1": "Face appearance code 1",
	"aqdb.face.appearance.code2": "Face appearance code 2",
	"aqdb.family.group.code": "Family group code",
	"aqdb.flag.complete": "Complete",
	"aqdb.flag.incomplete": "Incomplete",
	"aqdb.form": "Form",
	"aqdb.format.actual": "Format (actual/ordered)",
	"aqdb.formula.cal02": "Formula CAL02",
	"aqdb.formula.cal15": "Formula CAL15",
	"aqdb.grade": "Grade",
	"aqdb.gross.weight": "Gross Weight",
	"aqdb.hardness.index": "Hardness number",
	"aqdb.hardness.type": "Condition of the hardness test",
	"aqdb.heat.number": "Heat N°'",
	"aqdb.hydrogen": "% H",
	"aqdb.induction.10000w": "Induction at 10000 W",
	"aqdb.induction.2500w": "Induction at 2500 W",
	"aqdb.induction.5000w": "Induction at 5000 W",
	"aqdb.internal.diameter": "Internal diameter of MU",
	"aqdb.label": "Dane AQDB",
	"aqdb.lead": "% Pb",
	"aqdb.level": "Palier",
	"aqdb.losses.15t": "Losses at 1,5 T",
	"aqdb.losses.1t": "Losses at 1 T",
	"aqdb.magnetic.characteristicList": "Magnetic characteristics",
	"aqdb.manganese": "% Mn",
	"aqdb.marked.identity": "Marked Identity",
	"aqdb.measure.type": "Measure type",
	"aqdb.measured.datas": "Measured data",
	"aqdb.mechanical.characteristics.anisotropy": "Mechanical characteristics - Anisotropy",
	"aqdb.mechanical.characteristics.bake.hardening": "Mechanical characteristics - Bake hardening",
	"aqdb.mechanical.characteristics.bending": "Mechanical characteristics - Bending",
	"aqdb.mechanical.characteristics.erichsen": "Mechanical characteristics - Erichsen",
	"aqdb.mechanical.characteristics.hardness": "Mechanical characteristics - Hardness",
	"aqdb.mechanical.characteristics.impact.resistance": "Mechanical characteristics - Resilience",
	"aqdb.mechanical.characteristics.tensile.test": "Mechanical characteristics - Tensile test",
	"aqdb.metal.coating.aluminium": "% Aluminium",
	"aqdb.metal.coating.average.quantity": "Average quantity",
	"aqdb.metal.coating.characteristics": "Coating / Surface characteristics - Metal coating",
	"aqdb.metal.coating.delta.phase": "Mass Phase Delta",
	"aqdb.metal.coating.dzeta.phase": "Mass Phase Dzeta",
	"aqdb.metal.coating.gamma.phase": "Mass Phase Gamma",
	"aqdb.metal.coating.iron.rate": "Iron rate in galvallia",
	"aqdb.metal.coating.lead": "% Lead",
	"aqdb.metal.coating.measure.type": "Type of measurement",
	"aqdb.metal.coating.nature": "Nature of metallic coating",
	"aqdb.metal.coating.nickel": "% Nickel",
	"aqdb.metal.coating.powdering": "Powdering",
	"aqdb.metal.coating.quantity.centre": "Quantity Centre",
	"aqdb.metal.coating.quantity.edge1": "Quantity Edge 1",
	"aqdb.metal.coating.quantity.edge2": "Quantity Edge 2",
	"aqdb.metal.coating.spangling": "Spangling",
	"aqdb.metal.unit": "Metal unit",
	"aqdb.metal.unit.date": "Metal Unit Identification Date",
	"aqdb.metal.unit.information": "Metal unit informations",
	"aqdb.metal.unit.mill": "Metal Unit Identification Mill",
	"aqdb.mill.cast": "Mill Cast Number",
	"aqdb.mill.cast.number": "Mill Cast Number",
	"aqdb.mill.code": "Receiving mill code",
	"aqdb.mill.description": "Mill",
	"aqdb.mill.internal.ref": "Mill internal reference",
	"aqdb.modelled.data": "Modelled data",
	"aqdb.molybdenum": "% Mo",
	"aqdb.mpa.unit": "megapascal (Mpa)",
	"aqdb.nature": "Nature",
	"aqdb.net.weight": "Net weight (t)",
	"aqdb.nickel": "% Ni",
	"aqdb.niobium": "% Nb",
	"aqdb.nitrogen": "% N2",
	"aqdb.no": "No",
	"aqdb.nominal.thickness": "Nominal thickness",
	"aqdb.nominal.width": "Nominal width",
	"aqdb.notch.average.crystallinity.index": "Average crystallinity index",
	"aqdb.notch.average.ductility.rate": "Average ductility rate",
	"aqdb.notch.average.energy": "Average energy (in Joules)",
	"aqdb.notch.crystallinity.index1": "Crystallinity index 1",
	"aqdb.notch.crystallinity.index2": "Crystallinity index 2",
	"aqdb.notch.crystallinity.index3": "Crystallinity index 3",
	"aqdb.notch.energy1": "Energy 1 (in Joules)",
	"aqdb.notch.energy2": "Energy 2 (in Joules)",
	"aqdb.notch.energy3": "Energy 3 (in Joules)",
	"aqdb.notch.percent.ductility1": "Ductility rate 1",
	"aqdb.notch.percent.ductility2": "Ductility rate 2",
	"aqdb.notch.percent.ductility3": "Ductility rate 3",
	"aqdb.organic.coating.bending": "Bending",
	"aqdb.organic.coating.brilliance": "Brilliance",
	"aqdb.organic.coating.characteristics": "Coating / Surface characteristics - Organic coating",
	"aqdb.organic.coating.colour": "Colour",
	"aqdb.organic.coating.delta.a": "Delta A",
	"aqdb.organic.coating.delta.b": "Delta B",
	"aqdb.organic.coating.delta.e": "Delta E",
	"aqdb.organic.coating.delta.l": "Delta L",
	"aqdb.organic.coating.nature": "Nature of organic coating",
	"aqdb.organic.coating.reticulation": "Reticulation",
	"aqdb.organic.coating.thickness": "Thickness",
	"aqdb.origin.mill": "Origin Mill",
	"aqdb.other.characteristics": "Other Characteristics",
	"aqdb.oui": "Oui",
	"aqdb.phosphorus": "% P",
	"aqdb.pos.across.length": "Position test-tube in the length of the product",
	"aqdb.pos.across.width": "Position test-tube in the width of the product",
	"aqdb.product.family": "Product family",
	"aqdb.quality.code": "Technical Quality Code",
	"aqdb.quality.data": "sprawdź dane dotyczące jakości",
	"aqdb.quality.label": "Technical Quality Label",
	"aqdb.quality.version": "Technical Quality Version",
	"aqdb.quarter": "Quarter",
	"aqdb.recipient": "Recipient",
	"aqdb.release": "Technical Quality Version",
	"aqdb.roughness.characteristics": "Coating / Surface characteristics - Roughness",
	"aqdb.roughness.cut.off": "Cut-Off",
	"aqdb.roughness.obtainment": "Method of obtainment",
	"aqdb.roughness.peaks": "Number of peaks",
	"aqdb.roughness.ra": "Ra",
	"aqdb.roughness.rt": "Rt",
	"aqdb.roughness.rz": "Rz",
	"aqdb.roughness.threshold": "Threshold",
	"aqdb.roughness.w": "W",
	"aqdb.sample.type": "Type of test-tube",
	"aqdb.segment": "Segment",
	"aqdb.segments.no": "Number of Segments",
	"aqdb.serial.number": "Serial number",
	"aqdb.shipping": "Shipping Information",
	"aqdb.silicium": "% Si",
	"aqdb.steel.condition": "State of Metal",
	"aqdb.sulphur": "% S",
	"aqdb.surface.cleanliness.carbon": "Surface carbon",
	"aqdb.surface.cleanliness.characteristics": "Coating / Surface characteristics - Surface cleanliness",
	"aqdb.surface.cleanliness.iron": "Surface iron",
	"aqdb.surface.mu": "Surface of MU",
	"aqdb.technical.grade": "Technical grade",
	"aqdb.temp.notch": "Temperature notch test",
	"aqdb.tensile.direction": "Direction",
	"aqdb.tensile.re.rm": "Re/Rm",
	"aqdb.tensile.total.lengthening": "Total Lengthening",
	"aqdb.tensile.ultimate.tensile.stress": "Ultimate Tensile Stress",
	"aqdb.tensile.work.hardening.coefficient": "Work-hardening coefficient",
	"aqdb.test.condition": "Condition of the test",
	"aqdb.test.number.anisotropy": "Number of the test of anisotropy",
	"aqdb.test.number.bakehardening": "Number of the test Bake Hardening",
	"aqdb.test.number.bending": "Number of the bending test",
	"aqdb.test.number.erichsen": "Number of the test of Erichsen",
	"aqdb.test.number.hardness": "Number of the Hardness test",
	"aqdb.test.number.res": "Number of the reslience test",
	"aqdb.test.number.tensile": "Number of the tensile test",
	"aqdb.test.steel.condition": "State of the test-tube",
	"aqdb.test.temp": "Temperature of the test",
	"aqdb.thickness.mm": "Thickness (mm)",
	"aqdb.tin": "% Sn",
	"aqdb.titanium": "% Ti",
	"aqdb.unit": "Unit",
	"aqdb.user": "User",
	"aqdb.value.cal02": "CAL02",
	"aqdb.value.cal15": "CAL15",
	"aqdb.vanadium": "% V",
	"aqdb.weight.mu": "Net weight/Gross weight",
	"aqdb.width.mm": "Width (mm)",
	"aqdb.yes": "Yes",
	"aqdb.yield.stress": "Yield Stress",
	"aqdb.zinc": "% Zn",
	"aqdb.zirconium": "% Zr",
	"arcelormittal.need4steel.action.next": "Dalej",
	"arcelormittal.need4steel.action.proceed.to.order.button": "Przejdź do zamówienia",
	"arcelormittal.need4steel.entry": "ArcelorMittal Need4Steel®",
	"arcelormittal.need4steel.menu.entry": "ArcelorMittal Need4Steel",
	"attachment.limit.description": "PDF, DOC, XLS, PPT or images only. Max 20MB per file and max 3 files.",
	"auction-material.category.subcategory": "Kat./pod.",
	"auction-material.details": "Szczegółowe dane dotyczące materiału",
	"auction-material.downgrading.reason": "Powód przeklasyfikowania",
	"auction-material.oil.type": "Rodzaj oleju",
	"auction-offer.now-rows": "Brak dostępnej otwartej oferty aukcyjnej",
	"auction-offer.soldTo.changed.warning": "If you change the corporate name, all the bid details you have entered/modified in current session will be lost.",
	"auction.bid.list": "Aukcje - Lista z ofertami",
	"auction.bid.week": "Tydzień licytacji",
	"auction.bidding": "Oferty dla",
	"auction.bids": "Oferty",
	"auction.bundle.number": "Numer pakietu",
	"auction.confirm.bid": "Potwierdź ofertę",
	"auction.confirmation": "Potwierdzenie",
	"auction.dashboard": "Pulpit aukcji",
	"auction.description": "Opis aukcji",
	"auction.ended": "Zakończone",
	"auction.entry": "Aukcje",
	"auction.main.steelgrade": "Główny gatunek stali (wg ilości)",
	"auction.market": "Rynek",
	"auction.mill": "Huta",
	"auction.my.auction.bids": "Moje oferty",
	"auction.name": "Nazwa aukcji",
	"auction.new.offer.check": "Sprawdź nową ofertę aukcyjną",
	"auction.offer.bid.awarded": "Awarded",
	"auction.offer.bid.pending": "Oczekuje na zatwierdzenie",
	"auction.offer.bid.rejected": "Rejected",
	"auction.offer.bundle": "Pakiet",
	"auction.offer.clear.infos": "Usuń dane",
	"auction.offer.customer.reference": "Numer ref. klienta",
	"auction.offer.customerref.mandatory": "Nr ref. klienta jest obowiązkowy",
	"auction.offer.delivery.address.mandatory": "Delivery address is mandatory",
	"auction.offer.effective.price": "Cena efektywna",
	"auction.offer.exw.price": "cena EXW €/t",
	"auction.offer.exwprice.mandatory": "Cena Exw jest obowiązkowa",
	"auction.offer.invoicing.in": "Fakturowanie w",
	"auction.offer.lanned.loading.date": "Planowana data załadunku",
	"auction.offer.no.bids": "No bids available",
	"auction.offer.payment.condition": "Warunek dotyczący płatności",
	"auction.offer.tmode.mandatory": "Rodzaj transportu jest obowiązkowy",
	"auction.offer.transport.cost": "Koszt transportu",
	"auction.offer.transport.invoiced.conditions": "Warunki rozliczania transportu",
	"auction.offer.type.of.maritime.transport": "Rodzaj transportu morskiego",
	"auction.overview": "Podsumowanie aukcji w tym tygodniu",
	"auction.price.unit.et": "€/t",
	"auction.product.type": "Rodzaj produktu",
	"auction.selection": "Wybór aukcji",
	"auction.submit.not.authorized.internal": "Prześlij działanie nieautoryzowane w trybie symulacji lub delegowania",
	"auction.timer.days": "dni",
	"auction.timer.endsin": "Kończy się za",
	"auction.timer.hours": "godz.",
	"auction.timer.minutes": "min.",
	"auction.timer.weight.available": "Dostępny",
	"auction.transport.price": "Koszt transportu (€/t)",
	"auction.weight.unit.gross": "brutto",
	"auctions.menu": "Aukcje",
	"auctions.opened": "otwarte aukcje",
	"batch-card.all-documents": "Wszystkie dokumenty dla kręgu/paczki",
	"batch-card.batch-information": "Informacje o kręgu/paczce",
	"batch-card.batch-status": "Status kręgu/paczki",
	"batch-card.certificate-display-all": "Wyświetl wszystkie certifikat",
	"batch-card.create-call-off": "Rozpocznij nowy eCall-off",
	"batch-card.current-location": "Bieżąca lokalizacja",
	"batch-card.customer-article-reference": "Numer pozycji klienta",
	"batch-card.customer-order-number": "Numer zamówienia klienta",
	"batch-card.data-not-found": "Batch data not found",
	"batch-card.date-available-for-dispatch": "Data dostępności do wysyłki",
	"batch-card.days-in-stock": "Liczba dni w magazynie",
	"batch-card.detailed-batch-status": "Szczegółowy status kręgu/paczki",
	"batch-card.dispatch-advice-display-all": "Wyświetl wszystkie awiza",
	"batch-card.document-date": "Data",
	"batch-card.document-number": "Numer dokumentu",
	"batch-card.document-show": "Pokaż dokument",
	"batch-card.document-type": "Rodzaj",
	"batch-card.final-use": "Zastosowanie",
	"batch-card.followup": "Czynności dodatkowe",
	"batch-card.gross-weight": "Brutto",
	"batch-card.heat-number": "Numer wytopu",
	"batch-card.invoice-display-all": "Wyświetl wszystkie faktury",
	"batch-card.last-certificate": "Najnowszy certyfikat",
	"batch-card.last-dispatch-advice": "Najnowsze awizo",
	"batch-card.last-documents": "Ostatnie dokumenty",
	"batch-card.last-invoice": "Najnowsza faktura",
	"batch-card.length": "Długość (mm)",
	"batch-card.mill": "Huta",
	"batch-card.mill-order-number": "Numer zamówienia w hucie",
	"batch-card.net-weight": "Netto",
	"batch-card.package-serial-number": "Numer paczki",
	"batch-card.planned-loading-date": "Planowana data załadunku",
	"batch-card.shipments": "Wysyłki",
	"batch-card.steelgrade": "Gatunek stali",
	"batch-card.stock-alert": "Alert stanu magazynowego",
	"batch-card.supplier-order-number": "Numer zamówienia dostawcy",
	"batch-card.thickness": "Grubość (mm)",
	"batch-card.width": "Szerokość (mm)",
	"batch-list.last-seen": "Ostatnio wyświetlone kręgi/paczki",
	"batch.card": "Szczegóły kręgu/paczki",
	"batch.card.article": "Pozycja",
	"batch.card.customer": "Klient",
	"batch.card.dimensions": "Wymiary",
	"batch.card.final-use": "Zastosowanie",
	"batch.card.go-to-the-order": "Przejdź do zamówienia",
	"batch.card.information": "Informacje o kręgu/paczce",
	"batch.card.invoiced": "Zafakturowano",
	"batch.card.mill": "Huta",
	"batch.card.mill-order": "Numer zamówienia w hucie",
	"batch.card.order": "Zamówienie",
	"batch.card.weight": "Waga",
	"batch.coil-length": "Długość (mm)",
	"batch.current-location": "Bieżąca lokalizacja",
	"batch.current.location": "Bieżąca lokalizacja",
	"batch.date-for-dispatch": "Data dostępności do wysyłki",
	"batch.despatch.advice": "Awizo",
	"batch.despatch.date": "Data wysyłki",
	"batch.detailed-batch-status": "Szczegółowy status kręgu/paczki",
	"batch.ecall-status": "eCall-off status",
	"batch.from.same.invoice": "Tylko partie z faktury o numerze:",
	"batch.from.same.invoice.available": "są dostępne dla tego roszczenia",
	"batch.gross": "Brutto",
	"batch.gross-t": "Brutto (t) ",
	"batch.heat-number": "Numer wytopu",
	"batch.in-stock": "w magazynie",
	"batch.in-transit-detail": "W transporcie - szczegóły",
	"batch.invoice.date": "Data faktury",
	"batch.length": "Długość",
	"batch.net": "Netto",
	"batch.net-t": "Netto (t)",
	"batch.not.invoiced": "Partia niezafakturowana",
	"batch.not.invoiced.select.other": "Zgłoszenie reklamacji na ten materiał możliwe w późniejszym terminie.",
	"batch.not.invoiced.sorry": "Przepraszamy, wybrana partia nie została jeszcze zafakturowana",
	"batch.package-serial-number": "Numer paczki",
	"batch.planned-loading-date": "Planowana data załadunku",
	"batch.reference": "Krąg/paczka",
	"batch.requested-delivery-date": "Żądana data dostawy",
	"batch.requested-delivery-date-from": "Requested delivery date from",
	"batch.requested-delivery-date-to": "Requested delivery date to",
	"batch.shipment.date": "Data wysyłki",
	"batch.shipto": "Odbiorca",
	"batch.status": "Status kręgu/paczki",
	"batch.supplier.invoice.number": "Numer faktury",
	"batch.view.all": "Wyświetl wszystkie kręgi/paczki",
	"batch.view.all.at": "Wyświetl wszystkie kręgi/paczki w {{value}}",
	"batches.detailed.batch.status": "Szczegółowy status kręgu/paczki",
	"batches.doc": "Dok.",
	"batches.gross-t": "Brutto (t) ",
	"batches.net-t": "Netto (t)",
	"batches.number.of.day.in.stock": "Ilość dni w magazynie",
	"blocked-service-alert.plural": "Przepraszamy, te usługi są obecnie niedostępne, spróbuj ponownie później: {{services}}",
	"blocked-service-alert.refresh": "Odśwież",
	"blocked-service-alert.singular": "Przepraszamy, ta usługa jest obecnie niedostępna, spróbuj ponownie później: {{service}}",
	"browse.files": "Browse files",
	"cancel.issue": "Cancel your issue",
	"card.no.selected": "nie wybrano produktu",
	"card.prototype": "Prototyp",
	"card.prototype.lastModificationdate": "Last modification date",
	"card.prototype.production": "Produkcja",
	"card.selected": "{{value}} wybranych produktów",
	"cdd.in.date": "CDD ",
	"cdd.in.week": "CDD",
	"chart-title.M1": "Sty",
	"chart-title.M10": "Paź",
	"chart-title.M11": "Lis",
	"chart-title.M12": "Gru",
	"chart-title.M2": "Lut",
	"chart-title.M3": "Mar",
	"chart-title.M4": "Kwi",
	"chart-title.M5": "Maj",
	"chart-title.M6": "Cze",
	"chart-title.M7": "Lip",
	"chart-title.M8": "Sie",
	"chart-title.M9": "Wrz",
	"chart-title.Q1": "I kw.",
	"chart-title.Q2": "II kw.",
	"chart-title.Q3": "III kw.",
	"chart-title.Q4": "IV kw.",
	"chart-title.S1": "I semestr",
	"chart-title.S2": "II semestr",
	"check.new.offer": "Sprawdź nowe oferty",
	"choose.customer.last.used": "Ostatnio wybrane:",
	"choose.customer.restrict": "Ogranicz zakres zastosowania aplikacji SteelUser, ponieważ jest ona dedykowana klientom.",
	"choose.customer.select": "Jako użytkownik wewnętrzny musisz wybrać klienta, którego dane chcesz wyświetlić.",
	"choose.visibility.select": "Wybierz swoją widoczność spośród dostępnych opcji:",
	"claim-batch.receipt-date": "Data odbioru",
	"claim.action.plan.notif": "Jeśli to konieczne, zadzwoń do osoby kontaktowej od spraw technicznych i poproś o działanie korygujące",
	"claim.add-batch-to-this-issue": "Dodaj krąg/paczkę do reklamacji",
	"claim.add.attachment": "Dodaj załącznik",
	"claim.additional.costs.invalid": "Żądana kwota pozostałych kosztów musi być prawidłowa",
	"claim.additional.costs.mandatory": "Żądana kwota pozostałych kosztów jest wymagana",
	"claim.additional.costs.requested": "Wymagane koszty dodatkowe",
	"claim.amount.for.other.costs": "Żądana kwota pozostałych kosztów",
	"claim.amount.previous.value": "Poprzednia wartość: {{value}}",
	"claim.amount.unit.error": "Faktura w:",
	"claim.archived": "Zarchiwizowano",
	"claim.attach.several.documents": "Dołącz jeden lub kilka dokumentów",
	"claim.attachment.error": "Twoje załączniki nie zostały prawidłowo przesłane, spróbuj ponownie.",
	"claim.attachment.filename.error": "Please make sure that your filename is less than 80 characters",
	"claim.attachment.limit.zl": "Nazwa pliku powinna mieć mniej niż 80 znaków",
	"claim.attachment.limit.zr": "Podaj wszystkie istotne informacje wymagane do zatwierdzenia zgłoszonej kwoty i ilości, takie jak numery dotkniętych kręgów, waga i wszelkie inne informacje pomocnicze. Podanie kompletnych i dokładnych informacji pomoże nam szybko i sprawnie rozpatrzyć Twoją reklamację. Nazwa pliku powinna mieć mniej niż 80 znaków",
	"claim.attachment.mandatory": "Dodaj przynajmniej jeden załącznik",
	"claim.attachment.uploading.error": "Niektóre załączniki są nadal przesyłane, proszę czekać.",
	"claim.attachments": "Załączniki",
	"claim.attachments.description": "Dodaj przynajmniej jedno zdjęcie lub wideo by ułatwić przeprowadzenie procesu reklamacji",
	"claim.barcode.number": "Numer kodu kreskowego",
	"claim.batch": "Krąg/paczka",
	"claim.batch.reference.mandatory": "Numer kręgu/paczki jest wymagany",
	"claim.batch.selection": "Wybór kręgu/pqczki",
	"claim.batches": "Kręgi/paczki",
	"claim.choose.defect": "Wybierz uszkodzenie",
	"claim.claimtype.label": "Typ roszczenia",
	"claim.comment": "Komentarz",
	"claim.comment.mandatory": "Komentarz jest wymagany",
	"claim.comment.placeholder": "Wpisz krótki komentarz reklamacyjny. Proszę podać możliwie jak najwięcej szczegółów.",
	"claim.contact.type.mandatory": "Rodzaj kontaktu jest obowiązkowy",
	"claim.created": "Utworzona",
	"claim.created.by": "Utworzona przez",
	"claim.current.status": "Bieżący status",
	"claim.current.statusddot": "Bieżący status:",
	"claim.dashboard.services": "Moje usługi",
	"claim.dashboard.services.claims": "Reklamacje",
	"claim.defect": "Uszkodzenie",
	"claim.defect.mandatory": "Uszkodzenie jest obowiązkowe",
	"claim.display-pending-drafts": "oczekuje na informacje zwrotne",
	"claim.display-saved-drafts": "Szkice zapisane",
	"claim.first.batch.selection": "Wybór partii",
	"claim.full.quantity": "Łączna ilość",
	"claim.go-back-to-batch-management": "Wróć do opisu kręgu/paczki",
	"claim.guarantee.request": "WNIOSEK O NOWĄ GWARANCJĘ.",
	"claim.impacted.quantity": "Ilość reklamowana",
	"claim.impacted.quantity.mandatory": "Ilość reklamowana jest wymagana",
	"claim.impacted.quantity.minimum": "Wprowadź prawidłową ilość większą lub równą 1.",
	"claim.impacted.quantity.t": "Reklamowana ilość (t)",
	"claim.last.modification": "Ostatnia aktualizacja",
	"claim.main.batch.remove": "Usuń",
	"claim.main.batch.selected": "Wybrany krąg/paczka",
	"claim.material.costs": "Koszty materiałów",
	"claim.material.unit": "Jednostka",
	"claim.multi.batch.related.order": "Powiązane zamówienie",
	"claim.no.attachment": "Brak załącznika",
	"claim.no.reference": "Brak referencji",
	"claim.no.sample.needed": "To uszkodzenie nie wymaga próbki",
	"claim.not-existing-or-not-permission": "Reklamacja nie istnieje lub nie masz wymaganego dostępu.",
	"claim.optional": "Opcjonalne",
	"claim.other.amount.cost": "Żądana kwota pozostałych kosztów",
	"claim.paid.amount": "Kwota wypłacona",
	"claim.placeholder.reference.number": "Numer referencyjny klienta",
	"claim.quality.issue": "Reklamacja",
	"claim.quality.issue.information": "Informacje dotyczące jakości",
	"claim.quality.issue.summary": "Podsumowanie dotyczące jakości",
	"claim.quantity.limit.error": "Ilość reklamowana jest wyższa niż ilość zafakturowana.",
	"claim.quantity.previous.value": "Poprzednia wartość: {{value}}",
	"claim.quantity.tons.error": "Reklamowana ilość powinna być niższa niż 1000: tony",
	"claim.quantity.unit.error": "Faktura w:",
	"claim.raise-new-quality-issue": "Zgłoś reklamację",
	"claim.receipt.date.mandatory": "Data otrzymania jest wymagana",
	"claim.reference.number": "Numer referencyjny",
	"claim.request.type": "Typ żądania",
	"claim.requested.amount": "Żądana kwota",
	"claim.requested.material.costs": "Żądane koszty materiałów",
	"claim.sample": "Próbka zostanie wysłana do:",
	"claim.sample.agency": "Kontakt do spraw handlowych",
	"claim.sample.cts": "Kontakt do spraw technicznych",
	"claim.sample.mandatory": "Próbka jest obowiązkowa",
	"claim.sample.not": "Nie wysyłam próbki",
	"claim.sample.not.recommended": "(opcja niezalecana)",
	"claim.sample.other": "Inne",
	"claim.sample.other.comment": "Wpisz miejsce docelowe próbki",
	"claim.status.created": "Utworzona",
	"claim.total.amount": "Całkowita oszacowana kwota",
	"claim.total.requested.amount": "Całkowite roszczenie",
	"claim.total.requested.calculated": "Całkowita żądana kwota obliczona",
	"claim.total.weight": "Waga całkowita",
	"claim.type.filter.label": "Typ roszczenia",
	"claim.type.zl": "Roszczenie klienta ZL",
	"claim.type.zr": "Regularyzacja roszczenia ZR",
	"claim.visit": "Kontakt z ArcelorMittal",
	"claim.visit.text": "Chcę, aby skontaktował się ze mną przedstawiciel ArcelorMittal.",
	"claim.warning": "Ostrzeżenie",
	"claim.warning.takenintoaccount": "Uwzględniono ostrzeżenie",
	"claim.zr.attachment.info": "Zawsze wymieniaj wszystkie dotknięte partie i wszelkie dodatkowe istotne szczegóły (np. ilość na partię), aby zapewnić bezproblemową i skuteczną obsługę roszczeń.",
	"coil.calculator.additional.data": "Dodatkowe dane",
	"coil.calculator.all.other.coils": "Wszystkie pozostałe kręgi",
	"coil.calculator.density.text": "Wartość ta została ustalona na podstawie stałej gęstości wynoszącej 7,85 t/m³.",
	"coil.calculator.inner.diameter": "Średnica wewnętrzna kręgu",
	"coil.calculator.inner.diameter.label": "Średnica wewnętrzna kręgu (mm)",
	"coil.calculator.inner.diameter.mandatory": "Średnica wewnętrzna kręgu jest wymagana",
	"coil.calculator.input.parameters": "Ustawienia wejściowe",
	"coil.calculator.length": "Długość kręgu",
	"coil.calculator.length.label": "Długość kręgu (m)",
	"coil.calculator.length.mandatory": "Długość kręgu jest wymagana",
	"coil.calculator.metallic.coating.thickness.label": "Grubość powłoki metalicznej (g/㎡)",
	"coil.calculator.metallic.coating.type.label": "Typ powłoki metalicznej",
	"coil.calculator.metallic.coating.type.mandatory": "Typ powłoki metalicznej jest wymagany",
	"coil.calculator.no.result.text": "Wypełnij wszystkie pola, aby wyświetlić wyniki.",
	"coil.calculator.nominal.thickness.label": "Nominalna grubość (mm)",
	"coil.calculator.nominal.thickness.mandatory": "Nominalna grubość jest wymagana",
	"coil.calculator.organic.coated.coils": "Kręgi z powłoką organiczną",
	"coil.calculator.organic.coated.film.thickness.label": "Grubość powłoki organicznej (μm)",
	"coil.calculator.outer.diameter": "Średnica zewnętrzna kręgu",
	"coil.calculator.outer.diameter.label": "Średnica zewnętrzna kręgu (mm)",
	"coil.calculator.outer.diameter.mandatory": "Średnica zewnętrzna kręgu jest wymagana",
	"coil.calculator.outer.less.than.inner.error": "Pole mniejsze niż wewnętrzna Ø",
	"coil.calculator.product.information": "Informacje dotyczące produktu",
	"coil.calculator.result": "Wynik",
	"coil.calculator.specific.weight": "Waga właściwa",
	"coil.calculator.specific.weight.label": "Waga właściwa (kg/mm)",
	"coil.calculator.specific.weight.mandatory": "Waga właściwa jest wymagana",
	"coil.calculator.technical.feasibility.text": "Narzędzie to nie gwarantuje technicznych możliwości produkcji skalkulowanych paramentrów kręgów w poszczególnych hutach.",
	"coil.calculator.tool.text": "Kalkulator kręgów jest narzędziem pomagającym obliczyć średnicę zewnętrzną, ciężar kręgu, długość kręgu lub ciężar właściwy.",
	"coil.calculator.total.paint.thickness.label": "Całkowita grubość farby góra + dół (μm)",
	"coil.calculator.weight": "Waga kręgu",
	"coil.calculator.weight.label": "Waga kręgu (tona)",
	"coil.calculator.weight.mandatory": "Waga kręgu jest obowiązkowa",
	"coil.calculator.width.label": "Szerokość (mm)",
	"coil.calculator.width.mandatory": "Szerokość jest wymagana",
	"comment.offer.set": "Komentarz :",
	"commercial-documents-da.enduser": "Odbiorca końcowy",
	"commercial-documents-da.heat": "Wytop",
	"commercial-documents-da.serial": "Serial",
	"commercial-documents-da.supplier-article-reference": "Numer pozycji dostawcy",
	"commercial-documents.all-my-documents": "Moje dokumenty handlowe",
	"commercial-documents.amount": "Amount certified",
	"commercial-documents.batch-number": "Numer kręgu/paczki",
	"commercial-documents.batches-details": "Szczegóły kręgu/paczki",
	"commercial-documents.ce.enduser": "Odbiorca końcowy",
	"commercial-documents.ce.serial-number": "Numer",
	"commercial-documents.ce.supplier-article-reference": "Numer pozycji dostawcy",
	"commercial-documents.certificate-card": "Certifikat - szczegóły",
	"commercial-documents.certificate-date": "Data certyfikatu",
	"commercial-documents.certificate-number": "Numer certyfikatu",
	"commercial-documents.certificate-type": "Rodzaj certyfikatu",
	"commercial-documents.customer": "Klient",
	"commercial-documents.customer-article-reference": "Numer pozycji klienta",
	"commercial-documents.customer-claim-reference": "Numer reklamacji klienta",
	"commercial-documents.customer-order-number": "Numer zamówienia klienta",
	"commercial-documents.date": "Data dokumentu",
	"commercial-documents.dimensions": "Wymiary",
	"commercial-documents.discount": "Zniżka",
	"commercial-documents.dispatch-advice-date": "Data awiza",
	"commercial-documents.dispatch-advice-number": "Numer awiza",
	"commercial-documents.display-all-orders": "Wyświetl wszystkie zamówienia",
	"commercial-documents.docsWithCreationDateGtLastConnectionDate": "Dokumenty zarejestrowane od ostatniego połączenia",
	"commercial-documents.documents": "dokumenty",
	"commercial-documents.download-cart": "Ściągnij dokumenty w koszyku",
	"commercial-documents.emptyHeatNumber": "nie dotyczy",
	"commercial-documents.endQuarter": "End Quarter",
	"commercial-documents.enduser": "Odbiorca końcowy",
	"commercial-documents.final-use": "Zastosowanie",
	"commercial-documents.general-information": "Informacje ogólne",
	"commercial-documents.heat-number": "Numer wytopu",
	"commercial-documents.invoice": "Faktura",
	"commercial-documents.invoice-amount": "Kwota faktury (razem)",
	"commercial-documents.invoice-amount-without-vat": "Kwota faktury bez VAT (razem)",
	"commercial-documents.invoice-card": "Szczegóły faktury",
	"commercial-documents.invoice-currency": "Waluta faktury",
	"commercial-documents.invoice-date": "Data faktury",
	"commercial-documents.invoice-discount": "Rabat na fakturze (razem)",
	"commercial-documents.invoice-number": "Numer faktury",
	"commercial-documents.invoice-quantity": "Zafakturowana ilość",
	"commercial-documents.invoice-tax-amount": "Kwota podatku na fakturze (razem)",
	"commercial-documents.invoice-type": "Rodzaj faktury",
	"commercial-documents.invoiced-quantity": "Zafakturowana ilość",
	"commercial-documents.invoiced-quantity-unit": "Zafakturowana ilość ",
	"commercial-documents.line-status": "Line status",
	"commercial-documents.mill": "Huta",
	"commercial-documents.mill-order-number": "Numer zamówienia w hucie",
	"commercial-documents.my-commercial-documents": "Moje dokumenty handlowe",
	"commercial-documents.number": "Numer dokumentu",
	"commercial-documents.order-acknowledgement-date": "Data potwierdzenia zamówienia",
	"commercial-documents.order-acknowledgement-number": "Numer potwierdzenia zamówienia",
	"commercial-documents.order-acknowledgement-type": "Rodzaj potwierdzenia zamówienia",
	"commercial-documents.order-quantity": "Zamówiona ilość",
	"commercial-documents.order-reference": "Numer zamówienia",
	"commercial-documents.orderAcknowledgement-card": "Potwierdzenie zamówienia",
	"commercial-documents.ordered-quantity": "Zamówiona ilość",
	"commercial-documents.orders-line-details": "Szczegóły pozycji zamówienia",
	"commercial-documents.orders-number": "Numer zamówienia",
	"commercial-documents.payer": "Płatnik",
	"commercial-documents.payer-vat-number": "Nr VAT płatnika",
	"commercial-documents.payment-due-date": "Termin zapłaty",
	"commercial-documents.payment-due-to": "Płatność do",
	"commercial-documents.payment-information": "Informacje o płatności",
	"commercial-documents.plant-invoice-number": "Numer faktury huty",
	"commercial-documents.product": "Produkt",
	"commercial-documents.product-descriptions": "krąg organicznie powlekany",
	"commercial-documents.proforma": "Proforma",
	"commercial-documents.received-by-steeluser": "Odebrano przez SteelUser",
	"commercial-documents.rrp": "RRP type",
	"commercial-documents.shipto": "Odbiorca",
	"commercial-documents.soldto": "Klient",
	"commercial-documents.steel-grade": "Gatunek stali",
	"commercial-documents.subtype": "Podtyp",
	"commercial-documents.supplier-claim-reference": "Numer reklamacji producenta",
	"commercial-documents.supplier-order-number": "Numer zamówienia dostawcy",
	"commercial-documents.supplier-vat-number": "Nr VAT dostawcy",
	"commercial-documents.tax": "Podatek",
	"commercial-documents.transport-mode": "Rodzaj transportu",
	"commercial-documents.transport-reference": "Oznaczenie transportu",
	"commercial-documents.type": "Rodzaj dokumentu",
	"commercial-documents.vat": "VAT",
	"commercial-documents.vat-percentage": "Stawka procentowa VAT",
	"commercial-documents.weight": "Waga",
	"commercial-documents.without-vat": "Bez VAT-u",
	"commercial-documents.xcarbsubtype": "XCarb® sub-type",
	"confirm.continue": "Czy chcesz kontynuować?",
	"confirm.modified": "Ostatnia zmiana w dniu",
	"confirm.respectively": "odpowiednio.",
	"confirm.same.material": "Istnieje inna reklamacja dotycząca tej samej jednostki materiału odnośnie do",
	"confirm.thanks": "Dziękujemy za zapytanie.",
	"confirm.thanks.fastlane": "Dziękujemy za zapytanie.",
	"confirmation.message": "Po zatwierdzeniu krok wstecz nie będzie już możliwy",
	"contact.us": "Skontaktuj się z nami",
	"contactmail.popup.success.msg-line1": "Dziękujemy, otrzymaliśmy poprawnie Twoją wiadomość.",
	"contactmail.popup.success.msg-line2": "Wrócimy z informacją zwrotną, tak szybko jak to możliwe.",
	"contactmail.submit.attachment.error.msg": "Przepraszamy, coś jest nie tak z załącznikiem, spróbuj przesłać go ponownie.",
	"contactmail.submit.error.msg": "Przepraszamy, coś poszło nie tak w trakcicie procesu. Spróbuj ponownie później.",
	"contactmail.submit.session.error.msg": "Przepraszamy, coś poszło nie tak z sesją, spróbuj zalogować się ponownie.",
	"continue.draft": "Kontynuuj wersję roboczą",
	"corrosion.A": "Atmospheric",
	"corrosion.S": "Soil Corrosion",
	"create.new.order": "Stwórz nowe zamówienie",
	"create.new.request": "UTWÓRZ NOWE ZAPYTANIE",
	"customer.share.view": "Udostępnij widok",
	"customer.simulation": "Wybierz klienta",
	"dashboard.active.parameters": "Aktywne parametry",
	"dashboard.add-widget": "Skonfiguruj informacje",
	"dashboard.add-widget-instruction": "Wybierz informacje, które chcesz dodać",
	"dashboard.cancel": "Anuluj",
	"dashboard.card.time-in-stock": "Stan magazynowy",
	"dashboard.card.time-in-stock.time-to-call": "CZAS DO POBRANIA",
	"dashboard.card.time-in-stock.view-details": "Widok szczegółowy",
	"dashboard.claims": "Roszczenia",
	"dashboard.condition": "Warunek:",
	"dashboard.customer-material-reference": "Numer materiału klienta",
	"dashboard.customize-indicator": "Dostosuj wskaźnik",
	"dashboard.customize-information": "Dostosuj informacje",
	"dashboard.delete.confirmation-question": "Czy naprawdę chcesz skasować ten widżet?",
	"dashboard.documents-since-last-connection": "Dokumenty zarejestrowane od ostatniego połączenia",
	"dashboard.drag-customer-article-here": "Dodaj tutaj numer pozycji klienta",
	"dashboard.drag-drop-information": "Przeciągnij i upuść wartości do pola po prawej",
	"dashboard.drag-steelgrades-here": "Upuść tu gatunki stali",
	"dashboard.efeasibility": "eFeasibility",
	"dashboard.efeasibility.add.new": "Ask for a new feasibility",
	"dashboard.indicator": "Wskaźnik",
	"dashboard.information": "Informacje",
	"dashboard.key-indicator": "Kluczowy wskaźnik",
	"dashboard.key-information": "Spersonalizowane informacje",
	"dashboard.my-business-overview": "Widok ogólny",
	"dashboard.my.data": "Moje dane",
	"dashboard.order-status": "Status zamówień",
	"dashboard.orders": "Zamówienia",
	"dashboard.rts-widget.title": "Zapasy",
	"dashboard.rts-widget.tooltip": "Dostępna ilość produktu ze wszystkich magazynów gotowa do wysłania",
	"dashboard.savechanges": "Zapisz zmiany",
	"dashboard.saving": "widżety panelu są zapisywane...",
	"dashboard.schedule.business.order-status": "Status zamówień Schedule business",
	"dashboard.spot.order-status": "Status zamówień Spot",
	"dashboard.steelgrade": "Gatunek stali",
	"dashboard.validate": "Potwierdź",
	"dashboard.view.more": "Wyświetl więcej",
	"dashboard.widget-configuration": "Konfiguracja",
	"dashboard.widget-preview": "Podgląd",
	"dashboard.widget.highest-stocks": "5 najwyższych stanów magazynowych",
	"dashboard.widget.material-ready-to-ship": "Materiał gotowy do wysyłki",
	"dashboard.without-value": "Bez wartości",
	"datacenter-filter.LMD": "Modification date",
	"datacenter-filter.PO-Reception-date": "PO Reception date",
	"datacenter-filter.PO-Reception-week": "PO Reception week",
	"datacenter-filter.Proposed-Total-weight": "Proposed total weight",
	"datacenter-filter.Proposed-blank-weight": "Proposed blank weight",
	"datacenter-filter.Proposed-price": "Propozycja cenowa",
	"datacenter-filter.additional-desc": "Additional item information",
	"datacenter-filter.back-office-customer": "Klient zaplecza administracyjnego",
	"datacenter-filter.back-office-role": "Funkcja zaplecza administracyjnego",
	"datacenter-filter.batch-reference": "Numer referencyjny kręgu/pqczki",
	"datacenter-filter.batch-status": "Detailed batch status",
	"datacenter-filter.batches-not-delivered-gross": "Batches not yet delivered to final destination (Gross, t)",
	"datacenter-filter.batches-not-delivered-net": "Batches not yet delivered to final destination (net, t)",
	"datacenter-filter.bill-to": "Adres rozliczeniowy",
	"datacenter-filter.carrier-name": "Carrier name",
	"datacenter-filter.cdd": "Potwierdzony termin dostawy (tydzień)",
	"datacenter-filter.cdd-date": "Potwierdzony termin dostawy",
	"datacenter-filter.chemical-passivation": "Chemical Passivation",
	"datacenter-filter.choice": "Gatunek",
	"datacenter-filter.coating": "Specyfikacja powłoki",
	"datacenter-filter.coilAxis": "CoilAxis",
	"datacenter-filter.collate-documents": "Zestawianie dokumentów",
	"datacenter-filter.color-bottom-side": "Kolor na spodzie",
	"datacenter-filter.color-category-bottom-side": "Color Category Bottom Side",
	"datacenter-filter.color-category-top-side": "Color Category Top Side",
	"datacenter-filter.color-top-side": "Kolor górnej strony",
	"datacenter-filter.creation-date": "Data utworzenia",
	"datacenter-filter.current-location": "Bieżąca lokalizacja",
	"datacenter-filter.customer-article-reference": "Numer pozycji klienta",
	"datacenter-filter.customer-order-number": "Numer zamówienia klienta",
	"datacenter-filter.customer-order-number-without-item": "Customer order nr w/o item",
	"datacenter-filter.customer-req-name": "Customer request name",
	"datacenter-filter.customerRefusal": "Customer refusal comments",
	"datacenter-filter.data-sheet-bottom-side": "Karta informacyjna – powierzchnia spodnia",
	"datacenter-filter.data-sheet-top-side": "Karta informacyjna – powierzchnia wierzchnia",
	"datacenter-filter.date-available-for-dispatch": "Data dostępności do wysyłki",
	"datacenter-filter.delay": "Delay",
	"datacenter-filter.delivery-address": "Adres dostawy",
	"datacenter-filter.delivery-address-order": "Delivery address for order",
	"datacenter-filter.delivery-location": "Delivery location",
	"datacenter-filter.delivery-mode": "Sposób dostawy",
	"datacenter-filter.destination-address": "Destination Address",
	"datacenter-filter.destination-by-boat": "Cel podróży łodzią",
	"datacenter-filter.destination-name": "Destination Name",
	"datacenter-filter.detailed-batch-status": "Szczegółowy status kręgu/paczki",
	"datacenter-filter.dimension": "Wymiar (mm)",
	"datacenter-filter.dispatch-advice": "Awizo",
	"datacenter-filter.dispatch-advice-date": "Data awiza",
	"datacenter-filter.dispatch-advice-date-n1": "N-1 Data wysyłki",
	"datacenter-filter.dispatch-advice-date-n2": "N-2 Data wysyłki",
	"datacenter-filter.dispatch-advice-number": "Numer awiza",
	"datacenter-filter.dispatch-advice-number-n1": "N-1 Numer awiza",
	"datacenter-filter.dispatch-advice-number-n2": "N-2 Numer awiza",
	"datacenter-filter.dispatch-date": "Data wysyłki",
	"datacenter-filter.easy-film-bottom": "EasyFilm Bottom",
	"datacenter-filter.easy-film-top": "EasyFilm Top",
	"datacenter-filter.end-user": "Odbiorca końcowy",
	"datacenter-filter.final-use": "Zastosowanie",
	"datacenter-filter.first-name": "Imię",
	"datacenter-filter.form": "Forma",
	"datacenter-filter.grade": "Gatunek",
	"datacenter-filter.gross-consignment": "Przesyłka (brutto, t)",
	"datacenter-filter.gross-first-batch": "Pierwsza partia w magazynie (tydzień)",
	"datacenter-filter.gross-in-transit-details": "W tranzycie - szczegóły (brutto, t)",
	"datacenter-filter.gross-last-batch": "Ostatnia partia w magazynie (tydzień)",
	"datacenter-filter.heat-number": "Numer wytopu",
	"datacenter-filter.hts-code": "hts code",
	"datacenter-filter.incoterm2": "Incoterm 2",
	"datacenter-filter.internal-diameter": "Internal Diameter",
	"datacenter-filter.interpretation-delivery-date": "Określenie daty dostawy",
	"datacenter-filter.invalid-number": "Niepoprawny numer",
	"datacenter-filter.item-sold-to-party": "Numer pozycji klienta",
	"datacenter-filter.last-name": "Nazwisko",
	"datacenter-filter.length": "Długość (m)",
	"datacenter-filter.loading-program-number": "Loading program number",
	"datacenter-filter.material-not-avilable": "Material not available",
	"datacenter-filter.materialAvailability": "Material Availability",
	"datacenter-filter.mill": "Huta",
	"datacenter-filter.mill-order-number": "Numer zamówienia w hucie",
	"datacenter-filter.net-consignment": "Przesyłka (netto, t)",
	"datacenter-filter.net-in-transit": "W transporcie (netto, t)",
	"datacenter-filter.net-in-transit-details": "W tranzycie - szczegóły (netto, t)",
	"datacenter-filter.net-ready-to-ship": "Gotowe do wysyłki (netto, t)",
	"datacenter-filter.nominal-gloss-bottom-side": "Połysk nominalny dół",
	"datacenter-filter.nominal-gloss-top-side": "Połysk nominalny góra",
	"datacenter-filter.oil-reference": "Oil Reference",
	"datacenter-filter.order-created-by": "Zamówienie stworzone przez",
	"datacenter-filter.order-creator": "Zamówienie stworzone przez",
	"datacenter-filter.order-item-status": "Status pozycji zamówienia",
	"datacenter-filter.order-reason": "Przyczyna zamówienia",
	"datacenter-filter.organic-structure-bottom-side": "Struktura powłoki organicznej – spód",
	"datacenter-filter.organic-structure-top-side": "Struktura powłoki organicznej – wierzch",
	"datacenter-filter.organization-city": "Miejscowość",
	"datacenter-filter.organization-id": "Nr identyfikacyjny organizacji",
	"datacenter-filter.organization-name": "Nazwa organizacji",
	"datacenter-filter.organization-role": "Funkcja",
	"datacenter-filter.organization-service": "Obsługa organizacji",
	"datacenter-filter.organization-status": "Status organizacji",
	"datacenter-filter.organization-suppliers": "Dostawcy organizacji",
	"datacenter-filter.organization-type": "Rodzaj organizacji",
	"datacenter-filter.package-serial-number": "Numer paczki",
	"datacenter-filter.paint-marking-for-sh": "Paint Marking (for SH)",
	"datacenter-filter.pattern-for-sh": "Pattern (for SH)",
	"datacenter-filter.planned-shipment-date": "Planowana data załadunku",
	"datacenter-filter.ponumber": "PO Number",
	"datacenter-filter.price-unit": "Price unit",
	"datacenter-filter.produced-length-dimension": "Actual length",
	"datacenter-filter.producedDimension": "Wyprodukowany wymiar",
	"datacenter-filter.producedLength": "Wyprodukowana długość (m)",
	"datacenter-filter.producedThickness": "Wyprodukowana grubość (mm)",
	"datacenter-filter.producedWidth": "szerokość wytworzona (mm)",
	"datacenter-filter.product-category": "Kategoria produktu",
	"datacenter-filter.product-description": "krąg organicznie powlekany",
	"datacenter-filter.proposed-coating": "Proposed coating",
	"datacenter-filter.proposed-inner-diameter": "Proposed inner diameter",
	"datacenter-filter.proposed-length": "Proposed length",
	"datacenter-filter.proposed-oiling": "Proposed oiling",
	"datacenter-filter.proposed-outside-diameter": "Proposed outer diameter",
	"datacenter-filter.proposed-packing": "Proposed packaging",
	"datacenter-filter.proposed-quantity": "Proposed quantity",
	"datacenter-filter.proposed-steelgrade": "Proposed steel grade",
	"datacenter-filter.proposed-thickness": "Proposed thickness",
	"datacenter-filter.proposed-unit": "Proposed quantity unit",
	"datacenter-filter.proposed-weight": "Proposed sheet weight",
	"datacenter-filter.proposed-width": "Proposed width",
	"datacenter-filter.protection": "Zabezpieczenie",
	"datacenter-filter.proto-name": "Prototype name",
	"datacenter-filter.proto-status": "Prototype status",
	"datacenter-filter.provisional-firm-item": "Pozycja tymczasowa/stała",
	"datacenter-filter.quantity-unit": "Quantity Unit",
	"datacenter-filter.rdd": "Żądany termin dostawy (tydzień)",
	"datacenter-filter.rdd-date": "Żądany termin dostawy (tydzień)",
	"datacenter-filter.rdd-week": "RDD (week)",
	"datacenter-filter.ready-to-ship-date": "Date available for dispatch",
	"datacenter-filter.readyForDispatch": "Ready for dispatch at PO receipt (week)",
	"datacenter-filter.req-desc": "Request Description",
	"datacenter-filter.sales-quarter": "Kwartał",
	"datacenter-filter.service-level": "Poziom usług",
	"datacenter-filter.service-request": "Żądanie usługi",
	"datacenter-filter.ship-to": "Odbiorca",
	"datacenter-filter.ship-to-address": "Delivery address",
	"datacenter-filter.shipment-reference-date": "Dispatch date",
	"datacenter-filter.shipping-date": "Shipping date",
	"datacenter-filter.shipping-week": "Expected shipping week",
	"datacenter-filter.sold-to": "Klient",
	"datacenter-filter.special-stock-partner": "Stock partner",
	"datacenter-filter.spot-or-schedule": "Spot or schedule",
	"datacenter-filter.standard": "Standard",
	"datacenter-filter.standard-steel-grade": "Gatunek stali",
	"datacenter-filter.steeluser-order-number": "Nr ref. zamówienia eBusiness",
	"datacenter-filter.stockist": "Stockist",
	"datacenter-filter.supplier-rfq": "SupplierRfqNumber",
	"datacenter-filter.surface": "Powierzchnia",
	"datacenter-filter.thickness": "Grubość (mm)",
	"datacenter-filter.total-thickness-coating-bottom": "Całkowita grubość powłoki na dole (G/M2)",
	"datacenter-filter.total-thickness-coating-top": "Całkowita grubość powłoki wierzchniej (G/M2)",
	"datacenter-filter.trademark-name-bottom-side": "Nazwa znaku towarowego na dole",
	"datacenter-filter.trademark-name-top-side": "Nazwa znaku towarowego u góry",
	"datacenter-filter.transport-mode": "Rodzaj transportu",
	"datacenter-filter.transport-mode-n1": "N-1 Rodzaj transportu",
	"datacenter-filter.transport-mode-n2": "N-2 Rodzaj transportu",
	"datacenter-filter.transport-reference": "Oznaczenie transportu",
	"datacenter-filter.transport-reference-n1": "N-1 Oznaczenie transportu",
	"datacenter-filter.transport-reference-n2": "N-2 Oznaczenie transportu",
	"datacenter-filter.transportRef": "Transport reference",
	"datacenter-filter.ultrasonic-testing": "Ultrasonic Testing",
	"datacenter-filter.user-creation-date": "Data utworzenia",
	"datacenter-filter.user-email": "E-mail",
	"datacenter-filter.user-first-name": "Imię",
	"datacenter-filter.user-id": "Nr identyfikacyjny",
	"datacenter-filter.user-last-name": "Nazwisko",
	"datacenter-filter.user-organization-name": "Nazwa organizacji",
	"datacenter-filter.user-role": "Funkcja",
	"datacenter-filter.user-status": "Status",
	"datacenter-filter.users-city": "Miejscowość",
	"datacenter-filter.users-countrycode": "Kod kraju",
	"datacenter-filter.width": "Szerokość (mm)",
	"datacenter-filter.z-test-certificat": "Z-test Certificat",
	"datacenter-shipment.batch": "Krąg/paczka",
	"datacenter-shipment.customer": "Klient",
	"datacenter-shipment.customer-article-reference": "Numer pozycji klienta",
	"datacenter-shipment.customer-order-number": "Numer zamówienia klienta",
	"datacenter-shipment.date-available-for-dispatch": "Data dostępności do wysyłki",
	"datacenter-shipment.dispatch-advice-date": "Data awiza",
	"datacenter-shipment.dispatch-advice-number": "Numer awiza",
	"datacenter-shipment.grade": "Gatunek stali",
	"datacenter-shipment.gross-weight": "Brutto (t) ",
	"datacenter-shipment.mill": "Huta",
	"datacenter-shipment.net-weight": "Netto (t)",
	"datacenter-shipment.ship-to": "Odbiorca",
	"datacenter-shipment.shipment-quantity-gross": "Ilość (brutto, t)",
	"datacenter-shipment.shipment-quantity-net": "Ilość (netto, t)",
	"datacenter-shipment.supplier-order-number": "Numer zamówienia dostawcy",
	"datacenter-shipment.thickness": "Grubość (mm)",
	"datacenter-shipment.transport-mode": "Rodzaj transportu",
	"datacenter-shipment.transport-reference": "Oznaczenie transportu",
	"datacenter-shipment.width": "Szerokość (mm)",
	"datacenter.add-columns": "Dodaj kolumny",
	"datacenter.all": "Wszystkie",
	"datacenter.all-columns-added-to-grid": "Dodano do siatki wszystkie kolumny.",
	"datacenter.all-data-center": "Cała baza danych",
	"datacenter.annealed": "Wyżarzone",
	"datacenter.apply": "Zastosuj",
	"datacenter.aqdb": "eAQDB",
	"datacenter.aqdb-view": "Data center: eAQDB",
	"datacenter.at-reshipper-gross": "U spedytora (Gross, t)",
	"datacenter.at-reshipper-net": "U spedytora (Netto, t)",
	"datacenter.balanced-not-produced": "Saldo niewyprodukowanych",
	"datacenter.batch": "Kręgi/paczki",
	"datacenter.batches": "Baza danych: Kręgi/paczki",
	"datacenter.calloff": "Baza danych: eCall-off",
	"datacenter.calloff-by-batch": "eCall-off według partii",
	"datacenter.calloff-by-volume": "eCall-off wg objetości",
	"datacenter.cancel": "Anuluj",
	"datacenter.click-on-items-on-the-right": "Kliknij pozycje z prawej, aby dodać filtr",
	"datacenter.cold-rolled": "zimnowalcowany",
	"datacenter.columns": "Kolumny",
	"datacenter.commercial-documents": "Baza danych: Dokumenty handlowe",
	"datacenter.composite": "Kompozyt",
	"datacenter.create-new-view": "Utwórz nowy widok",
	"datacenter.current-layout": "Aktualny układ",
	"datacenter.customize-view": "Widok spersonalizowany",
	"datacenter.cutting-beveling": "Cięcie i fazowanie",
	"datacenter.data-center": "Baza danych",
	"datacenter.data-center-shipments": "Baza danych: Wysyłki",
	"datacenter.default": "Domyślny",
	"datacenter.delete": "Usuń",
	"datacenter.do-you-want-remove": "Czy chcesz usunąć widok?",
	"datacenter.document": "Dokumenty handlowe",
	"datacenter.documents": "dokumenty",
	"datacenter.download-invoice": "Pobierz fakturę",
	"datacenter.drag-and-drop-item-hint": "Przeciągnij i upuść pozycję, aby dodać lub usunąć kolumnę",
	"datacenter.drag-element-here-fixed": "Przeciągnij tutaj, aby dodać stałe kolumny.",
	"datacenter.drag-element-here-hide": "Przeciągnij element tutaj, aby ukryć kolumny w siatce.",
	"datacenter.drag-element-here-scrollable": "Przeciągnij tutaj, aby dodać kolumny przewijane.",
	"datacenter.edit-view": "Edytuj widok",
	"datacenter.favorite.added": "View added to favorites",
	"datacenter.favorite.max-reached": "Maximum number of favorites reached. Remove an existing favorite before adding a new one.",
	"datacenter.favorite.removed": "View removed from favorites",
	"datacenter.favorite.update-error": "Unable to update favorite status",
	"datacenter.filter.clear": "Clear",
	"datacenter.filters": "Filtry",
	"datacenter.fixed-columns": "Kolumny stałe",
	"datacenter.fixed-columns-scrollable": "Fixed columns (10 maximum)",
	"datacenter.graph.first-bar-label": "Poniżej - 30 dni",
	"datacenter.graph.fourth-bar-label": "91 i więcej",
	"datacenter.graph.second-bar-label": "31 - 60 dni",
	"datacenter.graph.third-bar-label": "61 - 90 dni",
	"datacenter.guarantee": "Baza danych: Gwarancja",
	"datacenter.handed-over-to-planning": "Przekazane do planowania",
	"datacenter.hot-rolled": "gorącowalcowany",
	"datacenter.in-transit-gross": "W transporcie (brutto, t)",
	"datacenter.in-transit-to-customer-gross": "W tranzycie do odbiorcy (brutto, t)",
	"datacenter.in-transit-to-customer-net": "W tranzycie do odbiorcy (netto, t)",
	"datacenter.land-transit-gross": "Tranzyt lądowy (Gross, t)",
	"datacenter.land-transit-net": "Tranzyt lądowy (Netto, t)",
	"datacenter.layout": "Układ",
	"datacenter.layout-sorting": "Układ i sortowanie",
	"datacenter.metallic-coated": "Powłoka metaliczna",
	"datacenter.minimal-quantity-for-this-item-is": "Minimalna ilość dla tej pozycji wynosi",
	"datacenter.name-your-new-layout": "Nadaj nazwę nowemu układowi",
	"datacenter.nb-days-in-stock": "Liczba dni w magazynie",
	"datacenter.net-qty-delivered": "Dostarczono (netto, t)",
	"datacenter.net-qty-not-delivered": "Not Delivered (Net, t)",
	"datacenter.normalizing": "Normalizacja",
	"datacenter.offer": "Oferty",
	"datacenter.offer.subcategory": "Sub category",
	"datacenter.offers": "Data center: Offer Lines",
	"datacenter.on-vessel-gross": "Na statku (Gross, t)",
	"datacenter.on-vessel-net": "Na statku (Netto, t)",
	"datacenter.open-needs": "Open Needs",
	"datacenter.or-save-as-a-new-view": "Lub zapisz jako nowy widok",
	"datacenter.order": "Zamówienia",
	"datacenter.ordered": "Zamówiono (t)",
	"datacenter.orders": "Baza danych: Zamówienia",
	"datacenter.organic-coated": "Powłoka organiczna",
	"datacenter.organization": "Organizacje",
	"datacenter.organizations": "Baza danych: Organizacje",
	"datacenter.overseas-transit-gross": "Tranzyt morski (Gross, t)",
	"datacenter.overseas-transit-net": "Tranzyt morski (Netto, t)",
	"datacenter.oxi-cutting": "Cięcie ogniowe",
	"datacenter.packing": "Opakowanie",
	"datacenter.pickled": "Wytrawione",
	"datacenter.planned-casting": "Zaplanowany zaklad odlewniczy",
	"datacenter.prematerial-ordered": "Zamówiony surowiec",
	"datacenter.prototypes": "Data center: Prototypes",
	"datacenter.qty-delivered": "Dostarczono (brutto, t)",
	"datacenter.qty-gross": "Brutto (t) ",
	"datacenter.qty-in-production": "Produkcja w toku (t)",
	"datacenter.qty-in-transit": "W transporcie (t)",
	"datacenter.qty-net": "Netto (t)",
	"datacenter.qty-not-delivered": "Nie dostarczono (brutto)",
	"datacenter.qty-ordered": "Zam. (t)",
	"datacenter.qty-ready-to-ship": "Gotowe do wysyłki (t)",
	"datacenter.quality": "Reklamacje",
	"datacenter.quality-control": "Kontrola jakości (tony)",
	"datacenter.quality-issues": "Baza danych : Reklamacje",
	"datacenter.requested-quantity-is-greater-than-the-maximum-value": "Żądana ilość jest większa niż wartość maksymalna",
	"datacenter.reset-all-filters": "Usuń wszystkie filtry",
	"datacenter.result": "1 wynik",
	"datacenter.results": "{{value}} wyników",
	"datacenter.rolling-stand": "Walcarka",
	"datacenter.rts-gross": "Gotowe do wysyłki (brutto, t)",
	"datacenter.save": "Zapisz",
	"datacenter.save-as": "Zapisz jako...",
	"datacenter.save-changes-in-the-view": "Zapisz zmiany widoku",
	"datacenter.save-new-layout-as": "Zapisz nowy układ jako...",
	"datacenter.save-new-view": "Zapisz nowy widok",
	"datacenter.save-the-view": "Zapisz widok",
	"datacenter.schedule-business-order": "zamówień Schedule business",
	"datacenter.schedule-business-orders": "Baza danych: zamówień Schedule business",
	"datacenter.scrollable-columns": "Kolumny przewijane",
	"datacenter.select-a-view": "Wybierz widok",
	"datacenter.selected": " ({{value}} wybranych)",
	"datacenter.shipment": "Wysyłki",
	"datacenter.shot-blasting": "Śrutowanie",
	"datacenter.skin-pass": "Wygładzanie",
	"datacenter.slab": "Slab",
	"datacenter.slitting": "Frezowanie",
	"datacenter.sorting": "Sortowanie",
	"datacenter.stock-blocked-gross": "Stock blocked (Gross, t)",
	"datacenter.stock-blocked-net": "Stock blocked (Net, t)",
	"datacenter.total": "Razem",
	"datacenter.users": "Baza danych: Użytkownicy",
	"datacenter.view-load-error": "Nie można pobrać widoku z bazy danych",
	"datacenter.view-name": "Nazwa widoku",
	"datacenter.view-name.duplicate.error": "A view with the name '{{viewName}}' already exists. Please choose a different name.",
	"datacenter.view-name.error": "Nazwa widoku musi być niepowtarzalna",
	"datacenter.view-not-found": "View '{{viewName}}' not found",
	"datacenter.view.add-filters": "Dodaj filtry",
	"datacenter.you-have-too-many-fixed-columns-to-add-a-new-one": "Zbyt wiele stałych kolumn, aby dodać nową",
	"datacenter.you-have-too-many-scroll-columns-to-add-a-new-one": "You have too many scrollable columns to add a new one",
	"datacenterview.Certificate": "Certyfikat",
	"datacenterview.DispatchAdvice": "Awizo",
	"datacenterview.Invoice": "Faktura",
	"datacenterview.OrderAcknowledgment": "Potwierdzenie zamówienia",
	"defect.CDCUS00A": "Wymiary",
	"defect.CDCUS00B": "Waga",
	"defect.CDCUS00C": "Rodzaj powierzchni",
	"defect.CDCUS00D": "Problem z powłoką",
	"defect.CDCUS00E": "Zgrzewy",
	"defect.CDCUS00F": "Rdza",
	"defect.CDCUS00G": "Płaskość",
	"defect.CDCUS00H": "Właściwości mechaniczne/analiza chemiczna",
	"defect.CDCUS00I": "Problemy przy przetwarzaniu materiału",
	"defect.CDCUS00J": "Opakowania",
	"defect.CDCUS00K": "Czas dostawy",
	"defect.CDCUS00L": "transport",
	"defect.CDCUS00M": "Błąd etykiety",
	"defect.Z/CDCUS00A/0600": "Wymiary",
	"defect.Z/CDCUS00B/0100": "Waga kręgu",
	"defect.Z/CDCUS00B/0200": "Dostarczona ilość (za dużo/za mało, różnica w stosunku do ilości zafakturowanej...)",
	"defect.Z/CDCUS00C/0400": "Rdza i oksydacja",
	"defect.Z/CDCUS00C/1400": "Rodzaj powierzchni",
	"defect.Z/CDCUS00D/0500": "Problem z powłoką",
	"defect.Z/CDCUS00E/0400": "Spawy",
	"defect.Z/CDCUS00F/0400": "Warstwa ochronna powierzchni (olej, folia, ...)",
	"defect.Z/CDCUS00G/0700": "Płaskość",
	"defect.Z/CDCUS00H/0600": "Jakość (właściwości mechaniczne, analiza chemiczna, …)",
	"defect.Z/CDCUS00I/0600": "Przetwarzanie",
	"defect.Z/CDCUS00J/0900": "Prezentacja (opakowanie, etykieta, zwoje, ...)",
	"defect.Z/CDCUS00K/0300": "Czas dostawy",
	"defect.Z/CDCUS00L/0100": "Błąd w transporcie (adres, środek transportu)",
	"defect.Z/CDCUS00L/0600": "Uszkodzenia podczas transportu",
	"defect.Z/CDCUS00M/0300": "Dokumentacja techniczna (Certifikat, krąg organicznie powlekany, list przewozowy...)",
	"delete.draft": "Usuń szkic",
	"delete.only-administrator": "Usunięcie tego użytkownika nie jest możliwe, ponieważ w firmie nie ma innego użytkownika.",
	"delivery-tracking.at-overseas-stock": "W magazynie zagranicznym",
	"delivery-tracking.delivery-follow-up": "Status dostaw",
	"delivery-tracking.in-land-transit": "W transporcie lądowym",
	"delivery-tracking.in-overseas-transit": "W transporcie zagranicznym",
	"delivery-tracking.in-transit-to-customer": "W transporcie do odbiorcy",
	"delivery-tracking.order-and-delivery-overview": "Zamówienia i dostawy",
	"delivery-tracking.stock-per-mill": "Stan magazynowy wg hut",
	"delivery-tracking.to-reshipper-in-land-transit-to-warehouse": "Do spedytora / W transporcie lądowym / Do magazynu",
	"delivery-tracking.total": "Razem",
	"delivery-tracking.view-details": "Widok szczegółowy",
	"delivery.status.late": "Late",
	"delivery.status.on-customer-time": "W terminie odbiorcy",
	"delivery.status.on-supplier-time": "W terminie dostawcy",
	"delivery.status.on-time": "Puktualnie",
	"dialog-upload-file": "Please upload a file",
	"dialog.all-column-added-to-grid": "All Columns added to grid",
	"dialog.apply": "Zastosuj",
	"dialog.customize.view.title": "Wybierz kolumny i przesuń je w żądane miejsce",
	"dialog.delete.description": "Czy na pewno chcesz usunąć tego użytkownika",
	"dialog.delete.title": "Usuń użytkownika",
	"dialog.drag-elements-here-hide": "Przeciągnij element tutaj, aby ukryć kolumny.",
	"dialog.drag-elements-here-scrollable": "Przeciągnij tutaj by dodaj kolumny",
	"dialog.loose-data-message": "Ta czynność spowoduje usunięcie wszystkich danych. Czy chcesz kontynuować?",
	"dialog.select.batch": "Wybierz partię",
	"doc-ce-subtype.01": "2.1: Deklaracja zgodności z zamówieniem",
	"doc-ce-subtype.02": "2.1: Declaration of compliance with the order",
	"doc-ce-subtype.17": "3.1: Świadectwo kontroli 3.1",
	"doc-ce-subtype.51": "2.2: Sprawozdanie z badań",
	"doc-ce-subtype.52": "3.2: Świadectwo kontroli 3.2",
	"doc-ce-subtype.car": "Chemical Analysis Report",
	"doc-ce-subtype.cconf": "Certyfikat zgodności",
	"doc-ce-subtype.ccpu": "Świadectwo badania",
	"doc-ce-subtype.cem": "Oznakowanie CE",
	"doc-ce-subtype.ceran": "Certyfikat badania 2.2 Chem. Analiza",
	"doc-ce-subtype.cerre": "Zaświadczenie odbioru",
	"doc-ce-subtype.cerus": "Zaświadczenie odbioru",
	"doc-ce-subtype.cinsp": "Świadectwo kontroli 3.2",
	"doc-ce-subtype.ctl": "Sprawozdanie z inspekcji",
	"doc-ce-subtype.fcp": "Karta charakterystyki produktu",
	"doc-ce-subtype.ohsas": "Raport dotyczący bezpieczeństwa",
	"doc-in-subtype.AVOIR": "Nota kredytowa",
	"doc-in-subtype.DEBIT": "Nota debetowa",
	"doc-in-subtype.FACTU": "Faktura",
	"doc-oa-subtype.N": "Zmieniona",
	"doc-oa-subtype.O": "Oryginalna",
	"doc-xcarb-subtype.a": "Green Steel Certificate",
	"doc-xcarb-subtype.b": "Recycled and renewably produced",
	"doc-xcarb-subtype.c": "EcoSheetPilePlus",
	"doc-xcarb-subtype.d": "Steel Certificate",
	"doc-xcarb-subtype.e": "Steel certificate (factor:0.7)",
	"doc-xcarb-subtype.f": "Steel certificate (factor:1.0)",
	"doc-xcarb-subtype.g": "Steel certificate Integral",
	"doc-xcarb.amount": "Amount",
	"doc-xcarb.endquarter": "End quarter",
	"doc-xcarb.rrpDownloadLink": "RRP link",
	"doc-xcarb.rrpType": "RRP type",
	"document-card.data-not-found": "Document data not found",
	"download-detailed-report": "Download detailed report",
	"download.pdf-files": "Pobierz pliki PDF",
	"draft.creationdate": "Data utworzenia",
	"draft.deleted.successfully": "Twoja wersjq robocza została usunięta",
	"draft.lastupdate": "Ostatnia aktualizacja",
	"draft.selected.product": "Wybierz produkt",
	"draft.total.tons": "Tony razem",
	"draft.value": "Wersja robocza",
	"draftoffer.list": "Lista wersji roboczych",
	"draftorder.list": "lista wstępna",
	"drafts.all.drafts": "Wszystkie wersje robocze",
	"drafts.has.been.deleted": "Usunięto wersję roboczą",
	"drafts.my.drafts": "Moje wersje robocze",
	"drafts.no.draft": "Brak wersji roboczych",
	"drafts.saved": "Zapisane wersje robocze",
	"drafts.search.drafts": "Przeszukaj wersje robocze",
	"drafts.sort.by.modification": "Sortuj wg zmian",
	"drafts.sort.by.reference": "Sortuj wg referencji",
	"drag.and.drop.files": "Przeciągnij i upuść",
	"ecall-comment-grid": "Comment",
	"ecall-off-batch-cancellation-date": "Cancelled Date",
	"ecall-off-call-creater": "eCall-off creator",
	"ecall-off-card-gross-quantity": "Gross Quantity",
	"ecall-off-card-net-quantity": "Net Quantity",
	"ecall-off-creation-date": "Creation date",
	"ecall-off-information-box": "eCall-off information",
	"ecall-off.all-batches": "Wszystkie partie",
	"ecall-off.apply-for-all": "Zastosuj do wszystkich",
	"ecall-off.batch": "partia",
	"ecall-off.batches": "partie",
	"ecall-off.call-off": "eCall-off",
	"ecall-off.call-off-by-batch": "eCall-off za paczkę",
	"ecall-off.call-off-by-volume": "eCall-off za wolumen",
	"ecall-off.call-off-date": "data eCall-off",
	"ecall-off.call-off-follow-up": "eCall-off follow-up",
	"ecall-off.call-off-header-information": "Informacje w nagłówku żądania",
	"ecall-off.call-off-request": "eCall-off request",
	"ecall-off.callable-weight": "Całkowity dostępny materiał (do)",
	"ecall-off.called-batches": "Wymagane partie",
	"ecall-off.called-order-items": "Wymagane pozycje zamówienia",
	"ecall-off.called-volume": "Wymagana ilość (do)",
	"ecall-off.canceled": "Cancelled date",
	"ecall-off.change-mills": "Zmiana hut",
	"ecall-off.choose-batches": "Wybierz partie, które są wymagane",
	"ecall-off.choose-order-items": "Wybierz pozycje zamówienia, które są wymagane",
	"ecall-off.closed-or-called": "Called",
	"ecall-off.comment_instruction": "Please fill in this field only if the eCall-off does not follow the standard process. Kindly, do not include messages such as “urgent”, “asap”, “thanks”, or similar. This field is intended only for exceptions to the normal flow.",
	"ecall-off.comment_placeholder": "This field should only be filled in if the eCall-off deviates from the standard flow and the information provided is new and not yet recorded elsewhere.",
	"ecall-off.copy-to": "Kopiuj do",
	"ecall-off.customer-call-off-reference": "Numer referencyjny żądania klienta",
	"ecall-off.do-you-really-want-to-change-mills": "Na pewno chcesz zmienić huty?",
	"ecall-off.ecall-card": "Żądanie elektroniczne",
	"ecall-off.exception": "Exception remark",
	"ecall-off.followup": "You will be able to view it in your My eCall-offs.",
	"ecall-off.information-entry": "Wprowadzenie informacji dotyczących żądania",
	"ecall-off.last-call-off-demand": "Ostatnie żądanie zapotrzebowania",
	"ecall-off.material-picking": "Zbieranie materiałów",
	"ecall-off.max": "Maks. {{value}}",
	"ecall-off.mill-section": "Wybór huty",
	"ecall-off.my-ecalls": "Żądania elektroniczne",
	"ecall-off.no-batches-found": "Nie znaleziono partii",
	"ecall-off.no-mills": "Brak hut z wymaganymi partiami",
	"ecall-off.no-selected-batches": "nie wybrano partii",
	"ecall-off.open-or-callable": "Callable",
	"ecall-off.order-items": "pozycje zamówienia",
	"ecall-off.personnalize-your-call-off-informations": "Spersonalizuj informacje dotyczące żądania",
	"ecall-off.rdd-mode": "Tryb żądanego terminu dostawy",
	"ecall-off.ready-to-call": "Twoje {{obiekty}} gotowe do wywołania",
	"ecall-off.requested-date": "Żądany termin",
	"ecall-off.requested-date-weekend-warning": "The selected requested delivery date falls on a weekend",
	"ecall-off.requested-ship-to": "Requested Ship To",
	"ecall-off.required": "wymagany",
	"ecall-off.see-card": "Zobacz kartę",
	"ecall-off.select-a-mill": "Wybierz jedną hutę, aby zobaczyć materiał gotowy do wysyłki",
	"ecall-off.select-your-mill": "Wybierz hutę",
	"ecall-off.selected": "Wybrano {{value}}",
	"ecall-off.selected-batches": "Wybrano {{value}} partii",
	"ecall-off.selected-batches-only": "Tylko wybrane partie",
	"ecall-off.selected-only": "Tylko wybrane",
	"ecall-off.selection-will-be-rest": "Wybór zostanie zresetowany",
	"ecall-off.separate-email-addresses": "Oddziel adresy e-mail za pomocą <<;>> (średnika)",
	"ecall-off.ship-to": "Ship To",
	"ecall-off.start-a-new-call-off": "START A NEW ECALL-OFF",
	"ecall-off.submit-call-off": "Prześlij żądanie",
	"ecall-off.submitted.successfully": "Your eCall-off {{value}} has been submitted successfully.",
	"ecall-off.summary": "Podsumowanie żądania",
	"ecall-off.supplier-call-off-reference": "Supplier eCall-off reference",
	"ecall-off.the": "Tony",
	"ecall-off.tons": "Tony",
	"ecall-off.total-called-weight": "Wymagana waga całkowita",
	"ecall-off.total-material-request": "Cały wymagany materiał",
	"ecall-off.type-your-comment": "Wpisz uwagę",
	"ecall-off.type-your-exception": "Type your exception remark",
	"ecall-off.unloading-reference": "Numer referencyjny rozładunku",
	"ecall-off.view-batch-card": "Wyświetl szczegóły partii",
	"ecall-off.your-batches-ready-to-call": "Twoje partie gotowe do zamówienia",
	"ecall-requested-deliverydate-from-grid": "Requested date from",
	"ecall-requested-deliverydate-to-grid": "Requested date to",
	"ecall-total-volume-called": "Total volume called",
	"ecall.batch.callCreator": "eCall-off creator",
	"ecall.exct-date-error": "You cannot choose exact date for the selected batches",
	"ecall.row.creation.date": "eCall-off creation date",
	"ecall.searchfield.extendable": "Quick search...",
	"edit.draft": "Edytuj wersje robocze",
	"efeasibility-disclaimer": "While care has been taken regarding the available information about quality or usability of our materials, it only serves as a description. All notices, advices, recommendations, calculations and, more generally, any information you have access from Steel User are given for your guidance, within the framework of a best effort undertaking, and on the basis of our experience and the state of our last knowledge. However, any industrial application/order/implementation based on such content shall have to be validated by your usual contact at ArcelorMittal Group.",
	"efeasibility-disclaimer.end": "ArcelorMittal Group accepts no responsibility or liability for any errors or information which is found to be misleading.  The use of the information contained herein is at the user’s risk and no warranty is implied or expressed by ArcelorMittal Group with respect to the use of the information.\n",
	"efeasibility.excel.file.name": "Feasibility",
	"efeasibility.excel.template": "Get excel template",
	"efeasibility.template.error": "Please upload a file which follows the template provided by SteelUser application",
	"efeasibility.template.product.category.validation": "Product category is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.product.sub.category.validation": "Product sub category is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.soldtoname.validation": "Customer name is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.standard.steelgrade.validation": "Standard steelgrade is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.steelgrade.validation": "Steelgrade is mandatory and must be one of the available values. Refer template for values.",
	"elink.add.attachment": "Dodaj załącznik",
	"elink.category": "Kategoria",
	"elink.comment": "Komentarz",
	"elink.comment-is-required": "Komentarz jest obowiązkowy",
	"elink.contact-mill": "Kontakt z hutą",
	"elink.copy-to": "Kopia do",
	"elink.data-automatically-sent-with-the-mail": "Dane automatycznie przesyłane z wiadomością",
	"elink.delete": "Usuń",
	"elink.dimension": "Wymiary (mm)",
	"elink.from": "Od",
	"elink.invalid-email-format": "Niepoprawny format adresu e-mail",
	"elink.message": "Wiadomość",
	"elink.send": "Wyślij",
	"elink.subject": "Temat",
	"email-message": "Email has been sent to confirm your new mail address",
	"end.date": "Data zakończenia",
	"eoffer-From.month": "Od miesiąca",
	"eoffer-Period.label": "Okres",
	"eoffer-Period.type": "Typ okresu",
	"eoffer-Period.type.custom": "Dla interwału niestandardowego",
	"eoffer-Period.type.month": "Dla interwału miesięcznego",
	"eoffer-Period.type.quarter": "Dla interwału kwartalnego",
	"eoffer-Period.type.semester": "Dla interwału semestralnego",
	"eoffer-Period.type.year": "Dla interwału rocznego",
	"eoffer-Quarter": "Kwartał",
	"eoffer-Semester": "Semestr",
	"eoffer-To.month": "Do miesiąca",
	"eoffer-selected.period": "Wybrany okres",
	"eoffer.Choose.the.split.of.quantities.by": "Wybierz podział ilości według",
	"eoffer.accepted": "Zaakceptowano",
	"eoffer.action.default": "Domyślne",
	"eoffer.action.delete": "Usuń",
	"eoffer.action.duplicate": "Duplikat",
	"eoffer.action.new": "Nowa",
	"eoffer.action.new.request": "Wniosek",
	"eoffer.action.new.request.for-a-new": "o nowe zamówienie",
	"eoffer.additional.fields": "Dodatkowa charakterystyka",
	"eoffer.assistant": "Kontakt handlowy (asystent)",
	"eoffer.available.fields": "Dostępne właściwości",
	"eoffer.cancel": "Anuluj",
	"eoffer.cart.finalise": "Dokończ koszyk",
	"eoffer.cart.input.request": "Wpisz zamawianą ilość, termin dostawy i pozostałe informacje",
	"eoffer.cart.volume.request": "Żądana ilość",
	"eoffer.choose.split.quantities.error": "Proszę wybrać podział ilości",
	"eoffer.choose.split.quantity.error": "Proszę wybrać podział ilości",
	"eoffer.cockpit": "Kokpit e-oferty",
	"eoffer.comment": "Komentarz",
	"eoffer.comment.product.is": "Zostaw komentarz do tego produktu",
	"eoffer.confirm.thanks": "Dziękujemy za zapytanie.",
	"eoffer.continue": "Dalej",
	"eoffer.continue.draft": "Kontynuuj wersję",
	"eoffer.create.enduser": "Odbiorca końcowy",
	"eoffer.currency": "Waluta",
	"eoffer.current.step": "Aktualny etap",
	"eoffer.customer": "Klient",
	"eoffer.datacenter.offerLines": "Data center: Offer lines",
	"eoffer.delivery.date": "Określenie daty dostawy",
	"eoffer.dialog.clear.products": "W przypadku zmiany Klienta lub Adresu dostawy lub Użytkownika końcowego produkty znajdujące się w koszyku zostaną utracone. Czy chcesz kontynuować?",
	"eoffer.dialog.month": "Miesiąc",
	"eoffer.dialog.monthweek": "Miesiąc lub tydzień ",
	"eoffer.dialog.offer.remove.product": "Czy nadal chcesz usunąć wybrany produkt?",
	"eoffer.dialog.offer.submission.error": "Błąd podczas składania oferty",
	"eoffer.dialog.pdm": "Preferowana huta",
	"eoffer.dialog.period": "Wybierz okres",
	"eoffer.dialog.quantity": "Ilość",
	"eoffer.dialog.requested.delivery.time": "Wybierz termin dostawy",
	"eoffer.dialog.reset.requested.delivery.time": "Czy nadal chcesz zmienić okres i wyzerować wnioskowane terminy dostawy?",
	"eoffer.dialog.week": "Tydzień",
	"eoffer.dialog.year": "Rok",
	"eoffer.dimension.mm": "Wymiary (mm)",
	"eoffer.draft": "Wersja robocza",
	"eoffer.draft.edit.message.line": "aby przesłać to do ArcelorMittal lub usuń.",
	"eoffer.draft.edit.message.text": "Można to później edytować na",
	"eoffer.draft.list.link": "twojej liście wstępnej.",
	"eoffer.draft.saved.successfully": "Twoje zapytanie ofertowe zostało poprawnie zapisane jako wersja robocza",
	"eoffer.drafts": "Wersje robocze",
	"eoffer.enduser": "Odbiorca końcowy",
	"eoffer.entry": "Offer entry",
	"eoffer.error.loading": "Nie można pobrać wartości parametrów",
	"eoffer.error.noenduser": "Nabywca {{value}} bez użytkownika",
	"eoffer.error.noshipto": "Nabywca {{value}} bez odbiorcy wysyłki",
	"eoffer.error.noshiptoenduser": "Nabywca {{value}} bez odbiorcy wysyłki i użytkownika",
	"eoffer.error.nosoldto": "Nie znaleziono nabywcy",
	"eoffer.feasibility": "Wykonalność",
	"eoffer.feasibility.no": "Odrzucono",
	"eoffer.feasibility.pending": "W toku",
	"eoffer.feasibility.yes": "OK",
	"eoffer.field": "Właściwość",
	"eoffer.form": "Forma",
	"eoffer.header.commercial.contacts": "INFORMACJE HANDLOWE",
	"eoffer.header.commitment.period": "Okres zobowiązania:",
	"eoffer.header.custOffNumber": "Numer oferty klienta",
	"eoffer.header.customer": "klient",
	"eoffer.header.entity.information": "Informacje o podmiotach",
	"eoffer.header.last.update.date": "Data ostatniej aktualizacji",
	"eoffer.header.offer.name": "Nazwa oferty",
	"eoffer.header.offer.validity.date": "Data ważności oferty:",
	"eoffer.header.suppOffNumber": "Numer oferty dostawcy",
	"eoffer.header.technical.contacts": "INFORMACJE TECHNICZNE",
	"eoffer.header.terms.information": "Informacje o warunkach",
	"eoffer.header.total": "Razem",
	"eoffer.home": "e-oferta",
	"eoffer.home.active": "Offers",
	"eoffer.home.cockpit": "Mój kokpit e-oferty",
	"eoffer.home.request": "Nowa",
	"eoffer.home.tool": "Zamów ofertę",
	"eoffer.idd.not.found": "Nie znaleziono parametrów do określenia terminu dostawy",
	"eoffer.in.calculation": "W trakcie obliczania",
	"eoffer.incot.not.found": "Nie znaleziono parametrów Incoterms",
	"eoffer.incoterms": "Incoterms",
	"eoffer.interpretation.delivery.date": "Określenie daty dostawy",
	"eoffer.mandatory.currency.reference": "Waluta jest obowiązkowa",
	"eoffer.mandatory.delivery.address": "Adres dostawy jest obowiązkowy",
	"eoffer.mandatory.enduser.reference": "Odbiorca końcowy jest obowiązkowy",
	"eoffer.mandatory.idd.reference": "Określenie terminu dostawy jest obowiązkowe",
	"eoffer.mandatory.incot.reference": "Incoterm jest obowiązkowy",
	"eoffer.mandatory.priceUnit.reference": "Jednostka ceny jest obowiązkowa",
	"eoffer.mandatory.quantity": "Ilość jest obowiązkowa",
	"eoffer.mandatory.requestedDeliveryTime": "Żądany termin dostawy jest obowiązkowy",
	"eoffer.mandatory.rfq.reference": "Oznaczenie zapytania o ofertę jest obowiązkowe",
	"eoffer.mandatory.soldTo.reference": "Nabywca jest obowiązkowy",
	"eoffer.mandatory.tmode.reference": "Rodzaj transportu jest obowiązkowy",
	"eoffer.merge.warning": "Niektóre produkty zostały połączone. Zostały one wykryte jako identyczne produkty.",
	"eoffer.message.offer.not.saved": "Nie można zapisać oferty",
	"eoffer.message.offer.not.submit": "Unable to submit offer",
	"eoffer.message.offer.saved": "Zapisano ofertę",
	"eoffer.mill": "Huta",
	"eoffer.mill.supplier.choice": "Wg wyboru dostawcy",
	"eoffer.minimum.quantity": "Minimum 1 quantity is required",
	"eoffer.next": "Następny",
	"eoffer.offer": "Oferta",
	"eoffer.offer.and.order": "Przegląd oferty",
	"eoffer.offer.card": "Szczegóły oferty",
	"eoffer.offer.dashboard.not.retrived": "Unable to retrieve offer dashboard data",
	"eoffer.offer.plural": "Oferty",
	"eoffer.offer.request": "Prośba o oferty",
	"eoffer.offer.terms": "Wybierz warunki zapytania ofertowego",
	"eoffer.offerLine": "Linia oferty",
	"eoffer.offerLine.plural": "Linie oferty",
	"eoffer.offers.draft": "Oferty – projekty",
	"eoffer.paymentTerms": "Warunki zapłaty",
	"eoffer.pc.label.weightDiameterMax": "Maks.",
	"eoffer.pc.label.weightDiameterMin": "Min.",
	"eoffer.pc.label.weightDiameterUnit": "Jednostka",
	"eoffer.period": "Okres",
	"eoffer.period.end": "Period (end)",
	"eoffer.period.in.month.value": "{{value}} miesiąc",
	"eoffer.period.month": "Okres (w miesiącach)",
	"eoffer.period.orderBook": "Okres do księgi historii zamówień",
	"eoffer.period.quarter.initial.letter": "Q",
	"eoffer.period.selection.needed": "Wymagany wybór",
	"eoffer.period.semester.initial.letter": "H",
	"eoffer.period.start": "Period (start)",
	"eoffer.prefered.delivery.mill": "Preferowana huta",
	"eoffer.previous": "Powrót",
	"eoffer.price": "Cena",
	"eoffer.pricing.unit": "Jednostka ceny",
	"eoffer.product": "Produkt",
	"eoffer.product.card": "Informacje o produkcie",
	"eoffer.product.family": "Grupa produktowa",
	"eoffer.product.family.infos.text": "Wybierz klienta, adres dostawy i odbiorcę końcowego, aby uzyskać dostęp do listy produktów",
	"eoffer.product.family.plural": "Grupy produktowe",
	"eoffer.product.load.content": "Nie można pobrać treści produktowej",
	"eoffer.product.not.found": "krąg organicznie powlekany niedostępny",
	"eoffer.product.plural": "Produkty",
	"eoffer.quantity": "Ilość",
	"eoffer.quantity.error": "Podaj prawidłową ilość",
	"eoffer.quantity.ton": "Ilość (tony)",
	"eoffer.quit.with.save": "Zapisz i wyjdź",
	"eoffer.quit.without.save": "Wyjdź bez zapisywania",
	"eoffer.referenceAm": "Oznaczenie AM",
	"eoffer.refresh": "Odśwież",
	"eoffer.remove.product": "Kontynuuj i usuń wybrany produkt",
	"eoffer.request.new.offer": "Request a new offer",
	"eoffer.request.new.offer.from.draft": "Zamów nową ofertę wg bieżącej",
	"eoffer.requested": "Wnioskowany",
	"eoffer.requested.delivery.time": "Żądany termin dostawy",
	"eoffer.reset.requested.delivery.time": "Kontynuuj i wyzeruj terminy dostaw",
	"eoffer.review.selections.and.submit": "Sprawdź wybór i zapisz",
	"eoffer.rfq.id": "Niepowtarzalny identyfikator zapytania to",
	"eoffer.rfq.reference": "Oznaczenie zapytania",
	"eoffer.save": "Zapisz",
	"eoffer.save.offer.draft": "Zapisz zapytanie ofertowe jako wersję roboczą",
	"eoffer.save.offer.question": "Czy nadal chcesz wyjść z kreatora bez zapisywania oferty?",
	"eoffer.searchfield.extendable": "Quick search",
	"eoffer.select.period.info": "Kliknij poniżej i wybierz okres od 1 miesiąca do 1 roku kalendarzowego",
	"eoffer.select.price": "Wybierz okres obowiązywania ceny oferty",
	"eoffer.selector": "Wybór",
	"eoffer.set.entities": "Ustaw jednostki bieżącej oferty",
	"eoffer.shipto": "Adres dostawy",
	"eoffer.simulation.shipto.enduser.error": "Błąd spowodowany wymuszeniem innego [shipto/enduser] po symulacji.",
	"eoffer.soldto": "Adres dostawy",
	"eoffer.status": "Status",
	"eoffer.status.accepted": "Zaakceptowano",
	"eoffer.status.accepted.plural": "Zaakceptowano",
	"eoffer.status.canceled": "Anulowano",
	"eoffer.status.canceled.plural": "Anulowano",
	"eoffer.status.draft": "Draft",
	"eoffer.status.draft.plural": "Projekty",
	"eoffer.status.offered": "Oferowane",
	"eoffer.status.offered.plural": "Oferowane",
	"eoffer.status.rejected": "Rejected",
	"eoffer.status.requested": "Wnioskowany",
	"eoffer.status.requested.plural": "Wnioskowany",
	"eoffer.steelGrade": "Gatunek",
	"eoffer.subcategory": "Podkategoria",
	"eoffer.submission.feedback": "Możesz śledzić stan swojego zapytania ofertowego za pośrednictwem pulpitu nawigacyjnego zapytania ofertowego",
	"eoffer.submit": "Prześlij",
	"eoffer.supplier.offer.number": "Numer oferty dostawcy",
	"eoffer.table.customer": "Klient",
	"eoffer.table.enduser": "Odbiorca końcowy",
	"eoffer.table.header.colTopSide": "Kolor górnej strony",
	"eoffer.table.header.custMatRef": "Numer pozycji klienta",
	"eoffer.table.header.custOffRef": "Customer offer number",
	"eoffer.table.header.delivery.mill": "Preferowana huta",
	"eoffer.table.header.dim": "Wymiar (mm)",
	"eoffer.table.header.dimension": "Wymiary (mm)",
	"eoffer.table.header.dimensions": "Wymiary",
	"eoffer.table.header.feasibility": "Wykonalność",
	"eoffer.table.header.last.update": "Last update date",
	"eoffer.table.header.orderCount": "Pozycje",
	"eoffer.table.header.period": "Okres",
	"eoffer.table.header.price": "Cena",
	"eoffer.table.header.qttOrdered": "Ilość",
	"eoffer.table.header.quantity": "Ilość (tony)",
	"eoffer.table.header.rfqRef": "Oznaczenie zapytania",
	"eoffer.table.header.standsteelGrade": "Norma",
	"eoffer.table.header.status": "Status",
	"eoffer.table.header.steelGrade": "Gatunek",
	"eoffer.table.item.number": "Item number",
	"eoffer.table.morw": "Miesiąc lub tydzień",
	"eoffer.table.price.unit": "Price (unit)",
	"eoffer.table.price.value": "Price (value)",
	"eoffer.table.quantity.unit": "Quantity (unit)",
	"eoffer.table.quantity.value": "Quantity (value)",
	"eoffer.table.shipto": "Odbiorca",
	"eoffer.title.my.offers": "Moje oferty",
	"eoffer.title.productlist.filter": "Wybierz produkt, o który chcesz poprosić",
	"eoffer.title.section.coilWeightInPercent": "Masa zwoju w %",
	"eoffer.title.section.dimensionUnit": "Jednostka wymiaru",
	"eoffer.title.section.length": "Długość",
	"eoffer.title.section.organicCoating": "Powłoka organiczna",
	"eoffer.tonnes": "Tony",
	"eoffer.total.quantity.for.period.draft": "Całkowita ilość w okresie",
	"eoffer.track.status": "Status zapytania o ofertę można obserwować przez",
	"eoffer.transport.mode": "Rodzaj transportu",
	"eoffer.validityDate": "Ważność",
	"eoffer.weightAndInvoicing": "Waga i faktury",
	"eoffer.wizard.cart": "Koszyk",
	"eoffer.wizard.delivery.address": "Adres dostawy",
	"eoffer.wizard.end": "Sprawdź-złóż",
	"eoffer.wizard.error.products.families": "Nie znaleziono grup produktowych",
	"eoffer.wizard.header.entity.information": "Informacje o podmiotach",
	"eoffer.wizard.header.terms.information": "Informacje o warunkach",
	"eoffer.wizard.parameters.error": "Nie można pobrać parametrów oferty",
	"eoffer.wizard.period.error": "Datę wyzerowano",
	"eoffer.wizard.period.selection.error": "Please select a date in the future and valid for the selected period",
	"eoffer.wizard.request": "Zamów ofertę",
	"eoffer.wizard.specs": "Specyfikacja produktu",
	"eoffer.wizard.step.status": "Etap {{step}} z 4",
	"eoffer.wizard.submit": "Prześlij zapytanie ofertowe",
	"eoffer.wizard.table.header.quantity": "Quantity (t)",
	"eoffer.wizard.terms": "Warunki oferty",
	"eorder.action.next": "Dalej",
	"eorder.action.save.draft": "Zapisz zamówienie jako wersję roboczą",
	"eorder.add.item.confirm.action": "Czy chcesz potwierdzić to działanie?",
	"eorder.add.item.confirm.change": "Czy chcesz potwierdzić tę zmianę?",
	"eorder.add.item.different.family.warning": "Wybrane produkty nie należą do tej samej rodziny co produkty w koszyku. Wyczyścimy koszyk przed dodaniem nowych produktów.",
	"eorder.add.item.different.form.warning": "Wybrany(-e) produkt(-y) nie ma(-ją) tej samej formy co produkt(-y) w koszyku. Wyczyścimy koszyk przed dodaniem nowych produktów.",
	"eorder.add.item.empty.customer.warning": "Pole klienta jest puste. Nie można dodać żadnego produktu do koszyka.",
	"eorder.add.item.limit.exeeds.warning": "Po dodaniu [X] elementów do koszyka zamówienie będzie zbyt duże dla bieżącego procesu (>100 elementów). Zmniejsz zawartość koszyka lub liczbę dodawanych produktów i spróbuj ponownie.",
	"eorder.add.item.success": "[X] pozycje prawidłowo dodane do koszyka",
	"eorder.confirm.message": "Potwierdź",
	"eorder.create.order.title": "Informacje o zamówieniu",
	"eorder.customer.change.warning": "Zmiana pola Klient spowoduje wyczyszczenie bieżącego koszyka. W danym zamówieniu nie można łączyć produktów pochodzących od różnych klientów.",
	"eorder.draft.deleted.successfully": "Twoja wersja robocza została usunięta",
	"eorder.draft.edit.message.text": "Będziesz mógł ją edytować w",
	"eorder.draft.last.update.date": "Data ostatniej aktualizacji",
	"eorder.draft.list.link": "Twoja lista wstępna.",
	"eorder.draft.norequest": "Brak wersji roboczej żądania",
	"eorder.draft.order-card.edit": "Edytuj tę wersję roboczą",
	"eorder.draft.order-card.no-item.text": "Brak elementu roboczego",
	"eorder.draft.order-card.placed.text": "Lista elementów projektu -",
	"eorder.draft.order-card.title": "Szczegóły zamówienia wstępnegoa",
	"eorder.draft.product.family": "Rodzina",
	"eorder.draft.product.number": "Liczba produktów",
	"eorder.draft.requested.quantity": "Żądana ilość",
	"eorder.draft.saved.successfully": "Twoja wersja robocza została zapisana.",
	"eorder.fixed-columns": "Fixed columns",
	"eorder.grid.header.view.label": "View",
	"eorder.line.select.family.product": "To add an item into cart, choose the number of copy of a product, and click on the corresponding button Add to cart",
	"eorder.mandatory.currency": "Waluta jest obowiązkowa",
	"eorder.mandatory.end.user": "Odbiorca końcowy jest obowiązkowy",
	"eorder.mandatory.idd": "Określenie daty dostawy jest obowiązkowe",
	"eorder.mandatory.pricingUnit": "Jednostka ceny jest obowiązkowa",
	"eorder.mandatory.shipTo.reference": "Odbiorca jest obowiązkowy",
	"eorder.message.order.not.saved": "Nie można zapisać zamówienia",
	"eorder.no.product.family": "No products found for the selected customer",
	"eorder.order": "Wniosek o zamówienie",
	"eorder.order.creation": "Utworzenie zamówienia",
	"eorder.orders.request": "Zapytanie o zamówienie",
	"eorder.product.color.bottom": "Colour (Bottom)",
	"eorder.product.colour.top": "Colour (Top)",
	"eorder.product.custmaterialnum": "Customer Material Number",
	"eorder.product.data.commercial.steelgrade.id": "Nr identyfikacyjny handlowego gatunku stali",
	"eorder.product.data.customer.article": "Pozycja klienta",
	"eorder.product.dimension": "Wymiary",
	"eorder.product.empty.row": "No active product linked to this template",
	"eorder.product.family.infos.title": "Wybierz klienta, adres dostawy i odbiorcę końcowego, aby uzyskać dostęp do listy produktów",
	"eorder.product.fc.products.label": "Fully configured products",
	"eorder.product.grid.note.fc": "[Y] product(s).",
	"eorder.product.grid.note.nfc": "[X] template(s) and [Y] product(s). A template is an item with empty variables to let you create a new product",
	"eorder.product.lastused": "Last used",
	"eorder.product.lastused.default": "Nigdy",
	"eorder.product.metalliccoating": "Metallic Coating",
	"eorder.product.organiccoating.datasheet.top": "Organic Coating Data Sheet (Top)",
	"eorder.product.organicdatasheet.bottom": "Organic Coating Data Sheet (Bottom)",
	"eorder.product.removablefilm": "Removable Protective Film",
	"eorder.product.steelgrade": "Steel Grade",
	"eorder.product.surfaceaspect": "Surface Aspect",
	"eorder.product.template.add.to.cart": "Add as empty product to cart",
	"eorder.product.type.fc": "Catalog product",
	"eorder.product.type.fm": "To be configured (with default values)",
	"eorder.product.type.nfc": "To be configured",
	"eorder.product.variables": "variables(s)",
	"eorder.product.variables.title": "Variables on this template:",
	"eorder.save.draft.confirmation": "Czy chcesz zapisać [X] jako wersję roboczą?",
	"eorder.save.draft.error.message": "Przepraszamy, wystąpił błąd podczas zapisywania projektu zamówienia. Proszę spróbować później lub wysłać wiadomość do swojego opiekuna klienta.",
	"eorder.save.draft.success.message": "Projekt Twojego zamówienia został poprawnie zapisany.",
	"eorder.select.product.spec": "Products list",
	"eorder.submit.error.msg.bad.data": "Nieprawidłowe dane w żądaniu.",
	"eorder.submit.error.msg.rqd.data.missing": "Brak wymaganych danych",
	"eorder.submit.order.success.follow.up.link": "STATUS ZAMÓWIENIA I DOSTAWY",
	"eorder.submit.order.success.follow.up.text": "Możesz śledzić ewolucję statusu w",
	"eorder.submit.order.success.text1": "Wniosek o zamówienie",
	"eorder.submit.order.success.text2": "został przetworzony",
	"eorder.wizard.header.customer": "Klient jest obowiązkowy",
	"eorder.wizard.header.customer-order-number": "Numer zamówienia klienta",
	"eorder.wizard.header.customer-order-number.error.invalid": "Nieprawidłowy numer zamówienia klienta",
	"eorder.wizard.header.customer-order-number.error.mandatory": "Numer zamówienia klienta jest obowiązkowy",
	"eorder.wizard.header.purchase-order-contract.error.invalid": "Nieprawidłowy numer umowy",
	"eorder.wizard.header.purchase-order-contract.error.mandatory": "Umowa zamówienia jest obowiązkowa",
	"eorder.wizard.order.currency": "Waluta",
	"eorder.wizard.order.enduser": "Odbiorca końcowy",
	"eorder.wizard.order.idd": "Określenie daty dostawy",
	"eorder.wizard.order.pricingUnit": "Jednostka ceny",
	"eorder.wizard.order.purchase.contract": "Umowa zamówienia",
	"eorder.wizard.order.shipto.name": "Adres dostawy",
	"eorder.wizard.order.soldto.name": "klient",
	"eorder.wizard.parameters.error": "Nie można pobrać parametrów zamówienia elektronicznego",
	"eorder.wizard.product.action.delete": "Usuń",
	"eorder.wizard.product.action.duplicate": "Duplikuj",
	"eorder.wizard.product.card.error": "⚠ This item is no more valid or has issues to be loaded",
	"eorder.wizard.product.itemnumber": "Numer pozycji",
	"eorder.wizard.product.modification.no.products": "Nr produktu",
	"eorder.wizard.product.modification.order.title": "Zamówienie",
	"eorder.wizard.product.modification.title.cart": "Twój koszyk",
	"eorder.wizard.product.modification.title.item": "pozycja",
	"eorder.wizard.product.modification.title.items": "pozycji",
	"eorder.wizard.product.quantity": "Ilość (t)",
	"eorder.wizard.product.rdd": "Żądany termin dostawy",
	"eorder.wizard.product.rdd.error": "Data w przeszłości",
	"eorder.wizard.product.rdd.type": "Rodzaj żądanego terminu dostawy",
	"eorder.wizard.product.service.level": "Poziom usług",
	"eorder.wizard.product.steelgrade": "Gatunek stali",
	"eorder.wizard.product.thickness": "grubość",
	"eorder.wizard.product.width": "szerokość",
	"eorder.wizard.quantity.error": "Wprowadź prawidłową ilość większą lub równą 1.",
	"eorder.wizard.stepper.step.order.information": "Szczegóły zamówienia i wybór produktu",
	"eorder.wizard.stepper.step.product.modification": "Modyfikacja produktu",
	"eorder.wizard.stepper.step.summary": "Podsumowanie zamówienia",
	"eorder.wizard.summary.header.contract.po": "Umowa (zamówienie)",
	"eorder.wizard.summary.header.currency.po": "Waluta fakturowania",
	"eorder.wizard.summary.header.order.title": "Informacje o zamówieniu",
	"eorder.wizard.summary.order.placed.text": "Zamówienie złożone - ",
	"eorder.wizard.summary.terms.conditions.text": "Klikając opcję Przejdź do zamówienia akceptujesz warunki regulaminu składania zamówień internetowych",
	"eorder.wizard.summary.total.quantity": "Całkowita ilość (t)",
	"epassivefilm.P": "E-Passivation®",
	"epassivefilm.S": "Easyfilm®",
	"error.cancelling.issue": "Error while cancelling issue",
	"error.choose.pdf.manager": "Zainstaluj w telefonie program do obsługi plików PDF",
	"error.deleting.draft": "Error while deleting draft",
	"error.file.download": "Podczas pobierania danych wystąpił błąd",
	"error.file.not.found": "Ten plik nie istnieje",
	"error.inavlid.transport.cost": "Nieprawidłowy koszt transportu",
	"error.place.atleast.one.bid": "Złóż co najmniej jedną ofertę przed zapisaniem",
	"exception-report.amlno": "AMLNo",
	"exception-report.comment-by-am": "Historical exception report Arcelormittal comment",
	"exception-report.comment-by-customer": "Historical exception report customer comment",
	"exception-report.delete": "Your exception report demand has been successfully deleted",
	"exception-report.dialog.add-comment.title": "Add a comment to finalize your exception report on order",
	"exception-report.dialog.current-status.title": "The current status of your request on order",
	"exception-report.dialog.processing": "Przetwarzanie",
	"exception-report.docNo": "Nr dokumentu",
	"exception-report.edit-request": "Edytuj komentarz",
	"exception-report.last.comment-by-am": "Exception report Arcelormittal last comment",
	"exception-report.last.comment-by-customer": "Exception report customer last comment",
	"exception-report.make-new-request": "Request exception report",
	"exception-report.order-card-header": "Specjalne żądanie",
	"exception-report.save": "Your exception report demand has been sent. You can follow your weekly request in the ORDER LIST",
	"exception-report.status": "Status komentarza",
	"exception-report.yearweek": "RokTydzień",
	"fabrication.process.H": "Tubing + HF",
	"fabrication.process.L": "Tubing + Laser",
	"fabrication.process.R": "Roll Forming",
	"fabrication.process.S": "Stamping",
	"fast.lane.entry": "Fast Lane",
	"fastlane.attachments": "Załączniki",
	"fastlane.create.details.field.currency": "Wybierz walutę",
	"fastlane.delivery.address": "Adres dostawy jest obowiązkowy!",
	"fastlane.delivery.infos.title": "Please choose the delivery address for your items in the predefined list or customize one. In case of custom destination, you will have to provide some details.",
	"fastlane.error.nosoldto": "Nie znaleziono nabywcy",
	"fastlane.file.import.button": "Import",
	"fastlane.file.import.note": "Prefill all items by using a file",
	"fastlane.file.import.progressMessage": "Import in progress.",
	"fastlane.file.import.result.label": "Result",
	"fastlane.file.import.result.text": "Please upload a file",
	"fastlane.file.import.validate": "Validate",
	"fastlane.file.template.download.note": "Use proper format for file by downloading the template by clicking here",
	"fastlane.header.customer-request-name.error.mandatory": "Request name is mandatory!",
	"fastlane.header.wizard.customer-request-name": "Request name",
	"fastlane.import.popup.text.1": "Upload an XLS file to prefill in one run all your items. Please follow the template in order to allow automatic detection.",
	"fastlane.import.popup.text.2": "If some fields are too long for text fields, they will be cut (ex: Name for an item: limit = 80 chars)",
	"fastlane.import.popup.text.3": "If some fields require a list of values and the file contains a non existing value, it will be ignored.",
	"fastlane.import.popup.text.4": "A given item must have all mandatory fields provided",
	"fastlane.import.popup.text.5": "The list of all defects will be provided at the end of the process to let you validate or retry.",
	"fastlane.import.popup.title": "Prefill all items",
	"fastlane.info.commercial.data": "Dane handlowe",
	"fastlane.info.request.details": "Request details",
	"fastlane.itemlist.coil.inner.diameter": "Średnica wewnętrzna",
	"fastlane.itemlist.coil.inner.diameter.508mm": "508 mm",
	"fastlane.itemlist.coil.inner.diameter.610mm": "610 mm",
	"fastlane.itemlist.coil.inner.diameter.NA": "N/A",
	"fastlane.itemlist.coil.inner.diameter.default": "Vertical",
	"fastlane.itemlist.coil.max_outer_diameter": "Max outer diameter",
	"fastlane.itemlist.global.quantity": "Ilość",
	"fastlane.itemlist.global.quantity.error": "Quantity is mandatory!",
	"fastlane.itemlist.global.select_unit.error": "Please select a unit",
	"fastlane.itemlist.global.unit": "Jednostka",
	"fastlane.itemlist.global.unit.error": "Jednostka jest wymagana!",
	"fastlane.itemlist.item.additional.info": "Additional item information",
	"fastlane.itemlist.navig.duplicate": "Duplikat",
	"fastlane.itemlist.navig.reset": "Resetuj",
	"fastlane.itemlist.order.thickness": "Grubość",
	"fastlane.itemlist.product.blankWeight.error.invalid": "Wartość wagi powinna być większa niż 0",
	"fastlane.itemlist.product.blank_weight": "Blank weight",
	"fastlane.itemlist.product.blank_weight.error": "The weight of one unit is mandatory!",
	"fastlane.itemlist.product.coating.error.invalid": "Powłoka powinna być większa niż 0",
	"fastlane.itemlist.product.coating.mandatory": "Coating is mandatory!",
	"fastlane.itemlist.product.coil_axis": "Coil axis",
	"fastlane.itemlist.product.coil_axis.default": "-- None --",
	"fastlane.itemlist.product.coil_axis.horizontal": "Horizontal",
	"fastlane.itemlist.product.coil_axis.vertical": "Vertical",
	"fastlane.itemlist.product.form_blank": "Form Blank",
	"fastlane.itemlist.product.item_form": "Formularz",
	"fastlane.itemlist.product.item_form.error": "Formularz jest wymagany!",
	"fastlane.itemlist.product.item_name": "Name",
	"fastlane.itemlist.product.item_name.error": "Name for the item is mandatory!",
	"fastlane.itemlist.product.item_number": "Numer pozycji",
	"fastlane.itemlist.product.length.error": "Length is mandatory!",
	"fastlane.itemlist.product.length.error.invalid": "Długość powinna być większa niż 0",
	"fastlane.itemlist.product.maxOuterDiameter.error.invalid": "Wartość Max Średnicy Zewnętrznej powinna być większa niż 0",
	"fastlane.itemlist.product.quantity.error.invalid": "Ilość powinna być większa niż 0",
	"fastlane.itemlist.product.select_form.error": "Please select a form",
	"fastlane.itemlist.product.slitting_coil": "Slitting Coil",
	"fastlane.itemlist.product.steel_grade": "Gatunek stali",
	"fastlane.itemlist.product.steel_grade.error": "Steel grade is mandatory!",
	"fastlane.itemlist.product.thickness.error": "Thickness is mandatory!",
	"fastlane.itemlist.product.thickness.error.invalid": "Grubość powinna wynosić od 0.1 do 999",
	"fastlane.itemlist.product.width.error": "Width is mandatory!",
	"fastlane.itemlist.product.width.error.invalid": "Szerokość powinna być większa niż 0",
	"fastlane.itemlist.productcharacteristic.oilquantity": "Olejowanie",
	"fastlane.itemlist.quality.calculator.coil": "Krąg",
	"fastlane.itemlist.quality.calculator.sheet": "Arkusz",
	"fastlane.itemlist.unit.blanks": "Blanks",
	"fastlane.itemlist.unit.sheets": "Arkusze",
	"fastlane.itemlist.unit.tons": "Tony",
	"fastlane.mandatory.delivery.address": "Adres dostawy jest obowiązkowy",
	"fastlane.prototype.dialog.week": "tydzień",
	"fastlane.prototype.not.found": "Not found",
	"fastlane.prototyperequest.request": "Fast Lane request",
	"fastlane.request.title": "Request information",
	"fastlane.soldto.shipto.error": "Sorry, there is an issue in your service settings, please contact SteelUser administrator",
	"fastlane.submit.error.msg": "Something went wrong. Please contact your SteelUser administrator.",
	"fastlane.submit.error.msg.mandatoryfield": "Some mandatory fields are missing.",
	"fastlane.submit.error.msg.nosoldtoshipto": "Something is wrong with your settings for this service",
	"fastlane.submit.error.msg.notoken": "Your session is expired. Please log in the application.",
	"fastlane.submit.request.error.msg.title": "Error during validation of your request",
	"fastlane.template.addinfo.validation": "Additional Information cannot exceed 255 chars ([X] detected)",
	"fastlane.template.blankweight.validation": "Blank Weight is mandatory for Form Blank and must be a valid number greater or equal to 1 with 2 digits (truncated if more). ([X] detected)",
	"fastlane.template.coating.validation": "Coating is mandatory and cannot exceed 50 chars ([X] detected)",
	"fastlane.template.coilaxis.validation": "Coil Axis is mandatory and must be one of the followed values: -- None --, Horizontal, Vertical (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.currency.validation": "Currency is mandatory and must be one of the followed values: EUR, GPB, USD (“[X]” detected). EUR will be set by default",
	"fastlane.template.deliveryaddress.validation": "Delivery address is not mandatory, but if filled in, cannot exceed 150 chars ([X] detected)",
	"fastlane.template.description.validation": "Description is mandatory and cannot exceed 255 chars ([X] detected)",
	"fastlane.template.detected.items": "[X] items detected in the file",
	"fastlane.template.form.validation": "Form is mandatory and must be one of the followed values: Coil, Sheet, Slitting Coil, Form Blank (“[X]” detected). Coil will be set by default",
	"fastlane.template.format.error": "The file should be a template provided by ArcelorMittal. We are not able to analyse it, it may be a wrong file or a corrupted one. If you have doubt on it, communicate with your AM contact by sending them the file.",
	"fastlane.template.global.data.issue": "Global data with issues",
	"fastlane.template.global.error": "Global error(s) preventing any analysis of the document",
	"fastlane.template.incoterms.validation": "Incoterms is mandatory and must be one of the followed values: -- None --, DAP, CIF, CIP, FCA, DDP (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.innerdiameter.validation": "Inner Diameter is mandatory and must be one of the followed values: N/A, 508 mm, 610 mm (“[X]” detected). “N/A” will be set by default",
	"fastlane.template.item.issue.header": "[X] items with issues",
	"fastlane.template.itemname.validation": "Item Name is mandatory and cannot exceed 80 chars ([X] detected)",
	"fastlane.template.length.validation": "Length is mandatory for Sheet and must be a valid number greater or equal to 1 with 0 digits (truncated if any). ([X] detected)",
	"fastlane.template.line": "Line",
	"fastlane.template.mill.validation": "Mill is mandatory and must be one of the valid values. (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.oiling.validation": "Oiling cannot exceed 50 chars ([X] detected)",
	"fastlane.template.outerdiameter.validation": "Max Outer Diameter must be a valid number greater or equal to 1 with 0 digits (truncated if any). ([X] detected)",
	"fastlane.template.packing.validation": "Packing cannot exceed 50 chars ([X] detected)",
	"fastlane.template.quantity.validation": "Quantity is mandatory and must be a valid positive number with max 2 or 0 digits based on unit selected (truncated if more). ([X] detected)",
	"fastlane.template.rddday.validation": "A Delivery Date has been provided in Day, but not in proper pattern (dd/mm/yyyy, ex: 02/02/2024). (“[X]” detected)",
	"fastlane.template.rddweek.validation": "A Delivery Date has been provided in Week, but not in proper pattern (Www/YYYY, ex: W01/2024). (“[X]” detected)",
	"fastlane.template.rddwnd.validation": "The day provided for Delivery Date should correspond to the week. (“[Y]” is not part of “[X]” Week)",
	"fastlane.template.request": "Request",
	"fastlane.template.requestname.validation": "Request name is mandatory and cannot exceed 120 chars ([X] detected)",
	"fastlane.template.steelgrade.validation": "Steelgrade is mandatory and cannot exceed 255 chars ([X] detected)",
	"fastlane.template.thickness.validation": "Thickness is mandatory and must be a valid positive number with max 2 digits (truncated if more). Should be less than or equal to 999. ([X] detected)",
	"fastlane.template.tmode.validation": "Transport Mode is mandatory and must be one of the followed values: -- None --, Train, Boat, Truck, Plane (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.unitbasic.validation": "Unit is mandatory and must be one of the followed values: Tons, Sheets, m², Blanks. (“[X]” detected). Default value will be set linked to Form.",
	"fastlane.template.unitform.validation": "“[X]” Quantity value is not valid for “[Y]” Form.",
	"fastlane.template.upload.confirmation.text1": "File properly imported in session.",
	"fastlane.template.upload.confirmation.text2": "Please recheck all items in session before confirming the request.",
	"fastlane.template.upload.warning.text": "You can validate this partial result or try to reupload the file by fixing issues",
	"fastlane.template.valid.items": "[X] items without any issue",
	"fastlane.template.width.validation": "Width is mandatory and must be a valid number greater or equal to 1 with 0 digits (truncated if any). ([X] detected)",
	"fastlane.template.xls.mime.type": "The file must be an Excel file. Please use the proper template provided by SteelUser application.",
	"fastlane.wizard.contact.person.mandatory": "Person of contact is mandatory!",
	"fastlane.wizard.contact.phone.number": "Phone number of this contact",
	"fastlane.wizard.currency": "Waluta",
	"fastlane.wizard.custom.destination": "Custom destination",
	"fastlane.wizard.custom.destination.contact.person": "Person of contact at custom destination",
	"fastlane.wizard.decide.later": "-- Decide Later --",
	"fastlane.wizard.delivery.address": "Predefined delivery address",
	"fastlane.wizard.header.customer": "Klient jest obowiązkowy",
	"fastlane.wizard.header.customer-request-name": "Request name",
	"fastlane.wizard.header.customer-request-name.error.invalid": "Invalid Request name",
	"fastlane.wizard.header.global.description": "Description",
	"fastlane.wizard.header.no.item.list": "No item in this request",
	"fastlane.wizard.header.request.data": "Request data",
	"fastlane.wizard.items.details.addanitem": "Add an item",
	"fastlane.wizard.items.details.datetype": "Date type",
	"fastlane.wizard.items.details.datetype.errormsg": "Typ daty jest wymagany!",
	"fastlane.wizard.items.details.datetype.rdd": "Żądana data dostawy",
	"fastlane.wizard.items.details.day": "Dzień",
	"fastlane.wizard.items.details.itemrequest": "PItem requests",
	"fastlane.wizard.items.details.sheet.weight": "Waga arkusza (w kg)",
	"fastlane.wizard.items.details.total.weight": "Masa całkowita (w tonach)",
	"fastlane.wizard.items.details.week": "Tydzień",
	"fastlane.wizard.parameters.error": "Nie można załadować parametrów fastlane",
	"fastlane.wizard.phone.number.mandatory": "Phone number is mandatory!",
	"fastlane.wizard.product.transport.desired.arcelormittal.plant": "Desired ArcelorMittal plant",
	"fastlane.wizard.product.transport.desired.arcelormittal.plant.errmsg": "Plant is mandatory!",
	"fastlane.wizard.product.transport.mode.errormsg": "Rodzaj transportu jest obowiązkowy!",
	"fastlane.wizard.shipto.name": "Adres dostawy",
	"fastlane.wizard.soldto.name": "Klient",
	"fastlane.wizard.stepper.step.items.details": "Items details",
	"fastlane.wizard.stepper.step.main.data": "Main data",
	"fastlane.wizard.stepper.step.transport.details": "Transport details",
	"fastlane.wizard.stepper.step.transport.summary": "Summary",
	"fastlane.wizard.summary.header.currency.po": "Waluta fakturowania",
	"fastlane.wizard.summary.submitBtn": "Submit your Fast Lane request",
	"fastlane.xlx.template": "XLS Template",
	"favorite-orders.title": "Moje najważniejsze zamówienia",
	"feasibility-status": "Feasibility",
	"feasibility.product-category": "Product category",
	"feasibiliy-characteristics": "Characteristics",
	"feasible-results": "Feasibility Results",
	"fields.number.error": "Thickness and width should be in number format",
	"filter.abandon": "Przerwij",
	"filter.add": "Dodaj",
	"filter.add.dimension": "Wymiary (w mm)",
	"filter.all": "Wszystkie",
	"filter.apply": "Zastosuj",
	"filter.atConsignment": "Na składzie konsygnacyjnym",
	"filter.batchid": "ID kręgu/paczki",
	"filter.bottom-color": "Kolor dolny",
	"filter.cancel": "Anuluj",
	"filter.cdd": "Potwierdzona data dostawy (CDD)",
	"filter.cddGtRdd": "CDD > RDD",
	"filter.coating": "Specyfikacja powłoki",
	"filter.confirmation.deleteall": "Czy na pewno chcesz usunąć wszystkie filtry?",
	"filter.contractNumber": "Numer kontraktu",
	"filter.criteria.applied": "Zastosowany filtr",
	"filter.criteria.no.applied": "Brak filtra",
	"filter.customerArticleReference": "Numer pozycji klienta",
	"filter.customerOrderNumber": "Numer zamówienia klienta",
	"filter.date": "Data...",
	"filter.date.from": "Od",
	"filter.date.invalid": "Data musi być prawidłowa",
	"filter.date.to": "Do",
	"filter.deleteall": "Usuń wszystkie",
	"filter.delivered": "Dostarczone",
	"filter.deliveryMode": "Sposób dostawy",
	"filter.dimension": "Wymiary",
	"filter.dimensions.length": "Długość",
	"filter.dimensions.thickness": "Grubość",
	"filter.dimensions.width": "Szerokość",
	"filter.dispatchAdviceNumber": "Numer awiza",
	"filter.dispatchDate": "Data wysyłki",
	"filter.enddate.inferior": "Ta data musi być późniejsza od poprzedniej",
	"filter.field.invalid": "Nieprawidłowa wartość",
	"filter.field.required": "To pole jest wymagane",
	"filter.filters": "Filtry",
	"filter.format.day": "Format: dzień",
	"filter.format.week": "Format: tygodzień",
	"filter.grossOrdersWithMaterial": "Zamówienia brutto z materiałem",
	"filter.inTransit": "W transporcie",
	"filter.is-not-a-number": "Wartość musi być liczbą.",
	"filter.is-not-a-positive-number": "Wartość musi być liczbą dodatnia.",
	"filter.length": "Długość (m)",
	"filter.less-than": "Mniejsze lub równe",
	"filter.mill": "Huta",
	"filter.more-than": "Większe lub równe",
	"filter.multiple-values": "Wiele wartości...",
	"filter.netOrdersWithMaterial": "Zamówienia netto z materiałem",
	"filter.no-matching-value": "Brak pasującej wartości",
	"filter.no-value": "Brak wartości",
	"filter.no.predefined": "Brak predefiniowanych",
	"filter.number.from": "Od",
	"filter.number.to": "Do",
	"filter.ok": "OK",
	"filter.operator.exact": "Dokładnie",
	"filter.operator.range": "Zakres",
	"filter.order-number.item": "Pozycja",
	"filter.order-number.reference": "Numer",
	"filter.order.item.number": "Numer pozycji",
	"filter.order.reference": "Numer zamówienia",
	"filter.orderWithCddGtRdd": "RDD < CDD",
	"filter.ordersWithMaterial": "Zamówienia z materiałem",
	"filter.placeholder.list": "Wybierz z listy",
	"filter.placeholder.suggestive.list": "Wyszukaj wartość",
	"filter.predefined": "Predefiniowane",
	"filter.readyToShip": "Gotowe do wysylki",
	"filter.reset": "Resetuj",
	"filter.schedule-business-order": "Schedule business order",
	"filter.scheduleBusinessOrdersWithMaterial": "Schedule Business Orders with material",
	"filter.shipment-section-n1": "W produkcji (WIP)",
	"filter.shipment-section-n2": "W produkcji (WIP)",
	"filter.spot-order": "Spot order",
	"filter.standardsteelgrade": "Norma",
	"filter.supplierOrderNumber": "Numer zamówienia dostawcy",
	"filter.text": "Użyj średnika (;), aby oddzielić wartości oraz gwiazdki (*) jako wieloznacznika",
	"filter.thickness": "Grubość (mm)",
	"filter.top-color": "Kolor górny",
	"filter.week.to": "Do",
	"filter.width": "Szerokość (mm)",
	"filter.workInProgress": "W produkcji (WIP)",
	"filter.x-filter-applied": "Zastosowany filtr: {{value}}",
	"filter.x-filters-applied": "Zastosowane filtry: {{value}}",
	"filter.x-selected-values": "Wybrane wartości: {{value}}",
	"filter.yes": "Tak",
	"footer.alerts": "Powiadomienia",
	"footer.home": "Strona główna",
	"footer.message": "Wiadomość",
	"footer.search": "Wyszukiwanie",
	"form.blanks": "wykrój",
	"form.coil": "Krąg / arkusz",
	"form.heavy.plate": "blachy grube",
	"form.indif.04": "Slab",
	"form.indif.06": "Coil",
	"form.indif.07": "Sheet",
	"form.indif.08": "Blanks",
	"form.indif.09": "Heavy Plate",
	"form.indif.10": "Thick Plate",
	"form.indif.12": "Slit coil",
	"form.indif.15": "Scrolled sheet",
	"form.indif.16": "Mixed Coil",
	"form.indif.17": "Welded Coil",
	"form.mixed.coil": "Mixed Coil",
	"form.scrolled.sheet": "Scrolled Sheet",
	"form.sheet": "arkusz",
	"form.slab": "Slab",
	"form.slit.coil": "Slit Coil",
	"form.thick.plate": "gruba płyta",
	"form.welded.coil": "Welded Coil",
	"full.product.catalogue": "Katalog produktów",
	"global-subcategory.BL": "Hot rolled black",
	"global-subcategory.CR": "zimnowalcowany",
	"global-subcategory.MS": "Metal studs",
	"global-subcategory.PI": "Hot rolled pickled and oiled",
	"global-subcategory.Z": "Hot dip galvanized",
	"global.action.cancelled": "Działanie anulowane",
	"global.business-type": "Business Type",
	"global.cancelled": "Anulowana",
	"global.clickhere": "Kliknij tutaj",
	"global.closed": "Zamknięta",
	"global.copyto": "Kopia do",
	"global.error": "An error occured while trying to get your list of products",
	"global.error.unexpected": "Nieoczekiwany błąd",
	"global.internal.server.error": "Wewnętrzny błąd serwera",
	"global.internal.soldto.error": "Błąd ustawień na Twoim koncie, nie możesz złożyć tego zamówienia (klient). Skontaktuj się z osobą kontaktową AM.",
	"global.message": "Wiadomość",
	"global.message-error": "Wiadomość jest obowiązkowa!",
	"global.next": "Dalej",
	"global.no": "Nie",
	"global.none": "Brak",
	"global.open": "Otwarta",
	"global.or": "LUB",
	"global.search-filter": "Global Search",
	"global.search.fastlane-entry": "FastLane",
	"global.search.fastlane-requests": "FastLane requests",
	"global.send": "Wyślij",
	"global.servicelevel": "Poziom usługi",
	"global.subject": "Temat",
	"global.subject-error-msg": "Temat jest obowiązkowy !",
	"global.submit.error.unexpected": "Wystąpił nieoczekiwany błąd podczas procesu przesyłania, spróbuj później lub skontaktuj się z osobą kontaktową AM.",
	"global.submit.service.error": "Twoje konto nie ma odpowiednich uprawnień do przesłania żądania zamówienia. Skontaktuj się z osobą kontaktową AM.",
	"global.unexpected.error.identified": "unexpected error identified",
	"global.warning": "Ostrzeżenie",
	"global.yes": "Tak",
	"guaranatee.aluminium.parts": "Aluminium na części",
	"guarantee.Others": "Inne",
	"guarantee.Poultry": "Drób",
	"guarantee.acoustic": "Ekrany akustyczne",
	"guarantee.acoustic.concrete": "Czy istnieje betonowa podstawa oddzielająca elementy pokryte powłoką Magnelis® od podłoża?",
	"guarantee.acoustic.railroad": "Ekrany akustyczne przy liniach kolejowych",
	"guarantee.acoustic.road.traffic": "Urządzenie do redukcji hałasu w ruchu drogowym / ekrany akustyczne przy drogach",
	"guarantee.activity.building": "Działanie wewnątrz budynku",
	"guarantee.activity.specify": "Określ działanie",
	"guarantee.add.parts": "Dodaj części",
	"guarantee.additional.comments": "Dodatkowe informacje lub komentarze",
	"guarantee.additional.documents": "Dodatkowe dokumenty",
	"guarantee.address": "Miejscowość / Kraj",
	"guarantee.age.material": "Wiek materiału podlegającego wymianie",
	"guarantee.agricultural": "Rolnictwo",
	"guarantee.agricultural.questions": "Pytanie dotyczące budynku rolniczego",
	"guarantee.agricultural.specify": "Proszę podać szczegóły",
	"guarantee.air.renewal": "określ szybkość wymiany powietrza (w m3/godz./zwierzę)",
	"guarantee.allocation.building": "Umieszczenie i przeznaczenie budynku",
	"guarantee.altitude.above.900m": "Powyżej 900 m",
	"guarantee.altitude.below.900m": "Poniżej 900 m",
	"guarantee.aluminium": "Aluminium",
	"guarantee.ambiance": "Atmosfera wewnątrz budynku",
	"guarantee.ammonia": "określ stężenie amoniaku w pomieszczeniu (w ppm)",
	"guarantee.animals.density": "Ilość zwierząt na m²?",
	"guarantee.animals.inside.building": "Jakie zwierzęta są trzymane w budynku?",
	"guarantee.animals.shed": "Określ liczbę zwierząt w chlewni",
	"guarantee.area": "Nazwa obszaru",
	"guarantee.atmospheric.corrosion": "Korozja atmosferyczna",
	"guarantee.attachment": "Załączony dokument",
	"guarantee.attachment.categorize.title": "Oznacz każdy dokument analizą, której dotyczy:",
	"guarantee.attachment.category.label": "Typ dokumentu",
	"guarantee.attachment.category.other": "Inne",
	"guarantee.attachment.category.soil": "Analiza gleby",
	"guarantee.attachment.category.water": "Analiza wody",
	"guarantee.attachment.column.actions": "Akcje",
	"guarantee.attachment.column.file": "Nazwa pliku",
	"guarantee.attachment.column.size": "Rozmiar",
	"guarantee.attachment.description": "Wgraj i oznacz swoje dokumenty. Każdy plik musi być oznaczony analizą, której dotyczy.",
	"guarantee.attachment.limit": "Maksymalny rozmiar pliku wynosi 115 MB.",
	"guarantee.attachment.missing.soil": "Brakuje: dokumentu do analizy gleby",
	"guarantee.attachment.missing.title": "Brakuje wymaganego dokumentu",
	"guarantee.attachment.missing.water": "Brakuje: dokumentu do analizy wody",
	"guarantee.attachment.size": "Rozmiar załącznika nie powinien przekraczać 115 MB",
	"guarantee.attachment.title": "Załączniki",
	"guarantee.attachment.uploaded.title": "Wgrane dokumenty",
	"guarantee.between.2kmand10km": "Znajduje się od 2 km do 10 km od wybrzeża",
	"guarantee.between.300mand2km": "Znajduje się od 300 m do 2 km od wybrzeża",
	"guarantee.breeding.animals": "Hodowla zwierząt",
	"guarantee.building.altitude": "Wysokość npm.",
	"guarantee.building.heated": "Czy budynek jest ogrzewany?",
	"guarantee.cancelled": "Anuluj",
	"guarantee.card.client.project.name": "Nazwa projektu klienta",
	"guarantee.card.details": "Szczegóły wniosku gwarancyjnego",
	"guarantee.card.info": "Informacje dotyczące gwarancji",
	"guarantee.card.title": "Szczegóły gwarancji - Zapytanie gwarancyjne",
	"guarantee.cattle": "Bydło",
	"guarantee.certificate.issued": "Certyfikat wystawiony",
	"guarantee.certificate.request": "Złóż wniosek o certyfikat",
	"guarantee.certificate.request.confirmation": "Czy potwierdzasz złożenie wniosku o certyfikat dla tego zapytania gwarancyjnego",
	"guarantee.certificate.request.failed": "Przepraszamy, podczas procesu wystąpił nieoczekiwany błąd. Spróbuj ponownie później.",
	"guarantee.certificate.request.success": "Wniosek o certyfikat został pomyślnie przesłany.",
	"guarantee.certificate.request.unavailable": "Ta gwarancja nie jest już dostępna do złożenia wniosku o certyfikat.",
	"guarantee.certificate.requested": "Certyfikat wnioskowany",
	"guarantee.characteristics": "Charakterystyka projektu",
	"guarantee.chimney": "Komin",
	"guarantee.choose.applicationtype": "Wybierz rodzaj gwarancji, o którą chcesz wnioskować.",
	"guarantee.cladding": "Okładzina",
	"guarantee.cladding.double.skin": "Podwójna powłoka",
	"guarantee.cladding.single.skin": "Pojedyncza powłoka",
	"guarantee.cladding.specify.material.type": "W okładzinie (określ rodzaj materiału i pokrytą powierzchnię)",
	"guarantee.client.project.name": "Nazwa projektu",
	"guarantee.coastal.marine": "W środowisku przybrzeżnym lub morskim",
	"guarantee.cold.structure": "Formowane na zimno elementy konstrukcyjne budynków (płatwie, szyny, …)",
	"guarantee.composite.floor": "Podłoga kompozytowa",
	"guarantee.concrete.foundations": "Beton na fundamenty",
	"guarantee.condensation.rink": "Czy istnieje ryzyko kondensacji wewnątrz budynku?",
	"guarantee.condition.material": "Stan materiału przeznaczonego do wymiany",
	"guarantee.construction.new.building": "Zakończenie budowy nowego budynku",
	"guarantee.construction.site": "Plac budowy",
	"guarantee.construction.site.mandatory": "Lokalizacja GPS (Szerokość i Długość geograficzna) jest obowiązkowa",
	"guarantee.contact": "(np. stal cynkowana ogniowo w sposób ciągły, stal cynkowana zanurzeniowo, drewno itp.)",
	"guarantee.contact.orther.parts": "Jakie inne materiały będą używane w kontakcie z częściami powlekanymi Magnelis®? Proszę podać, jeśli dotyczy!",
	"guarantee.contact.parts": "Jakie powłoki będą stosowane w częściach mających kontakt z częściami powlekanymi Magnelis®? Proszę podać, jeśli dotyczy!",
	"guarantee.coordinates.decimal": "Współrzędne w stopniach dziesiętnych",
	"guarantee.coordinates.dms": "Współrzędne w stopniach, minutach i sekundach",
	"guarantee.coordinates.pair.mandatory": "Proszę podać zarówno Szerokość, jak i Długość geograficzną",
	"guarantee.corporate.name.mandatory": "Pole Klienta jest obowiązkowe",
	"guarantee.current.status": "Bieżący status",
	"guarantee.customer.information": "Informacje dotyczące klienta",
	"guarantee.customer.name": "Klient",
	"guarantee.customer.rejected": "Odrzucone przez klienta",
	"guarantee.desert": "Na pustyni",
	"guarantee.designation": "Przeznaczenie",
	"guarantee.direction.of.cladding.installation": "Kierunek montażu okładziny",
	"guarantee.distance.3KM.seafront": "Jeśli odległość od morza jest mniejsza niż 3 km, należy ją podać",
	"guarantee.distance.lake": "Odległość do jeziora lub rzeki (km)",
	"guarantee.distance.less than 300m": "Znajduje się w odległości mniejszej niż 300 m od wybrzeża",
	"guarantee.distance.seafront": "Jeśli odległość od morza jest mniejsza niż 10 km, należy ją podać",
	"guarantee.distance.seafrontkm": "Jeżeli odległość od brzegu morza jest mniejsza niż 10 km, prosimy o podanie odległości.",
	"guarantee.distance.site": "Odległość od lokalizacji (km)",
	"guarantee.documents": "Dokumenty gwarancyjne",
	"guarantee.documents.title": "dokumenty",
	"guarantee.double.skin.roof": "Dach z podwójną powłoką",
	"guarantee.draft": "Wersja robocza",
	"guarantee.draft.edit": "Będziesz mógł ją edytować podczas uzupełniania wersji roboczej.",
	"guarantee.draft.saved.successfully": "Twoja wersja robocza została zapisana",
	"guarantee.duckboard": "Przez betonową kratę/płytę",
	"guarantee.duration.year": "{{value}} rok",
	"guarantee.duration.years": "{{value}} lat",
	"guarantee.duration.years.indoor": "Przewidywany czas trwania gwarancji wewnętrznej (w latach)",
	"guarantee.duration.years.outdoor": "Przewidywany czas trwania gwarancji zewnętrznej (w latach)",
	"guarantee.emission.type": "Rodzaje emisji",
	"guarantee.epassivation.type": "Rodzaj epasywacji",
	"guarantee.epc": "Inżynieria, zaopatrzenie i budownictwo (EPC)",
	"guarantee.epc.company.name": "Nazwa firmy",
	"guarantee.equipment": "Jaki sprzęt jest dostępny do odprowadzania dymu, oparów i wilgoci?",
	"guarantee.extension.existing.building": "Rozbudowa istniejącego budynku",
	"guarantee.extension.solar.plant": "Rozbudowa istniejącej elektrowni słonecznej",
	"guarantee.extractor": "Ekstraktor",
	"guarantee.fabrication": "Proces wytwarzania",
	"guarantee.fastners": "Materiały do zamocowań",
	"guarantee.fertilizer": "Przechowywanie nawozu",
	"guarantee.floating.solar.installation": "Pływające instalacje solarne",
	"guarantee.floating.solar.magnelis": "Gwarancja na pływające instalacje solarne z Magnelis®",
	"guarantee.fodder": "Przechowywanie paszy",
	"guarantee.forced": "wymuszona wentylacja",
	"guarantee.forced.ventilation": "Wymuszona wentylacja",
	"guarantee.gas.building": "Czy wewnątrz budynku wydziela się gaz lub para?",
	"guarantee.gratings": "Na kratach",
	"guarantee.ground.mounted": "Elektrownia słoneczna montowana na ziemi / o skali przemysłowej",
	"guarantee.heating.type": "Rodzaj ogrzewania",
	"guarantee.horizontal.rails": "Poziome szyny barier ochronnych",
	"guarantee.humidity.high": "Wysoki",
	"guarantee.humidity.low": "Niski",
	"guarantee.humidity.medium": "Średni",
	"guarantee.humidity.rate.inside.building": "Współczynnik wilgotności wewnątrz budynku",
	"guarantee.humidity.saturated": "Nasycony",
	"guarantee.humidity.specify": "Podaj współczynnik wilgotności",
	"guarantee.humidity.very.high": "Bardzo wysoki",
	"guarantee.hydrogen.sulphide": "określ stężenie siarkowodoru w pomieszczeniu (w ppm)",
	"guarantee.industrial": "Przemysł",
	"guarantee.industrial.questions": "Przemysłowy",
	"guarantee.industry.type": "Rodzaj przemysłu",
	"guarantee.inside-building.activity": "Please specify the activity inside the building",
	"guarantee.installation.direction.horizontal": "Poziomy",
	"guarantee.installation.direction.vertical": "Pionowy",
	"guarantee.last.modified.date": "Ostatnia aktualizacja",
	"guarantee.lat.degree": "Stopnie (0-89)",
	"guarantee.lat.degrees": "Stopnie szerokości geograficznej",
	"guarantee.lat.max": "Szerokość geograficzna (-90 do 90)",
	"guarantee.lat.minutes": "Minuty (0-59)",
	"guarantee.lat.seconds": "Sekundy (0-59,9999)",
	"guarantee.latitude": "Szrokość geograficzna",
	"guarantee.latlong.degree.pattern": "Maksymalna liczba miejsc dziesiętnych wynosi maksymalnie 6",
	"guarantee.latlongmin.max": "Minuty (0-59)",
	"guarantee.latlongsec.max": "Sekundy (0-59,9999)",
	"guarantee.latlongsec.pattern": "Maksymalna liczba miejsc po przecinku wynosi maksymalnie 4",
	"guarantee.launch.analysis": "Uruchom analizę",
	"guarantee.long.degrees": "Stopnie długości geograficznej",
	"guarantee.long.max": "Długość geograficzna (-180 do 180)",
	"guarantee.long.minutes": "Minuty (0-59)",
	"guarantee.long.seconds": "Sekundy (0-59,9999)",
	"guarantee.longdegress.max": "Stopnie (0-179)",
	"guarantee.longitude": "Długość geograficzna",
	"guarantee.magnelis": "Masa powłoki Magnelis®",
	"guarantee.magnelis.other": "Inne",
	"guarantee.magnelis.poles": "Masa powłoki Magnelis® do słupów",
	"guarantee.magnelis.upper.structure": "Masa powłoki Magnelis® do konstrukcji górnej",
	"guarantee.magnelis.zm310": "Magnelis® ZM310 - obustronna powłoka metaliczna wynosząca 310 g/m²",
	"guarantee.magnelis.zm430": "Magnelis® ZM430 - obustronna powłoka metaliczna wynosząca 430 g/m²",
	"guarantee.magnelis.zm620": "Magnelis® ZM620 - obustronna powłoka metaliczna wynosząca 620 g/m²",
	"guarantee.magnelis.zm800": "Magnelis® ZM800 - obustronna powłoka metaliczna wynosząca 800 g/m²",
	"guarantee.magnelisbuilding.long": "Magnelis® do zastosowań w budownictwie",
	"guarantee.magnelisbuilding.short": "Budynek Magnelis®",
	"guarantee.magnelisothers.long": "Magnelis® do innych zastosowań",
	"guarantee.magnelisothers.short": "Magnelis® Inne",
	"guarantee.magnelissolar.long": "Magnelis® do zastosowania w instalacjach fotowoltaicznych",
	"guarantee.magnelissolar.short": "Magnelis® Fotowoltaika",
	"guarantee.manure.management": "Gospodarka obornikiem w budynkach ze zwierzętami",
	"guarantee.mineral.wool.insulation": "Wełna mineralna",
	"guarantee.mounting.system.producer": "Producent systemów montażowych",
	"guarantee.msp.company.name": "Nazwa firmy",
	"guarantee.name.copy": "kopiuj",
	"guarantee.name.unique.error": "Wystąpił nieoczekiwany błąd podczas procesu ({{errordetails}})",
	"guarantee.name.unique.reason.duplicate": "unikalność nazwy",
	"guarantee.name.unique.reason.network": "nie można uzyskać dostępu do serwera",
	"guarantee.natural.ventilation": "Naturalna wentylacja",
	"guarantee.nature.content": "Charkter i zawartość wnętrza",
	"guarantee.nature.material": "Rodzaj materiału, który ma zostać wymieniony",
	"guarantee.new.solar.plant": "Zakończenie budowy nowej elektrowni słonecznej",
	"guarantee.no.duckboard": "Brak podestu",
	"guarantee.no.parts.magnelis": "Brak elementów z powłoką Magnelis®",
	"guarantee.notypes.available": "Brak dostępnego rodzaju gwarancji",
	"guarantee.open.building": "Otwarty budynek",
	"guarantee.open.building.specify": "Podaj",
	"guarantee.organiccoating.long": "Stale z powłoką organiczną do zastosowań w budownictwie",
	"guarantee.other": "Inne zastosowania",
	"guarantee.other.application": "Podaj zastosowanie",
	"guarantee.other.building": "Inne (np. biuro, opieka zdrowotna, hotel, sport i rekreacja, parking…)",
	"guarantee.other.coatings": "Stal powlekana innymi powłokami",
	"guarantee.other.materials": "Inne materiały stosowane w bezpośrednim kontakcie z Magnelis®",
	"guarantee.other.materials.used": "Inne użyte materiały",
	"guarantee.others.animals": "inne",
	"guarantee.others.please.specify": "Określ",
	"guarantee.part.corrosion": "Rodzaj korozji",
	"guarantee.part.magnelis": "Masa powłoki Magnelis® (g/m2)",
	"guarantee.parts.magnelis": "Elementy z powłoką Magnelis®",
	"guarantee.pdf.page": "Strona",
	"guarantee.per.app": "W jakim zastosowaniu będzie wykorzystywana blacha perforowana?",
	"guarantee.per.rich": "Określ schemat perforowania",
	"guarantee.perforated.sheet": "Blacha perforowana",
	"guarantee.pigs": "Świnie",
	"guarantee.pir.insulation": "PIR",
	"guarantee.planned.operations": "Zaplanowane działania",
	"guarantee.poles.magnelis": "Gwarancja na słupy wykonane z Magnelis® umieszczone w gruncie",
	"guarantee.poles.soil": "Projekty ze słupami umieszczonymi w gruncie",
	"guarantee.power.generation": "Wytwarzanie energii",
	"guarantee.presence.animals": "Obecność zwierząt wewnątrz budynku",
	"guarantee.prevailing.wind": "Czy wyrzuty gazu, dymu lub pyłu są przenoszone przez wiatr?",
	"guarantee.project.characteristics": "Charakterystyka projektu",
	"guarantee.project.environment": "Środowisko projektu",
	"guarantee.project.for.floating.solar": "Projekt dla pływających instalacji solarnych",
	"guarantee.project.location": "Lokalizacja projektu",
	"guarantee.project.name": "Nazwa projektu",
	"guarantee.project.name.mandatory": "Nazwa projektu jest obowiązkowa",
	"guarantee.project.size": "Wielkość projektu",
	"guarantee.project.type": "Rodzaj projektu",
	"guarantee.proposal.ongoing": "Propozycja w toku",
	"guarantee.proposals": "Oferta i dokumenty dodatkowe",
	"guarantee.proximity.buildings": "W pobliżu budynków, w których znajdują się zwierzęta lub przechowywane są produkty fermentacji",
	"guarantee.pu.insulation": "PU",
	"guarantee.purpose.building": "Określ przeznaczenie budynku",
	"guarantee.questions": "Pytania dotyczące budynków przemysłowych i rolniczych",
	"guarantee.radio.na": "NA",
	"guarantee.radio.no": "Nie",
	"guarantee.radio.yes": "Tak",
	"guarantee.rainwater.systems": "Systemy odprowadzania wody deszczowej / rynny",
	"guarantee.reason": "Powód",
	"guarantee.refineries.factories": "Obejmuje głównie rafinerie, spalarnie, elektrownie węglowe lub olejowe, przemysł gorzelniczy, cementownie, fabryki papieru, zakłady chemiczne...",
	"guarantee.register": "Produkt - wniosek gwarancyjny",
	"guarantee.register.magnelisbuilding": "Produkt - wniosek o gwarancję - Magnelis® do zastosowania w budownictwie",
	"guarantee.register.magnelisothers": "Produkt - wniosek o gwarancję - Magnelis® do innych zastosowań",
	"guarantee.register.magnelissolar": "Produkt - wniosek o gwarancję - Magnelis® do zastosowania w instalacjach fotowoltaicznych",
	"guarantee.relative.humidity": "Proszę podać wilgotność względną",
	"guarantee.remarks": "Podaj inne uwagi lub szczegóły dotyczące Twojego projektu:",
	"guarantee.request.author": "Autor",
	"guarantee.request.certificate.id": "Certyfikat",
	"guarantee.request.date": "Data",
	"guarantee.request.drafts": "Zapytanie gwarancyjne - lista robocza",
	"guarantee.request.duplicate": "Duplikuj",
	"guarantee.request.followup": "Będzie można to zobaczyć w sekcji Zapytania gwarancyjne.",
	"guarantee.request.id": "Nr ID. gwarancji",
	"guarantee.request.list": "Zapytania gwarancyjne",
	"guarantee.request.requested.date": "Żądany termin",
	"guarantee.request.submitted.successfully": "Twoje zapytanie gwarancyjne zostało pomyślnie przesłane.",
	"guarantee.request.type": "Rodzaj",
	"guarantee.requested": "Zażądano gwarancji",
	"guarantee.requested.type.indoor": "Wewnątrz",
	"guarantee.requested.type.indoor.label": "Żądana gwarancja wewnętrzna",
	"guarantee.requested.type.outdoor": "Na zewnątrz",
	"guarantee.requested.type.outdoor.label": "Żądana gwarancja zewnętrzna",
	"guarantee.residential": "Do celów mieszkalnych",
	"guarantee.retrofitting.existing.building": "Modernizacja/remont istniejącego budynku",
	"guarantee.retrofitting.solar.plant": "Modernizacja/remont istniejącej elektrowni słonecznej",
	"guarantee.road.restraint": "Systemy bezpieczeństwa ruchu drogowego",
	"guarantee.roofing": "Pokrycia dachowe",
	"guarantee.roofing-cladding.anti-condensation.felt": "Filc antykondensacyjny",
	"guarantee.roofing-cladding.color": "Kolor",
	"guarantee.roofing-cladding.desired.back.coat": "Żądana powłoka tylna",
	"guarantee.roofing-cladding.desired.coating": "Żądana powłoka",
	"guarantee.roofing-cladding.external.skin": "Powłoka zewnętrzna",
	"guarantee.roofing-cladding.insulation": "Izolacja",
	"guarantee.roofing-cladding.internal.skin": "Powłoka wewnętrzna",
	"guarantee.roofing-cladding.made.with.product": "Pokrycia dachowe i/lub okładziny wykonane w całości przy użyciu produktu",
	"guarantee.roofing-cladding.metallic.coating.weight": "Waga powłoki metalicznej",
	"guarantee.roofing-cladding.overlapping": "Nakładanie się",
	"guarantee.roofing-cladding.perforation": "Perforacja",
	"guarantee.roofing-cladding.pv.solar.roof": "Dach z fotowoltaiką / z solarami",
	"guarantee.roofing-cladding.substrate.thickness": "Grubość wsadu",
	"guarantee.roofing-cladding.surface": "Powierzchnia",
	"guarantee.roofing.decking.roof": "Dach tarasowy",
	"guarantee.roofing.roofslope": "Nachylenie dachu (%)",
	"guarantee.roofing.specify.material.type": "W pokryciach dachowych (określ rodzaj materiału i pokrytą powierzchnię)",
	"guarantee.rooftop.installation": "Instalacja dachowa",
	"guarantee.rrs.miscellaneous": "Różne części systemów bezpieczeństwa ruchu drogowego narażone na korozję atmosferyczną",
	"guarantee.rrs.poles": "Słupy do systemów bezpieczeństwa ruchu drogowego",
	"guarantee.rrs.welded": "Czy elementy, które będą wykonane z Magnelis®, są spawane?",
	"guarantee.rural.area": "Na terenach wiejskich ponad 10 km od wybrzeża",
	"guarantee.rural.area.20KM": "Na terenach wiejskich ponad 20 km od wybrzeża",
	"guarantee.sandwich.panel": "Panele warstwowe lub system zabudowy",
	"guarantee.satisfied": "Spełniono",
	"guarantee.save.failed": "Nie udało się przesłać gwarancji.",
	"guarantee.save.failed.message": "Spróbuj ponownie później lub skontaktuj się z ebusiness.support@arcelormittal.com",
	"guarantee.service.requests": "Moje wnioski gwarancyjne",
	"guarantee.sheet.thickness": "Grubość blachy (mm)",
	"guarantee.silo": "Silos",
	"guarantee.silo.cylinder": "Cylinder silosu",
	"guarantee.silo.liner": "Czy silos będzie miał wykładzinę?",
	"guarantee.silo.parts": "Które elementy silosu zostaną wykonane z Magnelis®?",
	"guarantee.silo.products": "Jakie produkty będą przechowywane w silosie?",
	"guarantee.silo.roof": "Dach silosu",
	"guarantee.silo.soil": "Podstawa silosu, która ma kontakt z gruntem lub betonem",
	"guarantee.single.skin.roof": "Pokrycie dachowe jednowarstwowe",
	"guarantee.soil.analysis": "Czy dostępna jest pełna analiza gleby?",
	"guarantee.soil.document": "Jeśli dostępna jest analiza gleby, dołącz dokument:",
	"guarantee.soil.information": "Analiza gleby powinna zawierać co najmniej następujące informacje: skład granulometryczny, odczyn pH, wilgotność, zawartość chlorków, siarczanów, siarczków, rezystywność, obecność wód gruntowych. Przydatne będą wszelkie inne informacje o glebie dotyczące poziomu korozyjności, zgodnie z normą DIN 50929-3:2018.",
	"guarantee.soil.requirements.title": "Wymagania dotyczące analizy gleby",
	"guarantee.specific.environment": "W określonym środowisku (kombinacja powyższego narażenia i pewnych dodatkowych efektów, wysoka temperatura, wysoka wilgotność, znaczne osady pyłu itp.)",
	"guarantee.specify": "Podaj proszę:",
	"guarantee.specify.perforation.scheme": "Określ schemat perforacji",
	"guarantee.stainless.steel": "Stal nierdzewna",
	"guarantee.steel.parts": "Stal nierdzewna na części",
	"guarantee.storage.chemicals": "Obecność i/lub stosowanie i/lub przechowywanie produktów chemicznych",
	"guarantee.storage.fermentation": "Obecność i/lub przechowywanie produktów fermentacji",
	"guarantee.structure": "Konstrukcja wykonana w całości z Magnelis®",
	"guarantee.suggested.coating.mass": "Masa powłoki sugerowana przez firmę ArcelorMittal na podstawie oczekiwanego okresu gwarancji",
	"guarantee.summary": "Podsumowanie",
	"guarantee.supplier.rejected": "Odrzucone przez dostawcę",
	"guarantee.surface.building": "Do zastosowania w budynkach: powierzchnia (m²):",
	"guarantee.tonnage.magnelis": "Tonaż stali powlekanej Magnelis®",
	"guarantee.type": "Rodzaj gwarancji",
	"guarantee.type.application": "Rodzaj zastosowania",
	"guarantee.type.of.installation": "Rodzaj instalacji",
	"guarantee.types.of.guarantee": "Rodzaj gwarancji",
	"guarantee.unknown": "Unknown",
	"guarantee.upper.structure": "Gwarancja na górną konstrukcję wykonaną z Magnelis®",
	"guarantee.urban.agglomeration": "W aglomeracji miejskiej i/lub środowisku przemysłowym",
	"guarantee.use.of.other.materials": "Zastosowanie innych materiałów, zwłaszcza cementu, pustaków",
	"guarantee.ventilation.roof": "naturalna wentylacja poprzez żaluzje w dachu",
	"guarantee.ventilation.walls": "naturalna wentylacja poprzez żaluzje w ścianach",
	"guarantee.wall.facade": "Ściana / Fasada",
	"guarantee.water.analysis": "Czy dostępna jest analiza wody?",
	"guarantee.water.document": "Prosimy o przesłanie analizy wody wraz ze zgłoszeniem gwarancyjnym",
	"guarantee.water.information": "Analiza wody powinna zawierać co najmniej następujące informacje: Zawartość chlorków, zawartość siarczanów, zawartość wapnia, zawartość magnezu, zasadowość Ks4,3, wartość pH, struktura/potencjał wody UH, przewodność. Przydatne będą wszelkie inne informacje o wodzie, które są zgodne z normą DIN 50929-3:2018.",
	"guarantee.water.requirements.title": "Wymagania dotyczące analizy wody",
	"guarantee.with.partial.momentary.wetting": "Z częściowym lub chwilowym zwilżeniem wodą morską i/lub bezpośrednim działaniem rozprysku morskiego",
	"guarantee.without.direct.wetting": "Nienarażone na bezpośrednie działanie wody morskiej i/lub mokrego powietrza morskiego",
	"guarantee.without.gratings": "Bez krat",
	"guarantee.zinc": "Stal powlekana cynkiem",
	"gurantee.duration.years": "Przewidywany czas trwania gwarancji (w latach)",
	"gurantee.other.coating.mass": "Inna masa powlekająca",
	"help.data.documents": "Dokumenty",
	"help.documents": "Documenty pomocnicze",
	"highest.stocks.widget.title": "5 najwyższych stanów magazynowych",
	"home.batch-list": "Moje kręgi/paczki",
	"home.customer.feedback": "Komentarz klienta",
	"home.dashboard": "Panel sterowania",
	"home.deliveryschedule": "Harmonogram dostaw",
	"home.diplay.last.batches": "Wyświetl ostatnich 20 przeglądanych kręgów/paczek",
	"home.identify.batch": "Zidentyfikuj krąg/paczkę",
	"home.last.seen.batch": "Ostatnio wyświetlone kręgi/paczki",
	"home.no.service": "Profil użytkownika nie pozwala zarządzać usługami. Skontaktuj się z przedstawiecielem ArcelorMittal, aby uzyskać pełen dostęp do usługi aplikacji.",
	"home.no.service.alert": "Brak usług",
	"home.order-tracking.commercial-documents": "Moje dokumenty handlowe",
	"home.order-tracking.my-schedule-business-order": "My schedule business order",
	"home.order-tracking.orders": "Moje zamówienia",
	"home.ordertracking": "Śledzenie zamówień",
	"home.quality-issues.issues": "Moje reklamacje",
	"import.data": "Import data",
	"import.excel": "Import excel",
	"import.file.message": "Upload an XLS file to import data from existing file. Please follow the template in order to allow automatic detection.",
	"import.file.message.all.fields.mandatory": "All the fields are mandatory.",
	"incoterm.22": "CFR dostarczono cło niezapłacone",
	"incoterm.23": "CFR warunki liniowe nieopłacone cło",
	"incoterm.24": "CFR wyładunek cło nieopłacone",
	"incoterm.25": "CIF dostarczono cło niezapłacone",
	"incoterm.26": "CIF warunki liniowe nieopłacone cło",
	"incoterm.27": "CIF wyładunek",
	"incoterm.28": "CFR sous palan",
	"incoterm.33": "CFR FO Quick custom desp",
	"incoterm.CFR": "CFR (Cost and Freight)",
	"incoterm.CIF": "CIF (Cost, Insurance, Freight)",
	"incoterm.CIP": "CIP (Carriage and insurance paid to)",
	"incoterm.CPT": "CPT (Carriage paid to)",
	"incoterm.DAF": "Delivered at frontier",
	"incoterm.DAT": "DPU (Delivered at Place Unloaded)",
	"incoterm.DDP": "DDP (Delivered duty paid)",
	"incoterm.DDU": "Delivered duty unpaid",
	"incoterm.DEQ": "Carriage paid to quay",
	"incoterm.DES": "Delivered ex ship",
	"incoterm.FAS": "FAS (Free alongside ship)",
	"incoterm.MAD": "Dostępny w fabryce",
	"incoterm.RC": "Łącznie z transportem do siedziby klienta",
	"incoterm.dap": "DAP (Delivered at place)",
	"incoterm.exw": "Ex works",
	"incoterm.fca": "FCA (Free carrier)",
	"incoterm.fob": "FOB (Free on board)",
	"inner.greater.than.outer.error": "Pole większe od zewnętrznego Ø.",
	"internal.placeholder.choose.customer": "Wprowadź nazwę klienta",
	"issue.acceptedquantity": "Zaakceptowana ilość",
	"issue.acceptedquantity.value": "Potwierdzona ilość (wartość)",
	"issue.action.data.center": "Baza danych",
	"issue.action.filters": "Filtry",
	"issue.attach.documents": "Dodaj załącznik",
	"issue.batch.cdd": "Potwierdzony termin dostawy",
	"issue.batch.commercial.documents": "Dokumenty handlowe",
	"issue.batch.customer.order.number": "Numer zamówienia klienta",
	"issue.batch.dimension": "Wymiary (mm)",
	"issue.batch.invoiced": "Invoiced",
	"issue.batch.no.result": "Brak wyników",
	"issue.batch.number": "Numer kręgu/paczki",
	"issue.batch.quick.search": "Szybkie wyszukiwanie",
	"issue.batch.status": "Status",
	"issue.batch.steelgrade": "Gatunek stali",
	"issue.batch.view-details": "Widok szczegółowy",
	"issue.batchesassociated": "Reklamowane kręgi/paczki",
	"issue.calimed.quantity": "Reklamowana ilość",
	"issue.calimed.quantity.value": "Reklamowana ilość (wartość)",
	"issue.cancel": "Your claim has been cancelled successfully",
	"issue.claim": "Reklamacja",
	"issue.closingdate": "Data zamknięcia",
	"issue.contact.info": "Dane kontaktowe",
	"issue.contact.label": "Chcę, aby skontaktowała się ze mną osoba z ArcelorMittal.",
	"issue.contact.type": "Rodzaj kontaktu",
	"issue.creditnote": "Nota uznaniowa",
	"issue.creditnotedate": "Data noty uznaniowej",
	"issue.currency": "Waluta",
	"issue.customer.defect": "Wada",
	"issue.customer.reference": "Numer referencyjny reklamacji klienta",
	"issue.decision": "Decyzja",
	"issue.defect.type": "Rodzaj uszkodzenia",
	"issue.do.you.want.to.be.contacted": "Czy chcesz, abyśmy się z Tobą skontaktowali?",
	"issue.draft": "Wersja robocza",
	"issue.draft.deleted": "Twoja wersja robocza została pomyślnie usunięta",
	"issue.drag.and.drop.files": "Przeciągnij i upuść pliki tutaj",
	"issue.filterbystatus": "Filtruj wg statusu",
	"issue.followup.widget.title": "Reklamacje",
	"issue.inprocess": "W toku",
	"issue.invoiced.batch": "Invoiced batches only",
	"issue.issuecard": "Szczegóły reklamacji ",
	"issue.issuedocuments": "dokumenty",
	"issue.issueinformation": "Informacje o reklamacji",
	"issue.ok.value": "OK",
	"issue.origin": "Pochodzenie",
	"issue.origin.ach": "System zgłaszania reklamacji ArcelorMittal",
	"issue.origin.sta": "SteelUser",
	"issue.pending": "Oczekuje na zatwierdzenie",
	"issue.qualityfeedback": "Reklamacje",
	"issue.qualityissues": "Reklamacje",
	"issue.qualityissues.drafts": "Reklamacje - zapisane wersje robocze",
	"issue.register": "Zgłoś problem dotyczący jakości",
	"issue.requested.total.amount": "Kwota całkowita zamówienia",
	"issue.requested.total.amount.value": "Kwota całkowita zamówienia (wartość)",
	"issue.save.as.drafts": "Zapisz jako wersję roboczą",
	"issue.select.batches.action.next": "Dalej",
	"issue.select.current.batch": "Wybrana obecnie przez Ciebie parta:",
	"issue.select.first.batch": "Wybierz pierwszą partię w celu zgłoszenia reklamacji",
	"issue.select.other.batch": "Lub wybierz inną partię",
	"issue.send.claim": "Wyślij",
	"issue.sending.sample": "Wysyłanie próbki",
	"issue.shipments": "Wysyłki",
	"issue.submit.quality.feedback": "Prześlij reklamację",
	"issue.supplierdefect": "Wada wg. dostawcy",
	"issue.supplierissuenumber": "Numer reklamacji w ArcelorMittal",
	"issue.total.amount.accepted": "Zaakceptowana kwota całkowita",
	"issue.total.amount.accepted.value": "Zaakceptowana kwota całkowita (wartość)",
	"issue.type.of.request": "Rodzaj żądania",
	"issue.unit": "Jednostka",
	"issue.widget.overviewofqi": "Reklamacje",
	"issue.widget.selector.feedbackselected": "Wybrano: Informacje o reklamacjach",
	"issue.widget.selector.validateadvice": "Kliknij by potwierdzić wybór",
	"label.calculation": "Uzyskaj obliczenie",
	"label.coil.calculator": "Kalkulator kręgów  ",
	"last.guarantee.requests": "Ostatnie zapytania gwarancyjne",
	"latitude.N": "N",
	"latitude.S": "S",
	"legal-document.needforsteel.sales.framework": "Ramy sprzedaży ArcelorMittal Need4Steel®",
	"legal-documents.agree.to.sales.conditions": "Prosimy o wyrażenie zgody na nasze",
	"legal-documents.and": "oraz",
	"legal-documents.confirm.cart.with.sales.conditions": "Potwierdzając koszyk, użytkownik wyraża zgodę na nasze",
	"legal-documents.general.sales.conditions": "ogólne warunki sprzedaży",
	"legal-documents.non.prime.sales.framework": "warunki sprzedaży materiałów non-prime",
	"legal.data.header": "Zasady, warunki i regulaminy",
	"line.select.family.period": "Wybierz okres wyszukiwania",
	"line.select.family.product": "Wybierz rodzaj wyszukiwanego produktu ",
	"line.select.period.fiveyears": "5 lata",
	"line.select.period.oneyear": "rok",
	"line.select.period.sixmonths": "6 miesięcy",
	"line.select.period.threemonths": "3 miesiące",
	"line.select.period.twoyear": "2 lata",
	"line.select.tab.layout": "Choose your tab layout",
	"linked.soldto": "Powiązane z sold-to",
	"loader.text": "Products are loading",
	"longitude.E": "E",
	"longitude.W": "W",
	"manage.services.add-services": "Dodaj usługi",
	"manage.services.drag-and-drop-items-on-the-right": "Przeciągnij i upuść elementy z prawej strony, aby dodać usługę",
	"manual.data.customer": "Numer zamówienia klienta",
	"manual.data.enter.reference": "Wpisz numer zamówienia",
	"manual.data.not.found": "Nie znaleziono kręgu",
	"manual.data.num": "Pozycja",
	"manual.data.reference": "Numer",
	"manual.data.supplier": "Numer zamówienia dostawcy",
	"manual.data.supplier.or.customer": "Wpisz numer zamówienia dostawcy lub klienta",
	"materials.rts.widget.title": "Materiał gotowy do wysyłki",
	"menu.closed.issues": "Zamknięte problemy jakościowe",
	"menu.declare.choose.customer": "Wybierz klienta",
	"menu.declare.order-tracking": "Śledzenie zamówień internetowych",
	"menu.declare.order-tracking.deliveryschedule": "Harmonogram dostaw",
	"menu.declare.order-tracking.ordertracking": "Śledzenie zamówień",
	"menu.declare.quality.issue": "Zgłoś problem jakościowy",
	"menu.drafts": "Projekty",
	"menu.logout": "Wyloguj się",
	"menu.modify.quality.issue": "Zmodyfikuj problem jakościowy",
	"menu.order-services": "Usługi w ramach zamówienia",
	"menu.pending.issues": "Reklamacje nierozpatrzone",
	"menu.product-services": "Usługi związane z produktem",
	"menu.profile": "Profil",
	"menu.sales-services": "Obsługa sprzedaży",
	"menu.settings": "Ustawienia",
	"menu.sign.in": "Zaloguj się",
	"modification.error.message": "Twoje zmiany nie zostaną zachowane",
	"n4steel.contact-add-attachment": "Dodaj załącznik",
	"n4steel.contact-attachment-help": "Przeciągnij i zostaw tutaj swoje pliki",
	"n4steel.contact-mail": "Kontakt ArcelorMittal Need4Steel®",
	"n4steel.contact-mail-from": "Od",
	"n4steel.contact-mail-invalid-email": "Nieprawidłowy format adresu e-mail",
	"n4steel.contact-mail-mill": "Huta",
	"n4steel.contact-mail-offer": "Dotyczy oferty",
	"n4steel.contact-mail-prefill-data": "Dane zostaną wysłane automatycznie wraz z e-mailem",
	"n4steel.upload.file.size.error.message": "Max 10MB per file and max 3 files.",
	"navig.confirm": "Potwierdź",
	"need4steel-logistic-routes.errormsg": "Max coil weight or Packing not compatible due to selected delivery address.",
	"need4steel-logistic-routes.packaging.errormsg": "Packaging is not compatible with delivery address.",
	"need4steel-order.history.errormsg": "No historical order from your ArcelorMittal Need4Steel® orderbook is matching the current offer options",
	"need4steel-order.history.import": "Import",
	"need4steel-order.history.notfound": "No order found",
	"need4steel-order.history.subtitle": "Please select products to import",
	"need4steel-order.history.title": "Order History",
	"need4steel-product-details-tooltip.no-price-msg": "Dane produktu nie są dostępne",
	"need4steel-product-details-tooltip.price-msg": "Wyświetl dane produktu",
	"need4steel-product-details.chemical-treatment": "Chemical Treatment",
	"need4steel-product-details.effectivedelivered": "€/t effective delivered",
	"need4steel-product-details.header-msg": "Szczegóły produktu -",
	"need4steel-product-details.max-outside-Diameter": "Max Outside Diameter (mm)",
	"need4steel-product-details.min-coil-weight": "Min. waga kręgu (t)",
	"need4steel-product-details.proposed-price": "Proponowana cena",
	"need4steel-product-details.unrolledWelds": "Unrolled Welds",
	"need4steel-product-offers.additional-fields": "Dodatkowe pola",
	"need4steel-product-section-details.min-coil-weight": "Min. waga kręgu (t)",
	"need4steel-schedule.button": "Import from history",
	"need4steel-summary-details.effectivedelivered": "effective delivered",
	"need4steel.dialog.coil.weight": "Max. waga kręgu (t)",
	"need4steel.dialog.coil.weight.range": "od {{minValue}} do {{maxValue}} t",
	"need4steel.dialog.coil.weight.range.title": "Maksymalny zakres wagi zwoju",
	"need4steel.dialog.max.coilweight.range.content": "Maksymalna dostępna waga zwoju",
	"need4steel.dialog.max.specific.weight.range.content": "Maksymalna dostępna waga właściwa",
	"need4steel.dialog.range.steelgrade": "Dla gatunku",
	"need4steel.dialog.specific.weight.range": "od {{minValue}} do {{maxValue}} kg/mm",
	"need4steel.dialog.specific.weight.range.title": "Zakres maksymalnej wagi właściwej",
	"need4steel.dialog.thickness.content": "Wybierz gatunek stali",
	"need4steel.dialog.thickness.list.content": "jeśli oczywiste jest, że trzeba wybrać wartość",
	"need4steel.dialog.thickness.range.content": "Dostępne wymiary dla grubości",
	"need4steel.dialog.thickness.range.title": "Zakres grubości",
	"need4steel.dialog.width.content": "Wprowadź odpowiednią wartość dla Grubość",
	"need4steel.dialog.width.list.content": "Wybierz odpowiednią wartość dla Grubość",
	"need4steel.dialog.width.range.content": "Dostępne wymiary dla szerokości",
	"need4steel.dialog.width.range.title": "Zakres szerokości",
	"need4steel.dialog.width.range.title.content": "i grubości",
	"need4steel.offer.error.message": "Przepraszamy, wystąpiły błędy podczas uzyskiwania dostępu do tej oferty. Spróbuj ponownie lub wyślij wiadomość do osoby kontaktowej w ArcelorMittal",
	"need4steel.offer.finishingline": "linia końcowa",
	"need4steel.offer.simulation.error.message": "Przepraszamy, wystąpiły błędy. Spróbuj ponownie lub wyślij wiadomość do osoby kontaktowej w ArcelorMittal.",
	"need4steel.offers.order.button": "Zamówienie",
	"need4steel.offers.title": "Oferty ArcelorMittal Need4Steel®",
	"need4steel.product.details.product.coilweight": "Max. waga kręgu (t)",
	"need4steel.product.details.specific.weight": "Maks. waga właściwa (kg/mm)",
	"need4steel.product.thickness.tolerance": "tolerancja grubości",
	"need4steel.soldto.shipto.error.message": "Przepraszamy, wystąpił błąd w ustawieniach usługi, prosimy o kontakt z administratorem SteelUser",
	"need4steel.submit.credit.limit.error.msg": "☹ ArcelorMittal Need4Steel® order request impossible: not sufficient credit limit available. Please contact us at need4steel@arcelormittal.com",
	"need4steel.submit.error.msg": "Coś poszło nie tak. Skontaktuj się z administratorem SteelUser",
	"need4steel.submit.exchange.rate.mandatory.error.msg": "Kurs wymiany jest obowiązkowy",
	"need4steel.submit.exchange.rate.refreshed.error.msg": "Kurs wymiany został zaktualizowany podczas składania zamówienia. Sprawdź go przed ponownym wysłaniem zamówienia",
	"need4steel.submit.order.error.msg.title": "Wystąpił błąd podczas zatwierdzania zamówienia",
	"need4steel.submit.order.success.msg.row1": "Twoje zamówienie zostało przetworzone",
	"need4steel.submit.order.success.msg.row2": "Możesz śledzić status swojego zamówienia w",
	"need4steel.submit.order.success.msg.row2.link": "STATUS ZAMÓWIENIA I DOSTAWY",
	"need4steel.trademark": "®",
	"need4steel.wizard.coil.error": "Wprowadź prawidłową wartość mniejszą lub równą 1000.",
	"need4steel.wizard.estimated": "Szacunkowa:",
	"need4steel.wizard.exchange-rate.rate": "Kurs wymiany",
	"need4steel.wizard.exchange-rate.reference-date": "Data referencyjna",
	"need4steel.wizard.header.Delivery-address": "Adres dostawy jest obowiązkowy",
	"need4steel.wizard.header.customer": "Klient jest obowiązkowy",
	"need4steel.wizard.header.customer-order-number": "Numer zamówienia klienta",
	"need4steel.wizard.header.customer-order-number.error.invalid": "Nieprawidłowy numer zamówienia klienta",
	"need4steel.wizard.header.customer-order-number.error.mandatory": "Numer zamówienia klienta jest obowiązkowy",
	"need4steel.wizard.header.delivery.date": "Data dostawy",
	"need4steel.wizard.header.mill": "Huta",
	"need4steel.wizard.header.shipto": "Adres dostawy",
	"need4steel.wizard.header.soldto": "klient",
	"need4steel.wizard.header.transport-mode": "Rodzaj transportu",
	"need4steel.wizard.maxcoilweight.range.error": "Wprowadź prawidłową maksymalną wagę cewki.",
	"need4steel.wizard.maxspecificweight.range.error": "Wprowadź prawidłowy maksymalny ciężar właściwy",
	"need4steel.wizard.no.weight.option.error.message": "Problem z ustawieniami szablonu: brak opcji wagi",
	"need4steel.wizard.product.coil.weight": "Maksymalna waga kręgu (t)",
	"need4steel.wizard.product.max.specific.weight": "Maks. waga właściwa kg/mm",
	"need4steel.wizard.product.price.calculate.offline": "Aby poprosić o wycenę, należy mieć dostęp do Internetu",
	"need4steel.wizard.product.specific.weight": "Maks. waga właściwa (kg/mm)",
	"need4steel.wizard.product.weight.type.label": "Wybór rodzaju wagi",
	"need4steel.wizard.step.product.title": "Określ produkt",
	"need4steel.wizard.stepper.product.action.delete": "Usuń",
	"need4steel.wizard.stepper.product.action.duplicate": "Duplikuj",
	"need4steel.wizard.stepper.product.action.reset": "Resetuj",
	"need4steel.wizard.stepper.product.add": "Dodaj produkt",
	"need4steel.wizard.stepper.product.coil": "Nr (zwój)",
	"need4steel.wizard.stepper.product.coilweight": "Maksymalna waga zwoju (t)",
	"need4steel.wizard.stepper.product.itemnumber": "Numer pozycji",
	"need4steel.wizard.stepper.product.steelgrade": "Gatunek stali",
	"need4steel.wizard.stepper.product.thickness": "Grubość (mm)",
	"need4steel.wizard.stepper.product.total.weight": "Waga całkowita",
	"need4steel.wizard.stepper.product.width": "Szerokość (mm)",
	"need4steel.wizard.stepper.step.product.specification": "Specyfikacja produktu",
	"need4steel.wizard.stepper.step.summary": "Podsumowanie",
	"need4steel.wizard.summary.confirm.to.order.button": "Potwierdź zamówienie",
	"need4steel.wizard.summary.proceed.order.button": "Przejdź do zamówienia",
	"need4steel.wizard.summary.product.coils": "Ilość zwojów",
	"need4steel.wizard.summary.product.dimension": "Wymiary (mm)",
	"need4steel.wizard.summary.product.price": "Cena (€/t)",
	"need4steel.wizard.summary.product.selection": "Wybór produktu",
	"need4steel.wizard.summary.product.total.weight": "Waga całkowita (t)",
	"need4steel.wizard.summary.terms.conditions.text": "Klikając opcję Przejdź do zamówienia akceptujesz warunki regulaminu ArcelorMittal Need4Steel®",
	"need4steel.wizard.thickness.range.error": "Wprowadź prawidłową grubość.",
	"need4steel.wizard.thickness.tolerance.field": "Tolerancja grubości",
	"need4steel.wizard.width.range.error": "Wprowadź prawidłową szerokość.",
	"new.offer.request.message": "Czy wiesz, jakiej ilości potrzebujesz dla specyfikacji każdej pozycji?",
	"news.detail": "Widok szczegółowy",
	"news.last-news": "Najnowsze wiadomości",
	"news.news-list": "Lista wiadomości",
	"news.view-all": "Wyświetl wszystkie",
	"no.data.error": "No data found in the feasibility sheet",
	"no.guarantee.documents": "Brak dokumentów gwarancyjnych",
	"no.legal.documents": "Nie znaleziono dokumentów",
	"no.product.family": "Nie znaleziono produktów",
	"no.result": "Brak wyników",
	"notifications.daily": "Codziennie",
	"notifications.immediatly": "Natychmiast",
	"notifications.management": "Zarządzanie powiadomieniami",
	"notifications.monthly": "Miesięcznie",
	"notifications.weekly": "Tygodniowo",
	"number.of.items.in.order": "Zbyt wiele pozycji do dodania do tego zamówienia.",
	"number.of.items.infos.message": "Wpisz numer kopii tego produktu, który chcesz, aby został dodany do tego zamówienia",
	"number.of.items.label": "Liczba pozycji",
	"number.of.items.limit.in.order": "Jedno zamówienie może obejmować tylko 100 pozycji. Sprawdź wybrane produkty.",
	"offer-dashboard-card.accepted": "Zaakceptowano",
	"offer-dashboard-card.annually": "Rocznie",
	"offer-dashboard-card.monthly": "Miesięcznie",
	"offer-dashboard-card.offered": "Oferowane",
	"offer-dashboard-card.order": "Zamówienie",
	"offer-dashboard-card.other-period": "Inny okres",
	"offer-dashboard-card.quarterly": "Kwartalnie",
	"offer-dashboard-card.remaining-to-order": "Pozostało do zamówienia",
	"offer-dashboard-card.requested": "Wnioskowany",
	"offer-dashboard-card.semesterly": "Półrocznie",
	"offer-dashboard-card.view-details": "Widok szczegółowy",
	"offer-period.from": "Od",
	"offer-period.reset": "Resetuj",
	"offer-period.to": "Do",
	"offer.card.table.header.quantity": "Ilość (t)",
	"offer.current.total.tons": "t",
	"offer.dashboard.services": "Moje usługi",
	"offer.end.date": "Data zakończenia",
	"offer.enduser.update.cart.warning": "Ten użytkownik końcowy nie jest zgodny z niektórymi wybranymi produktami. Zostaną one automatycznie usunięte z koszyka.",
	"offer.multiple.families": "Wielokrotność",
	"offer.new.request.title": "Nowe zapytanie",
	"offer.product.disabled.tooltip": "Ten produkt nie jest zgodny z aktualnie wybranym adresem dostawy lub użytkownikiem końcowym",
	"offer.product.family": "Grupa produktowa",
	"offer.quantity.framework": "Wybierz ilości na rodzinę, na które chcesz otrzymać ofertę ",
	"offer.quantity.spot": "Wybierz ilości na sztukę, na które chcesz otrzymać ofertę ",
	"offer.shipto.update.cart.warning": "Ten adres dostawy nie jest zgodny z niektórymi wybranymi produktami. Zostaną one automatycznie usunięte z koszyka.",
	"offer.sub.family": "Podgrupa",
	"offer.template.disabled.tooltip": "Ten szablon nie jest zgodny z aktualnie wybranym adresem dostawy lub użytkownikiem końcowym",
	"offer.transport.condition": "Warunki transportu",
	"offer.type.no": "Nie",
	"offer.type.yes": "Tak",
	"offer.weight": "Waga",
	"offers.action.next": "Następny",
	"offers.commercial.terms": "Warunki handlowe",
	"offers.commitment.period": "Okres zobowiązania",
	"offers.create.details.customer.offer-name": "Numer RFQ klienta",
	"offers.create.details.customer.offer-name.error.mandatory": "Numer zapytania ofertowego klienta jest obowiązkowy",
	"offers.create.details.field.currency": "Wybierz walutę",
	"offers.create.details.field.offer-name": "Nazwa zapytania ofertowego",
	"offers.create.details.field.offer-name.error.mandatory": "Nazwa zapytania ofertowego jest obowiązkowa",
	"offers.create.details.section.entities": "Jednostki",
	"offers.create.details.section.offer-period": "Warunki oferty i okres zobowiązania",
	"offers.create.path.cart": "set your quantity",
	"offers.create.path.confirmation": "złóż zapytanie ofertowe",
	"offers.create.request.offer": "Poproś o ofertę",
	"offers.create.section.offer-period": "Terms and commitment period",
	"offers.product.list": "Lista produktów",
	"offers.proposals.price.nooffer": "Brak dostępnych ofert",
	"offers.proposals.price.period": "Okres powiązany",
	"offers.proposals.price.title": "Ostatnie propozycje cenowe",
	"offers.request.info": "Informacje dotyczące zapytania ofertowego",
	"offers.soldTo.selection.text": "Wybierz odpowiedniego klienta dla tego zapytania ofertowego, aby rozpocząć wyświetlanie listy dostępnych produktów. Wszystkie produkty w koszyku powinny być powiązane z tym samym klientem.",
	"offers.sqmeters": "Metry kwadratowe",
	"offers.wizard.stepper.customization": "Personalizacja",
	"offers.wizard.stepper.request.and.selection": "Zapytanie ofertowe i wybór",
	"offers.wizard.stepper.step.offer-summary": "Podsumowanie",
	"offers.wizard.stepper.step.quantity": "Ilość",
	"offline.alert": "Alert",
	"ok.value": "OK",
	"order-card.batches-at-reshipper": "U spedytora",
	"order-card.batches-available": "Dostępne kręgi/paczki",
	"order-card.batches-blocked": "Kręgi/paczki zablokowane",
	"order-card.batches-called": "Called",
	"order-card.batches-consignment-stock": "Magazyn konsygnacyjny",
	"order-card.batches-delivered": "Kręgi/paczki dostarczone",
	"order-card.batches-land-transit": "Tranzyt lądowy",
	"order-card.batches-on-vessel": "Na statku",
	"order-card.batches-overseas-transit": "Tranzyt morski",
	"order-card.batches-ready-to-ship": "Gotowe do wysyłki",
	"order-card.batches-transit-to-customer": "W transporcie do odbiorcy",
	"order-card.commercial-documents": "Dokumenty handlowe",
	"order-card.data-not-found": "Order data not found",
	"order-card.document": "Dokument",
	"order-card.due-to-technical-issue": "Nie jesteśmy w stanie wyświetlić tych danych z powodu problemów technicznych.",
	"order-card.gross": "Brutto: {{value}}",
	"order-card.name": "Nazwa",
	"order-card.net": "Netto: {{value}}",
	"order-card.no-rows-to-show": "Brak danych",
	"order-card.proforma": "Proforma",
	"order-card.type": "Rodzaj",
	"order-card.we-are-actively-working": "Aktywnie pracujemy nad przywróceniem usługi.",
	"order-card.wip-quantity": "Ilość (tony)",
	"order-card.work-in-progress": "Produkcja w toku",
	"order-item-status.completely-produced": "Wyprodukowana",
	"order-tracking.card.batches-in-stock": "Kręgi/paczki w magazynie",
	"order-tracking.card.callables-batches.days": "dni",
	"order-tracking.card.callables-batches.view-details": "Widok szczegółowy",
	"order-tracking.card.delivery-date.cdd": "Potwierdzony termin dostawy",
	"order-tracking.card.delivery-date.first-batch": "Pierwsza partia w magazynie",
	"order-tracking.card.delivery-date.last-batch": "Ostatnia partia w magazynie",
	"order-tracking.card.delivery-date.rdd": "Żądany termin dostawy (tydzień)",
	"order-tracking.card.delivery-date.view-details": "Widok szczegółowy",
	"order-tracking.card.delivery-status": "Status dostaw",
	"order-tracking.cdd": "Potwierdzony termin dostawy",
	"order-tracking.choice": "Gatunek",
	"order-tracking.customerArticleReference": "Numer pozycji klienta",
	"order-tracking.delivered": "Dostarczone",
	"order-tracking.delivered-t": "Dostarczono (t)",
	"order-tracking.dimension": "Wymiary (mm)",
	"order-tracking.final.use": "Zastosowanie",
	"order-tracking.form": "Forma",
	"order-tracking.in.production": "W produkcji",
	"order-tracking.in.production-t": "W produkcji (t)",
	"order-tracking.in.stock": "w magazynie",
	"order-tracking.in.stock-t": "W magazynie (t)",
	"order-tracking.in.transit": "W transporcie",
	"order-tracking.in.transit-t": "W transporcie (t)",
	"order-tracking.list": "Lista",
	"order-tracking.no.connection": "Usługa śledzenia zamówień internetowych jest niedostępna",
	"order-tracking.no.result": "Brak wyników",
	"order-tracking.overview": "Przegląd",
	"order-tracking.product": "Produkt",
	"order-tracking.product.category": "Kategoria produktu",
	"order-tracking.product.description": "krąg organicznie powlekany",
	"order-tracking.running.orders": "Zamówienia bieżące",
	"order-tracking.standard-steel-grade": "Gatunek stali",
	"order-tracking.standard.steelgrade": "Gatunek stali",
	"order-tracking.steelgrade": "Gatunek stali",
	"order.avail-t": "Dostępne (t)",
	"order.bill.to": "Adres rozliczeniowy",
	"order.book.only": "Tylko lista zamówień",
	"order.callable.gross.weight": "Callable gross weight",
	"order.called.gross.weight": "Called gross weight",
	"order.card": "Szczegóły zamówienia",
	"order.card.all.documents": "Wszystkie dokumenty dla tego zamówienia",
	"order.card.certificate.display.all": "Wyświetl wszystkie Certifikat",
	"order.card.dates": "Daty",
	"order.card.detail.information": "Zobacz szczegółowe informacje i zamówieniu",
	"order.card.dispatch.advice.display.all": "Wyświetl wszystkie awiza",
	"order.card.document.certificates": "Certifikat",
	"order.card.document.date": "Data",
	"order.card.document.dispatch.advices": "Awiza",
	"order.card.document.display.batches": "Wyświetl wszystkie kręgi/paczki",
	"order.card.document.invoices": "Faktury",
	"order.card.document.number": "Numer dokumentu",
	"order.card.document.order.acknowledgments": "Potwierdzenia zamówień",
	"order.card.document.show": "Pokaż dokument",
	"order.card.document.type": "Format",
	"order.card.followup": "Dodatkowe informacje",
	"order.card.in-consignment": "W przesyłce",
	"order.card.in-consignment-t": "W przesyłce (t)",
	"order.card.information": "Moje zamówienie",
	"order.card.invoice.display.all": "Wyświetl wszystkie faktury",
	"order.card.last.certificate": "Najnowszy certyfikat",
	"order.card.last.dispatch.advice": "Najnowsze awizo",
	"order.card.last.documents": "Ostatnie dokumenty",
	"order.card.last.invoice": "Najnowsza faktura",
	"order.card.last.order.acknowledgment": "Najnowsze potwierdzenie zamówienia",
	"order.card.order.acknowledgment.display.all": "Wyświetl wszystkie potwierdzenia zamówień",
	"order.card.product": "Produkt",
	"order.card.xcarb": "XCarb®",
	"order.cdd-week": "Potwierdzony termin dostawy (tydzień)",
	"order.certificate": "Certyfikat",
	"order.chemical.passivation": "Chemical Passivation",
	"order.choice": "Gatunek",
	"order.coating": "Powłoka",
	"order.coating-side": "Strona powłoki",
	"order.color-bottom-side": "Kolor (dół)",
	"order.color-top-side": "Kolor (góra)",
	"order.color.category.bottom.side": "Color Category Bottom Side",
	"order.color.category.top.side": "Color Category Top Side",
	"order.confirmed.delivery.date": "Potwierdzona data dostawy (CDD)",
	"order.contract.number": "Numer kontraktu",
	"order.creation.date": "Data utworzenia",
	"order.customer": "Klient",
	"order.customer-template-reference": "Nr ref. szablonu klienta",
	"order.customer.article.reference": "Numer pozycji klienta",
	"order.customer.order.number": "Numer zamówienia klienta",
	"order.daysInStock": "Liczba dni w magazynie",
	"order.delivered-t": "Dostarczono (t)",
	"order.delivery": "Dostawa",
	"order.delivery.address": "Adres dostawy",
	"order.delivery.mode": "Sposób dostawy",
	"order.dim-mm": "Wymiar (mm)",
	"order.easy-film-bottom": "Folia ochronna (dół)",
	"order.easy-film-top": "Folia ochronna (góra)",
	"order.easy.film.bottom": "EasyFilm Bottom",
	"order.easy.film.top": "EasyFilm Top",
	"order.ebusiness.order.number": "Nr ref. zamówienia eBusiness",
	"order.end.user": "Odbiorca końcowy",
	"order.enduser": "Odbiorca końcowy",
	"order.entry": "Wprowadzanie zamówień",
	"order.final-use": "Zastosowanie",
	"order.firm": "Firma",
	"order.first.batch.available": "Dostępność pierwszej partii",
	"order.first.batch.in.stock": "Pierwsza partia w magazynie",
	"order.form": "Forma",
	"order.grade": "Gatunek",
	"order.incoterm": "Incoterm",
	"order.incoterm2": "Incoterm2",
	"order.internal-diameter": "Średnica wewnętrzna (mm)",
	"order.interpretation.delivery.date": "Określenie daty dostawy",
	"order.item.reference.soldto.party": "Numer pozycji klienta",
	"order.item.status": "Status pozycji zamówienia",
	"order.last.batch.available": "Dostępność ostatniej partii",
	"order.last.batch.in.stock": "Ostatnia partia w magazynie",
	"order.last.updated": "Ostatnia aktualizacja",
	"order.maximum-outside-diameter": "Maksymalna średnica zewnętrzna (mm)",
	"order.mill": "Huta",
	"order.mill.order.number": "Numer zamówienia w hucie",
	"order.minimum-outside-diameter": "Minimalna średnica zewnętrzna (mm)",
	"order.no-documents": "Brak dokumentów",
	"order.oil-reference": "Rodzaj oleju",
	"order.oil-side": "Strona olejowana",
	"order.oil.reference": "Oil Reference",
	"order.ord-t": "Zam. (t)",
	"order.order-status": "Status zamówień",
	"order.ordered": "Zamówiono",
	"order.ordered-t": "Zamówiono (t)",
	"order.orders": "Zamówienia",
	"order.packing": "Opakowanie",
	"order.paint.marking.for.sh": "Paint Marking",
	"order.pattern.for.sh": "Pattern",
	"order.place.delivery": "Miejsce dostawy",
	"order.prevision.item": "Późniejsza specyfikacja",
	"order.protection": "Zabezpieczenie",
	"order.provisional": "Tymczasowo",
	"order.provisional.item": "Wstępna specyfikacja",
	"order.rdd": "Żądany termin dostawy (tydzień)",
	"order.reason": "Przyczyna zamówienia",
	"order.responsible.order.manager": "Odpowiedzialny menedżer ds. zamówień",
	"order.sales.quarter": "Kwartał",
	"order.service.level": "Poziom usług",
	"order.service.request": "Żądanie usługi",
	"order.ship.to": "Odbiorca",
	"order.sortby": "Sortuj wg",
	"order.spangle": "Kwiat",
	"order.standard": "Norma",
	"order.status": "Status zamówień",
	"order.steelgrade": "Gatunek stali",
	"order.stock-alert": "Alert stanu magazynowego",
	"order.sub.category": "Sub Category",
	"order.submit": "Prześlij",
	"order.supplier": "Dostawca",
	"order.supplier-rfq-number": "Supplier RFQ number",
	"order.supplier.order.number": "Numer zamówienia dostawcy",
	"order.surface-aspect": "Powierzchnia",
	"order.thickness": "Grubość",
	"order.transport-mode": "Rodzaj transportu",
	"order.transport.mode": "Rodzaj transportu",
	"order.ultrasonic.testing": "Ultrasonic Testing",
	"order.width": "Szerokość",
	"order.wip": "W produkcji",
	"order.wip-t": "Produkcja w toku (t)",
	"order.wip.forecast.stock": "Szacunkowa data w magazynie",
	"order.wip.quantity": "Ilość",
	"order.woe.version": "Wersja WOE",
	"order.z.test.certificat": "Z-test Certificat",
	"orderview.sort.cdd": "Potwierdzony termin dostawy",
	"orderview.sort.order": "Zamówienie",
	"orderview.sort.product": "Produkt",
	"organization-type.agency": "Agency",
	"organization-type.buyer": "Buyer",
	"organization-type.lab": "Laboratory",
	"organization-type.selag": "Biuro sprzedawcy",
	"organization-type.seller": "Sprzedawca",
	"organization-type.super-user": "Super użytkownik",
	"organization-users.one-admin": "One administrator should be selected",
	"organization-users.one-admin-only": "Only one administrator should be selected",
	"organization-users.roles-error": "An error occurred during the update of the user, changes are not saved",
	"organization-users.roles-saved": "Roles have been correctly updated",
	"organization.card.administrator.comment": "Aktualnie odpowiedzialny za tę organizację",
	"organization.card.administrator.email": "Email",
	"organization.card.administrator.name": "Nazwa",
	"organization.card.details": "Szczegóły",
	"organization.card.details.administrator": "Administrator",
	"organization.card.details.identity": "Szczegóły",
	"organization.card.identity.address": "Adres",
	"organization.card.identity.city": "Miejscowość",
	"organization.card.identity.country": "Kraj",
	"organization.card.identity.country.AD": "Andora",
	"organization.card.identity.country.AE": "Zjedn.Emir.Arab.",
	"organization.card.identity.country.AF": "Afganistan",
	"organization.card.identity.country.AG": "Antigua i Barbuda",
	"organization.card.identity.country.AI": "Anguilla",
	"organization.card.identity.country.AL": "Albania",
	"organization.card.identity.country.AM": "Armenia",
	"organization.card.identity.country.AN": "Antyle Holenderskie",
	"organization.card.identity.country.AO": "Angola",
	"organization.card.identity.country.AQ": "Antarktyda",
	"organization.card.identity.country.AR": "Argentyna",
	"organization.card.identity.country.AS": "Samoa",
	"organization.card.identity.country.AT": "Austria",
	"organization.card.identity.country.AU": "Australia",
	"organization.card.identity.country.AW": "Aruba",
	"organization.card.identity.country.AZ": "Azerbejdżan",
	"organization.card.identity.country.BA": "Bośnia i Hercegowina",
	"organization.card.identity.country.BB": "Barbados",
	"organization.card.identity.country.BD": "Bangladesz",
	"organization.card.identity.country.BE": "Belgia",
	"organization.card.identity.country.BF": "Burkina Faso",
	"organization.card.identity.country.BG": "Bułgaria",
	"organization.card.identity.country.BH": "Bahrajn",
	"organization.card.identity.country.BI": "Burundi",
	"organization.card.identity.country.BJ": "Benin",
	"organization.card.identity.country.BM": "Bermudy",
	"organization.card.identity.country.BN": "Brunei",
	"organization.card.identity.country.BO": "Boliwia",
	"organization.card.identity.country.BR": "Brazylia",
	"organization.card.identity.country.BS": "Bahamy",
	"organization.card.identity.country.BT": "Bhutan",
	"organization.card.identity.country.BU": "Birma",
	"organization.card.identity.country.BV": "W. Bouveta",
	"organization.card.identity.country.BW": "Botswana",
	"organization.card.identity.country.BY": "Białoruś",
	"organization.card.identity.country.BZ": "Belize",
	"organization.card.identity.country.CA": "Kanada",
	"organization.card.identity.country.CC": "W. Kokosowe",
	"organization.card.identity.country.CD": "Dem. Rep. Konga",
	"organization.card.identity.country.CF": "Rep. Środkowoafryk.",
	"organization.card.identity.country.CG": "Kongo",
	"organization.card.identity.country.CH": "Szwajcaria",
	"organization.card.identity.country.CI": "Wybrzeże Kości Słoniowej",
	"organization.card.identity.country.CK": "W. Cooka",
	"organization.card.identity.country.CL": "Chile",
	"organization.card.identity.country.CM": "Kamerun",
	"organization.card.identity.country.CN": "Chiny",
	"organization.card.identity.country.CO": "Kolumbia",
	"organization.card.identity.country.CR": "Kostaryka",
	"organization.card.identity.country.CS": "nie używać (S/M)",
	"organization.card.identity.country.CU": "Kuba",
	"organization.card.identity.country.CV": "W. Zielonego Przylądka",
	"organization.card.identity.country.CX": "W. Bożego Narodzenia",
	"organization.card.identity.country.CY": "Cypr",
	"organization.card.identity.country.CZ": "Czechy",
	"organization.card.identity.country.DE": "Niemcy",
	"organization.card.identity.country.DJ": "Dżibuti",
	"organization.card.identity.country.DK": "Dania",
	"organization.card.identity.country.DM": "Dominika",
	"organization.card.identity.country.DO": "Dominikana",
	"organization.card.identity.country.DZ": "Algieria",
	"organization.card.identity.country.EC": "Ekwador",
	"organization.card.identity.country.EE": "Estonia",
	"organization.card.identity.country.EG": "Egipt",
	"organization.card.identity.country.EH": "Sahara Zachodnia",
	"organization.card.identity.country.ER": "Erytrea",
	"organization.card.identity.country.ES": "Hiszpania",
	"organization.card.identity.country.ET": "Etiopia",
	"organization.card.identity.country.FI": "Finlandia",
	"organization.card.identity.country.FJ": "Fidżi",
	"organization.card.identity.country.FK": "Falklandy",
	"organization.card.identity.country.FM": "Mikronezja",
	"organization.card.identity.country.FO": "W. Owcze",
	"organization.card.identity.country.FR": "Francja",
	"organization.card.identity.country.GA": "Gabon",
	"organization.card.identity.country.GB": "Wielka Brytania",
	"organization.card.identity.country.GD": "Grenada",
	"organization.card.identity.country.GE": "Gruzja",
	"organization.card.identity.country.GF": "Gujana Francuska",
	"organization.card.identity.country.GH": "Ghana",
	"organization.card.identity.country.GI": "Gibraltar",
	"organization.card.identity.country.GL": "Grenlandia",
	"organization.card.identity.country.GM": "Gambia",
	"organization.card.identity.country.GN": "Gwinea",
	"organization.card.identity.country.GP": "Gwadelupa",
	"organization.card.identity.country.GQ": "Gwinea Równikowa",
	"organization.card.identity.country.GR": "Grecja",
	"organization.card.identity.country.GS": "Sandwich Płd.",
	"organization.card.identity.country.GT": "Gwatemala",
	"organization.card.identity.country.GU": "Guam",
	"organization.card.identity.country.GW": "Gwinea-Bissau",
	"organization.card.identity.country.GY": "Gujana",
	"organization.card.identity.country.HK": "Hongkong",
	"organization.card.identity.country.HM": "W. Heard i McDonalda",
	"organization.card.identity.country.HN": "Honduras",
	"organization.card.identity.country.HR": "Chorwacja",
	"organization.card.identity.country.HT": "Haiti",
	"organization.card.identity.country.HU": "Węgry",
	"organization.card.identity.country.ID": "Indonezja",
	"organization.card.identity.country.IE": "Irlandia",
	"organization.card.identity.country.IL": "Izrael",
	"organization.card.identity.country.IN": "Indie",
	"organization.card.identity.country.IO": "Bryt.Teryt.Oc.Ind.",
	"organization.card.identity.country.IQ": "Irak",
	"organization.card.identity.country.IR": "Iran",
	"organization.card.identity.country.IS": "Islandia",
	"organization.card.identity.country.IT": "Włochy",
	"organization.card.identity.country.JM": "Jamajka",
	"organization.card.identity.country.JO": "Jordan",
	"organization.card.identity.country.JP": "Japonia",
	"organization.card.identity.country.KE": "Kenia",
	"organization.card.identity.country.KG": "Kirgizja",
	"organization.card.identity.country.KH": "Kambodża",
	"organization.card.identity.country.KI": "Kiribati",
	"organization.card.identity.country.KM": "Komory",
	"organization.card.identity.country.KN": "Saint Kitts",
	"organization.card.identity.country.KP": "Korea Płn.",
	"organization.card.identity.country.KR": "Korea Płd.",
	"organization.card.identity.country.KW": "Kuwejt",
	"organization.card.identity.country.KY": "Kajmany",
	"organization.card.identity.country.KZ": "Kazachstan",
	"organization.card.identity.country.LA": "Laos",
	"organization.card.identity.country.LB": "Liban",
	"organization.card.identity.country.LC": "Saint Lucia",
	"organization.card.identity.country.LI": "Liechtenstein",
	"organization.card.identity.country.LK": "Sri Lanka",
	"organization.card.identity.country.LR": "Liberia",
	"organization.card.identity.country.LS": "Lesotho",
	"organization.card.identity.country.LT": "Litwa",
	"organization.card.identity.country.LU": "Luksemburg",
	"organization.card.identity.country.LV": "Łotwa",
	"organization.card.identity.country.LY": "Libia",
	"organization.card.identity.country.MA": "Maroko",
	"organization.card.identity.country.MC": "Monako",
	"organization.card.identity.country.MD": "Mołdawia",
	"organization.card.identity.country.ME": "Czarnogóra",
	"organization.card.identity.country.MF": "Saint-Martin",
	"organization.card.identity.country.MG": "Madagaskar",
	"organization.card.identity.country.MH": "W. Marshalla",
	"organization.card.identity.country.MK": "Macedonia Płn.",
	"organization.card.identity.country.ML": "Mali",
	"organization.card.identity.country.MM": "Mjanma",
	"organization.card.identity.country.MN": "Mongolia",
	"organization.card.identity.country.MO": "Makao",
	"organization.card.identity.country.MP": "Mariany Płn.",
	"organization.card.identity.country.MQ": "Martynika",
	"organization.card.identity.country.MR": "Mauretania",
	"organization.card.identity.country.MS": "Montserrat",
	"organization.card.identity.country.MT": "Malta",
	"organization.card.identity.country.MU": "Mauritius",
	"organization.card.identity.country.MV": "Malediwy",
	"organization.card.identity.country.MW": "Malawi",
	"organization.card.identity.country.MX": "Meksyk",
	"organization.card.identity.country.MY": "Malezja",
	"organization.card.identity.country.MZ": "Mozambik",
	"organization.card.identity.country.NA": "Namibia",
	"organization.card.identity.country.NC": "Nowa Kaledonia",
	"organization.card.identity.country.NE": "Niger",
	"organization.card.identity.country.NF": "W. Norfolk",
	"organization.card.identity.country.NG": "Nigeria",
	"organization.card.identity.country.NI": "Nikaragua",
	"organization.card.identity.country.NL": "Holandia",
	"organization.card.identity.country.NO": "Norwegia",
	"organization.card.identity.country.NP": "Nepal",
	"organization.card.identity.country.NR": "Nauru",
	"organization.card.identity.country.NU": "Niue",
	"organization.card.identity.country.NZ": "Nowa Zelandia",
	"organization.card.identity.country.O1": "Pozostałe NIEPODSTAWOWE",
	"organization.card.identity.country.O2": "Pozostałe TASIA",
	"organization.card.identity.country.O3": "Pozostałe TAEX",
	"organization.card.identity.country.O4": "Pozostałe TANY",
	"organization.card.identity.country.OM": "Oman",
	"organization.card.identity.country.OT": "Pozostałe kraje",
	"organization.card.identity.country.PA": "Panama",
	"organization.card.identity.country.PE": "Peru",
	"organization.card.identity.country.PF": "Polinezja Fr.",
	"organization.card.identity.country.PG": "Papua N. Gwinea",
	"organization.card.identity.country.PH": "Filipiny",
	"organization.card.identity.country.PK": "Pakistan",
	"organization.card.identity.country.PL": "Polska",
	"organization.card.identity.country.PM": "Saint-Pierre",
	"organization.card.identity.country.PN": "Pitcairn",
	"organization.card.identity.country.PR": "Portoryko",
	"organization.card.identity.country.PS": "Teryt. Palestyny",
	"organization.card.identity.country.PT": "Portugalia",
	"organization.card.identity.country.PW": "Palau",
	"organization.card.identity.country.PY": "Paragwaj",
	"organization.card.identity.country.QA": "Katar",
	"organization.card.identity.country.RE": "Reunion",
	"organization.card.identity.country.RO": "Rumunia",
	"organization.card.identity.country.RS": "Serbia",
	"organization.card.identity.country.RU": "Fed. Rosyjska",
	"organization.card.identity.country.RW": "Rwanda",
	"organization.card.identity.country.SA": "Arabia Saudyjska",
	"organization.card.identity.country.SB": "W. Salomona",
	"organization.card.identity.country.SC": "Seszele",
	"organization.card.identity.country.SD": "Sudan",
	"organization.card.identity.country.SE": "Szwecja",
	"organization.card.identity.country.SG": "Singapur",
	"organization.card.identity.country.SH": "St. Helena",
	"organization.card.identity.country.SI": "Słowenia",
	"organization.card.identity.country.SJ": "Svalbard",
	"organization.card.identity.country.SK": "Słowacja",
	"organization.card.identity.country.SL": "Sierra Leone",
	"organization.card.identity.country.SM": "San Marino",
	"organization.card.identity.country.SN": "Senegal",
	"organization.card.identity.country.SO": "Somalia",
	"organization.card.identity.country.SR": "Surinam",
	"organization.card.identity.country.ST": "W. Św. Tomasza",
	"organization.card.identity.country.STL": "bezpaństwowcy",
	"organization.card.identity.country.SV": "Salwador",
	"organization.card.identity.country.SY": "Syria",
	"organization.card.identity.country.SZ": "Suazi",
	"organization.card.identity.country.TC": "Turks i Caicos",
	"organization.card.identity.country.TD": "Czad",
	"organization.card.identity.country.TF": "Francuskie Terytoria Płd.",
	"organization.card.identity.country.TG": "Togo",
	"organization.card.identity.country.TH": "Tajlandia",
	"organization.card.identity.country.TJ": "Tadżykistan",
	"organization.card.identity.country.TK": "Tokelau",
	"organization.card.identity.country.TL": "Timor Wschodni",
	"organization.card.identity.country.TM": "Turkmenia",
	"organization.card.identity.country.TN": "Tunezja",
	"organization.card.identity.country.TO": "Tonga",
	"organization.card.identity.country.TP": "Timor Wsch.",
	"organization.card.identity.country.TR": "Turcja",
	"organization.card.identity.country.TT": "Trynidad",
	"organization.card.identity.country.TV": "Tuvalu",
	"organization.card.identity.country.TW": "Tajwan",
	"organization.card.identity.country.TZ": "Tanzania",
	"organization.card.identity.country.UA": "Ukraina",
	"organization.card.identity.country.UG": "Uganda",
	"organization.card.identity.country.UM": "Dalekie Wyspy Mniejsze",
	"organization.card.identity.country.US": "USA",
	"organization.card.identity.country.UY": "Urugwaj",
	"organization.card.identity.country.UZ": "Uzbekistan",
	"organization.card.identity.country.VA": "Watykan",
	"organization.card.identity.country.VC": "St. Vincent",
	"organization.card.identity.country.VE": "Wenezuela",
	"organization.card.identity.country.VG": "Brytyjskie W. Dziewicze",
	"organization.card.identity.country.VI": "W. Dziewicze USA",
	"organization.card.identity.country.VN": "Wietnam",
	"organization.card.identity.country.VU": "Vanuatu",
	"organization.card.identity.country.WF": "Wallis",
	"organization.card.identity.country.WS": "Samoa",
	"organization.card.identity.country.XK": "Kosowo",
	"organization.card.identity.country.YE": "Jemen",
	"organization.card.identity.country.YT": "Majotta",
	"organization.card.identity.country.YU": "Jugosławia",
	"organization.card.identity.country.ZA": "RPA",
	"organization.card.identity.country.ZM": "Zambia",
	"organization.card.identity.country.ZR": "Zair",
	"organization.card.identity.country.ZW": "Zimbabwe",
	"organization.card.identity.name": "Nazwa",
	"organization.card.identity.postCode": "Kod pocztowy",
	"organization.card.identity.state": "Kraj lub region",
	"organization.card.identity.suppliers": "Dostawcy",
	"organization.card.identity.vat": "Nr VAT",
	"organization.card.manage-transactional-visibilities": "Zarządzaj autoryzacją transakcji",
	"organization.card.organizationcard": "Szczegóły organizacji",
	"organization.card.services": "Usługi",
	"organization.card.services.no-data": "Nie masz żadnych usług",
	"organization.card.services.tab.desc": "Opis",
	"organization.card.services.tab.name": "Nazwa",
	"organization.card.services.title": "Lista usług",
	"organization.card.services.title.desc": "Lista wszystkich usług dostępnych dla Twojej organizacji",
	"organization.card.transactional-visibilities": "Autoryzacje transakcji",
	"organization.card.users": "Użytkownicy",
	"organization.card.visibilities": "Autoryzacje",
	"organization.details-card.flow-chart": "Struktura organizacji",
	"organization.details-card.flow-chart.current-organization": "Wybrana organizacja",
	"organization.details-card.flow-chart.customer": "Klient",
	"organization.details-card.flow-chart.desc": "Miejsce organizacji w strukturze",
	"organization.details-card.flow-chart.supplier": "Dostawca",
	"organization.is-payer": "to płatnik",
	"organization.is-shipto": "to odbiorca",
	"organization.is-soldto": "to klient",
	"organization.status.deactivated": "Dezaktywowany",
	"organization.status.deleted": "Usunięty",
	"organization.user-accept": "Akceptuj",
	"organization.user-id": "Nr identyfikacyjny",
	"organization.user-manage": "Zarządzaj",
	"organization.user-reject": "Odrzuć",
	"organization.user-status-in-organization": "Status w organizacji",
	"organization.users.list.desc": "Lista wszystkich dostępnych użytkowników w tej organizacji",
	"organizationrole.api": "API",
	"organizationrole.dsu": "Administrator",
	"organizationrole.hlpdk": "Helpdesk",
	"organizationrole.subscription": "Notification",
	"organizationrole.user": "Użytkownik",
	"overview.survey-answer": "Przejdź do ankiety",
	"overview.survey-no-answer": "Nie, dziękuję",
	"overview.survey.please": "Prosimy",
	"overview.survey.questions": "odpowiedz na 3 pytania (czas około 20 s)",
	"overview.viewby": "Wyświetl wg",
	"product.added.to.cart": "produkt(y) zostały prawidłowo dodane do koszyka",
	"product.card.new.specification": "Nowa specyfikacja",
	"product.error": "unexpected error while trying to look for the product",
	"product.feasibility.not-feasible": "not feasible",
	"product.feasibility.ok": "Produkt OK",
	"product.feasibility.pending": "W toku",
	"product.feasibility.refused": "Produkty niewykonalny",
	"product.feasibility.technical-error": "Technical Error",
	"product.message.product.not.saved": "Nie można zapisać produktu",
	"product.message.template.product.not.saved": "Nie można stworzyć nowego produktu",
	"product.most.used.values": "Najczęściej używane wartości",
	"product.no.original.value": "Brak oryginalnej wartości",
	"product.not.exist": "Ten produkt nie istnieje",
	"product.original.value": "Oryginalna wartość",
	"product.other.values": "Inne wartości",
	"product.pc.label.max": "Maks.",
	"product.pc.label.min": "Min.",
	"product.pc.label.unit": "Jednostka",
	"product.product.submitted": "Produkt zapisany",
	"product.quality.dashboard": "Reklamacje",
	"product.save.template.product": "Zapisane jako nowa specyfikacja",
	"product.save.template.product.and.add.to.cart": "Zapisane i dodane do koszyka",
	"product.table.header.add": "Dodaj",
	"product.table.header.view": "Widok",
	"product.template": "Szkic produkty",
	"product.template.isbeingsimulated": "Nowa specyfikcja jest zatwierdzana",
	"product.title.group.certificate": "Certyfikat",
	"product.title.group.coating": "Powłoka",
	"product.title.group.dimensions": "Wymiary",
	"product.title.group.insulationResistanceTest": "Badanie rezystancji powierzchniowej izolacji ",
	"product.title.group.labelling": "Etykieta",
	"product.title.group.management": "Management",
	"product.title.group.packing": "Opakowanie",
	"product.title.group.productionProcess": "Proces produkcji",
	"product.title.group.specifications": "Specyfikacje",
	"product.title.group.stamping": "Stemplowanie",
	"product.title.group.surface": "Powierzchnia",
	"product.title.group.surfaceTreatment": "Obróbka powierzchni",
	"product.title.group.use": "Zastosowanie",
	"product.title.group.weightDiameter": "Waga/ średnica",
	"product.title.group.welds": "Zgrzewy",
	"product.title.section.bottom": "Spód",
	"product.title.section.bundleHeight": "Wysokość paczki",
	"product.title.section.bundleWeight": "Waga paczki",
	"product.title.section.coilWeight": "Waga kręgu",
	"product.title.section.customerArticle": "Numer pozycji klienta",
	"product.title.section.diameter": "Średnica",
	"product.title.section.edge": "Krawędź",
	"product.title.section.insideDiameter": "Średnica wewnętrzna",
	"product.title.section.numberSheetsPerBundle": "Ilość arkuszy w paczce",
	"product.title.section.numberSlitCoilsPerPackage": "Ilość kręgów taśmy w paczce",
	"product.title.section.outsideDiameter": "Średnica zewnętrzna",
	"product.title.section.packageHeight": "Wysokość paczki",
	"product.title.section.packageHeightWithPalet": "Wysokość paczki włączając paletę",
	"product.title.section.packageWeight": "Waga paczki (więcej niż jeden krąg w paczce)",
	"product.title.section.removableProtectiveFilm": "Usuwalna folia ochronna",
	"product.title.section.slabWeightInTon": "Waga kęsiska w tonach",
	"product.title.section.specificWeight": "Waga",
	"product.title.section.thickness": "Grubość",
	"product.title.section.top": "Góra",
	"product.title.section.weight": "Waga",
	"product.title.section.width": "Szerokość",
	"profile.no.access": "Aby wyświetlić profil, upewnij się, czy masz dostęp do internetu i zaloguj się do aplikacji",
	"profile.select": "Profil - wybierz",
	"profile.select.visibility": "Wybierz firmę/widoczność",
	"profile.visibility.all": "Wszystkie",
	"progress.message": "Twoja transakcja trwa",
	"progress.message.fastlane": "Your transaction is in progress",
	"promote.user.message": "Użytkownik do promowania:",
	"prototype-card": "Karta prototypowa",
	"prototype-card-details.proposed-price": "Proponowana cena",
	"prototype-card-details.proposed-price.na": "ND.",
	"prototype-card.data-not-found": "prototyp nie istnieje",
	"prototype.card.deliveryweek": "Delivery week",
	"prototype.card.product.source": "source",
	"prototype.card.proposal": "Propozycja",
	"prototype.card.proposal.deliveries": "Proponowane dostawy",
	"prototype.card.proposal.product.information": "Proponowany produkt",
	"prototype.card.proposed.quantities": "Proponowana ilość",
	"prototype.card.proposed.readyForDispatch": "Ready for dispatch at PO receipt",
	"prototype.card.request.deliveries": "Zamówione dostawy",
	"prototype.card.request.information": "Żądany produkt",
	"prototype.card.request.quantities": "Żądane ilości",
	"prototype.card.sheetweight": "Waga arkusza",
	"prototype.card.status.accepted": "Przyjęte",
	"prototype.card.status.materialnotfound": "Materiał niedostępny",
	"prototype.card.status.notavailable": "Not available",
	"prototype.card.status.refusedbycustomer": "Odmowa klienta",
	"prototype.card.status.requested": "Wnioskowany",
	"prototype.production-po-reception-date": "Data otrzymania PO",
	"prototype.production.po-delivery": "Dostawa",
	"prototype.production.po.order": "Zamówienie",
	"prototype.status.accepted": "Zaakceptowane",
	"prototype.status.closed": "Closed",
	"prototype.status.confirmed": "Confirmed",
	"prototype.status.decision": "Decyzja",
	"prototype.status.proposal": "Propozycja",
	"prototype.status.refused": "Refused",
	"prototype.tracker.status": "Status prototypu",
	"qty-by-family.title.note": "Proszę podać ilości dla odpowiednich okresów dla tej rodziny",
	"quality.feedback.card.closed.issues": "Zamknięte reklamacje ",
	"quality.feedback.card.closed.paid": "Zapłacono",
	"quality.feedback.card.closed.rejected": "Odrzucono",
	"quality.feedback.card.details": "Widok szczegółowy",
	"quality.feedback.card.open.issues": "Reklamacje w toku",
	"quality.feedback.card.subtitle": "Szczegóły rozpatrzonych reklamacji",
	"quality.feedback.card.title": "Reklamacje",
	"quality.first.selected.batch": "Twoje partie dostarczone lub gotowe do wysyłki w ramach zamówienia",
	"quality.guarantee.request": "Żądanie gwarancji",
	"quality.information": "Informacje dotyczące jakości",
	"quality.issue.save.failed": "Nie udało się przesłać reklamacji.",
	"quality.issues.draft.edit": "Będziesz mógł ją edytować podczas uzupełniania wersji roboczej.",
	"quality.issues.draft.saved.successfully": "Twoja wersja robocza została zapisana",
	"quality.issues.followup": "Będzie można ją wyświetlić podczas uzupełniania reklamacji w sekcji Zarządzanie jakością.",
	"quality.issues.save.failed.message": "Spróbuj ponownie później lub skontaktuj się z ebusiness.support@arcelormittal.com",
	"quality.issues.submitted.successfully": "Twoja reklamacja została przesłana pomyślnie.",
	"quality.max.selected.batch": "Wybrane partie (maksymalnie 6 partii)",
	"quapp.action.add.attach": "Dodaj załącznik",
	"quapp.action.add.attach.progress": "Dodawanie w toku",
	"quapp.action.cancel": "Anuluj reklamację",
	"quapp.action.change": "Zmień",
	"quapp.action.delete": "Usuń",
	"quapp.action.edit": "Edytuj",
	"quapp.action.go.back": "Wróć",
	"quapp.action.save": "Zapisz",
	"quapp.action.select.file": "Wybierz plik",
	"quapp.action.send": "Wyślij",
	"quapp.action.view": "Widok",
	"quapp.actor.am": "ArcelorMittal",
	"quapp.actor.customer": "Klient",
	"quapp.alert": "Alert",
	"quapp.attach.audio": "Audio",
	"quapp.attach.file": "Plik (PDF, Excel, itd.)",
	"quapp.attach.picture": "Zdjęcie",
	"quapp.attach.record.sound": "Nagraj dźwięk",
	"quapp.attach.record.video": "Nagraj film",
	"quapp.attach.take.picture": "Zrób zdjęcie",
	"quapp.attach.video": "Film",
	"quapp.detector": "Detektor",
	"quapp.error": "Błąd",
	"quapp.loading": "Wczytywanie",
	"quapp.logout.warning1": "Ostrzeżenie!",
	"quapp.logout.warning2": "Wylogowanie z tej aplikacji spowoduje utratę wszystkich niezsynchronizowanych danych.",
	"quapp.logout.warning3": "Aktualna liczba niezsynchronizowanych działań: {{value}}.",
	"quapp.logout.warning4": "Czy na pewno chcesz się wylogować?",
	"quapp.notif.claim.cancelled": "{{value}} zostało anulowane",
	"quapp.notif.claim.comment": "Komentarz: {{comment}}",
	"quapp.notif.claim.paid": "{{value}} zostało wypłacone: ({{amount}} {{currency}}, {{quantity}} {{unit}})",
	"quapp.notif.claim.refused": "{{value}} zostało odrzucone",
	"quapp.notif.claim.warning": "{{value}} zostało zarejestrowane jako ostrzeżenie",
	"quapp.notif.label": "Reklamacja zaktualizowana:",
	"quapp.notif.title": "SteelUser",
	"quapp.notification": "Powiadomienie",
	"quapp.page.not.found": "Nie znaleziono strony",
	"quapp.process.closed": "Przyjęte lub odrzucone",
	"quapp.process.closed.paid": "Zapłacono",
	"quapp.process.closed.refused": "Odrzucono",
	"quapp.process.closed.warning": "Zarejestrowano jako ostrzeżenie",
	"quapp.process.create": "Czekanie na połączenie",
	"quapp.process.inprogress": "Przetwarzane przez ArcelorMittal",
	"quapp.process.push": "Przesłano do ArcelorMittal",
	"quapp.process.push-cancel": "Anulacja przesłane do ArcelorMittal",
	"quapp.process.push-update": "Modyfikacja przesłana do ArcelorMittal",
	"quapp.process.registered": "Zarejestrowane przez ArcelorMittal",
	"quapp.reader": "Zgłaszający",
	"quapp.validator": "Zatwierdzający",
	"quapp.warning": "Ostrzeżenie",
	"readonly.user.error": "W trybie symulacji nie można podejmować żadnych działań, można jedynie zapoznać się z opinią klienta",
	"remove.notification": "Usuń Powiadomienie",
	"remove.unrecognized.batch": "nie jest zidentyfikowaną partią. Wybierz prawidłową partię.",
	"request-feasibility": "Request feasibility",
	"request.card.information": "Informacje o żądaniu",
	"reset.order": "Resetowanie zamówienia",
	"reset.order.confirmation": "Czy chcesz kontynuować?",
	"reset.order.warning.add.product.another.family": "Ostrzeżenie: W koszyku znajduje się już co najmniej jeden produkt z innej rodziny produktowej. Dodanie tego produktu spowoduje zresetowanie aktualnego koszyka (wszystkich wybranych produktów).",
	"reset.order.warning.customer.change": "Ostrzeżenie! Zmiana klienta w zamówieniu spowoduje zresetowanie aktualnego koszyka (wszystkie wybrane produkty).",
	"saBusinessStatus.closed": "Zamknieto",
	"saBusinessStatus.high.risk.external": "High Risk External",
	"saBusinessStatus.high.risk.internal": "High Risk Internal",
	"saBusinessStatus.high.runner": "High runner",
	"saBusinessStatus.low.runner": "Low runner",
	"saBusinessStatus.on.hold": "Wstrzymane",
	"saBusinessStatus.running": "W toku",
	"saBusinessStatus.running.out": "Zmniejszenie stanu zapasów",
	"saBusinessStatus.start.up": "Rozpoczete",
	"sb.Cancel": "Anuluj",
	"sb.Download": "Pobierz",
	"sb.choose.options": "Wybierz opcje",
	"sb.detailed.report": "Szczegółowy raport",
	"sb.period": "Okres",
	"sb.type": "Rodzaj",
	"scan.barcode": "Kod kreskowy",
	"scan.batch.choose": "Wybierz tę partię",
	"scan.browser.title": "Rozpoznawanie partii",
	"scan.customer": "Klient",
	"scan.dimensions": "Wymiary",
	"scan.get.closer": "Zbliż się do etykiety",
	"scan.go-batch-card": "Przejdź do karty partii",
	"scan.invoiced": "Zafakturowano",
	"scan.looking.batch.data": "Wyszukiwanie danych partii",
	"scan.looking.multi.batch.data": "Looking for related batches",
	"scan.material-scan": "Skan materiału",
	"scan.mill.order": "Numer zamówienia nadany przez hutę",
	"scan.quantity": "Ilość",
	"scan.quantity.optional": "Ilość (fakultatywnie)",
	"scan.quantity.placeholder": "Wpisz wysłaną ilość",
	"scan.select.batch": "Wybierz krąg",
	"scan.serial.number": "Numer seryjny",
	"scan.serial.number.placeholder": "Wpisz numer seryjny",
	"scan.supplier.order": "Zlecenie dostawcy",
	"scan.tip.disable-tips": "Wyłącz wskazówki",
	"scan.tip.message": "Nie możesz zeskanować kodu kreskowego? Przejdź do ustawień (przycisk w prawym górnym rogu ekranu), aby sprawdzić, czy jest włączony prawidłowy tryb skanowania dla danego kodu kreskowego.",
	"scan.tip.ok": "OK",
	"scan.tip.title": "Wskazówka",
	"scan.title": "Skanuj etykiety",
	"scan.weight": "Waga",
	"schedule-business-order-card.commercial-documents": "Dokumenty handlowe",
	"schedule-business-order-filter.customer-article-reference": "Numer pozycji klienta",
	"schedule-business-order-filter.thickness": "Grubość (mm)",
	"schedule-business-order-filter.width": "Szerokość (mm)",
	"schedule-business-order.SA-unit": "SA unit",
	"schedule-business-order.card": "Szczegóły zamówienia SA",
	"schedule-business-order.cem-partner": "CEM partner",
	"schedule-business-order.certificate": "Certyfikat",
	"schedule-business-order.choice": "Gatunek",
	"schedule-business-order.country-of-scf": "Country of SCF",
	"schedule-business-order.customer-expected-cumul": "Customer expected cumul",
	"schedule-business-order.customer-realized-cumul": "Customer realized cumul",
	"schedule-business-order.customer.article.reference": "Numer pozycji klienta",
	"schedule-business-order.customer.order.number": "Numer zamówienia klienta",
	"schedule-business-order.delivery": "Dostawa",
	"schedule-business-order.delivery.address": "Adres dostawy",
	"schedule-business-order.delivery.mode": "Sposób dostawy",
	"schedule-business-order.final-use": "Zastosowanie",
	"schedule-business-order.form": "Forma",
	"schedule-business-order.icon": "icon",
	"schedule-business-order.in-transit-stock": "W tranzycie",
	"schedule-business-order.incoterm": "Incoterm",
	"schedule-business-order.internal-diameter": "Średnica wewnętrzna (mm)",
	"schedule-business-order.interpretation-delivery-date": "Określenie daty dostawy",
	"schedule-business-order.lead-delay": "Lead/Delay",
	"schedule-business-order.needs": "Needs",
	"schedule-business-order.oil-reference": "Rodzaj oleju",
	"schedule-business-order.order-follow-up-schedule": "Order follow-up schedule",
	"schedule-business-order.order-reason": "Przyczyna zamówienia",
	"schedule-business-order.packing": "Opakowanie",
	"schedule-business-order.pds-instruction": "PDS instruction",
	"schedule-business-order.plant-stock": "Na magazynie w hucie",
	"schedule-business-order.product": "Product information",
	"schedule-business-order.product.category": "Kategoria produktu",
	"schedule-business-order.protection": "Zabezpieczenie",
	"schedule-business-order.realized-cumul": "Realized cumul",
	"schedule-business-order.reference-of-alignment": "Reference of alignment",
	"schedule-business-order.sa-business-status": "SA business status",
	"schedule-business-order.sfc-country": "SFC country",
	"schedule-business-order.shortdescription": "Short description",
	"schedule-business-order.situation-overview": "Situation overview",
	"schedule-business-order.standard": "Norma",
	"schedule-business-order.standard.steelgrade": "Norma",
	"schedule-business-order.stock": "Stock",
	"schedule-business-order.stock-blocked": "Zablokowany",
	"schedule-business-order.stock-partner": "Stock partner",
	"schedule-business-order.supplier.order.number": "Numer zamówienia dostawcy",
	"schedule-business-order.surface-aspect": "Powierzchnia",
	"schedule-business-order.time-of-alignment": "Time of alignment",
	"schedule-business-order.transport-mode": "Rodzaj transportu",
	"schedule-business-order.wip": "WIP",
	"search.batches": "Kręgi/paczki",
	"search.by": "szukaj wg",
	"search.certificates": "Certifikat",
	"search.claim": "Roszczenia",
	"search.count.batches": "Kręgi/paczki: {{value}}",
	"search.count.closed": "{{value}} Reklamacje rozpatrzone",
	"search.count.drafts": "{{value}} Wersje robocze",
	"search.count.orders": "Zamówienia: {{value}}",
	"search.count.pending": "{{value}} Reklamacje nierozpatrzone",
	"search.dispatch.advices": "Awiza",
	"search.display": "Wyświetl",
	"search.guarantees": "Gwarancje",
	"search.invoices": "Faktury",
	"search.order.acknowledgments": "Potwierdzenia zamówień",
	"search.placeholder": "Szukaj...",
	"search.see.result": "Zobacz wynik",
	"search.see.results": "Zobacz {{value}} wyników",
	"search.shipment": "Wysyłka",
	"search.shipments": "Wysyłki",
	"section.filters": "Filtry",
	"see.all.batches": "See all batches",
	"see.all.documents": "Zobacz wszystkie dokumenty",
	"select.auction.title": "Wybierz aukcję",
	"select.new.administrator": "Usunięcie tego użytkownika będzie wymagało wybrania nowego administratora dla tej organizacji:",
	"select.product.spec": "Wybierz swój katalog produktów",
	"sent.closed.no.issue": "Brak reklamcji rozpatrzonych",
	"sent.hide.process": "Ukryj proces",
	"sent.issue": "Reklamacje",
	"sent.pending.no.issue": "Brak reklamacji w toku",
	"sent.search.issues": "Szukaj reklamacji",
	"sent.show.process": "Pokaż proces",
	"sent.since": "Od {{value}}",
	"sent.status": "Status",
	"service.parameters.value": "Wartość",
	"services.Back": "POWRÓT DO DODAWANIA USŁUGI",
	"services.management": "Zarządzanie usługami",
	"services.settings": "Ustawienia",
	"settings.account": "Moje konto",
	"settings.actions": "Działania",
	"settings.activity": "Aktywność",
	"settings.activity-desc": "Ostatnie logowanie",
	"settings.add-all-services": "Dodaj wszystkie usługi",
	"settings.all-services-added": "Wszystkie usługi dodane do użytkownika",
	"settings.any": "Dowolne",
	"settings.boolean.off": "Wył.",
	"settings.boolean.on": "Wł.",
	"settings.business-id": "Nr identyfikacyjny firmy",
	"settings.change-simulated-user": "Zmień użytkownika w symulacji",
	"settings.city": "Miejscowość",
	"settings.company": "Firma",
	"settings.date-format-dd/mm/yyyy": "dd/mm/rrrr",
	"settings.date-format-mm/dd/yyyy": "dd/mm/rrrr",
	"settings.delegation.changement": "Zmień moją delegowaną organizację",
	"settings.download.aggregated": "Łącznie",
	"settings.download.duplicate": "Duplikuj",
	"settings.drag-drop-services-here": "Przeciągnij i upuść usługi, które chcesz dodać tutaj",
	"settings.drag-services-here": "Przeciągnij tutaj usługi, aby usunąć z konta użytkownika",
	"settings.email": "Email",
	"settings.faq": "FAQ",
	"settings.firstname": "Imię",
	"settings.gender": "Płeć",
	"settings.general": "Ustawienia ogólne",
	"settings.general.date-format": "Format daty",
	"settings.general.helper": "Ustawienia do aplikacji mobilnych i strony internetowej",
	"settings.general.time-format": "Format czasu",
	"settings.generalSalesCondition": "ogólne warunki sprzedaży",
	"settings.identity": "Szczegóły",
	"settings.identity.desc": "Dane osobowe użytkownika",
	"settings.informational-visibilities": "Autoryzacje dotyczące informacji",
	"settings.last-connection-date": "Data ostatniego połączenia",
	"settings.lastname": "Nazwisko",
	"settings.legal-information": "Informacje prawne",
	"settings.legal-information.property": "Aplikacja SteelUser jest własnością ArcelorMittal FCE SA z siedzibą 24-26 Boulevard d'Avranches L-1160 Luksemburg, Luksemburg.",
	"settings.legal-information.questions": "Wszelkie pytania i komentarze dotyczące aplikacji należy kierować do zespołu e-service:",
	"settings.legal-information.require-registration": "By korzystać z aplikacji wymagana jest rejestracja",
	"settings.login": "Nazwa użytkownika",
	"settings.logout": "Wyloguj",
	"settings.manage-info-visibilities": "Zarządzaj autoryzacjami dotyczącymi informacji",
	"settings.manage-services": "Zarządzaj usługami",
	"settings.name": "Nazwa",
	"settings.order.customer": "Numer zamówienia klienta",
	"settings.order.number": "Numer zamówienia",
	"settings.order.supplier": "Numer zamówienia dostawcy",
	"settings.order.tracking": "Śledzenie zamówień",
	"settings.ordertracking.sorting.list": "Domyślne sortowanie listy",
	"settings.organisation": "Organizacja",
	"settings.organizations": "Organizacje",
	"settings.organizations.desc": "Przynależność użytkownika do organizacji",
	"settings.organizations.name": "Nazwa",
	"settings.organizations.role": "Funkcja",
	"settings.organizations.visibilities.address": "Adres",
	"settings.organizations.visibilities.name": "Nazwa / Miejscowość",
	"settings.other": "Pozostałe ustawienia",
	"settings.password-doesn't-match-rules": "Hasło nie spełnia poniższych wymagań",
	"settings.password-updated-successfully": "Hasło zostało zmienione pomyślnie",
	"settings.phone": "Telefon komórkowy",
	"settings.phone-number": "Numer telefonu",
	"settings.privacy-policy": "Polityka prywatności",
	"settings.privacypolicy.ContactUs": "Skontaktuj się z nami",
	"settings.privacypolicy.ContactUsAddress": "Arcelormital FCE SA, 24-26 boulevard D’avranches L-1160 Luxembourg, Luxembourg",
	"settings.privacypolicy.ContactUsByEmail": "lub na adres email:",
	"settings.privacypolicy.ContactUsPlease": "Wszystkie pytania dotyczące Polityki Prywatności prosimy kierować do:",
	"settings.privacypolicy.GeneralInformation": "Informacje ogólne",
	"settings.privacypolicy.GeneralInformationProperty": "SteelUser jest własnością ArcelorMittal France. ArcelorMittal France, spółka prawa francuskiego wpisana do rejestru handlowego w Bobigny pod numerem 562 094 425, z siedzibą pod adresem Immeuble “Le Cézanne, 6, rue André Campra, F-93200 Saint-Denis, Francja, prowadzi stronę SteelUser.com, koordynuje utrzymanie tej strony i zajmuje się funkcjami integracyjnymi. Zarejestrowany użytkownik SteelUser uzyskuje możliwość bezpiecznego i poufnego przeprowadzania transakcji (zakupu, sprawdzania w Internecie stanu zamówień i dokumentacji sprzedaży).",
	"settings.privacypolicy.GeneralInformationWebservices": "Platforma SteelUser oferuje klientom ArcelorMittal zaawansowane usługi internetowe, takie jak sprawdzanie stanu zamówień w Internecie, konsultowanie dokumentacji handlowej, aukcje materiałów uzupełniających, składanie zamówień przez Internet i konsultowanie danych technicznych. Służy to uproszczeniu i przyspieszeniu współpracy między nabywcami stali a ArcelorMittal.",
	"settings.privacypolicy.HypertextLinksContent": "Hiperłącza prowadzące do innych zasobów w Internecie, zwłaszcza udostępnianych przez kontrahentów, są zamieszczone w platformie SteelUser za uprzednią wyraźną, pisemną zgodą. Użytkownicy SteelUser mogą zamieszczać hiperłącza do tej strony bez uprzedniej wyraźnej zgody ArcelorMittal.",
	"settings.privacypolicy.PersonalInformation": "Infomacje które chcesz zapisać",
	"settings.privacypolicy.PersonalInformationContent": "Platforma SteelUser służy do obsługi pewnych procesów biznesowych w ArcelorMittal, takich jak zarządzanie zamówieniami, sprawdzanie roszczeń, aukcje, wydawanie dokumentacji handlowej i technicznej o produktach ArcelorMittal. Wymienione funkcje biznesowe obejmują zarządzanie czynnościami użytkowników, którzy reprezentują klientów ArcelorMittal. Dlatego formularz rejestracji w platformie SteelUser wymaga wpisania pewnych danych (takich jak nazwa klienta, nazwisko i imię, dane teleadresowe i stanowisko). Brak wpisów obowiązkowych danych osobowych podczas określonej czynności uniemożliwia jej przeprowadzenie.",
	"settings.privacypolicy.PrivacyPolicy": "Polityka prywatności",
	"settings.privacypolicy.PrivacyPolicyContent": "Dbamy o ochronę danych osobowych użytkowników. ArcelorMittal stosuje procedurę ochrony danych („Obowiązujący regulamin korporacyjny”). Procedura ta stanowi uogólnioną i uproszczoną podstawę prawną wszystkich baz danych i aplikacji przekazujących dane osobowe w grupie kapitałowej. Procedura ochrony danych obowiązująca w całej grupie kapitałowej ArcelorMittal wprowadza minimalny standard ochrony danych osobowych przekazywanych w skali globalnej, w stopniu wymaganym przepisami UE. Procedura ochrony danych w ArcelorMittal („Obowiązujący regulamin korporacyjny”) wraz z głównymi zasadami jest opublikowana na",
	"settings.privacypolicy.Property": "Własność Intelektualna i przemysłowa",
	"settings.privacypolicy.PropertyContent": "Treść platformy SteelUser (w tym między innymi tekst, ilustracje, pliki audio i wideo, kod HTML, przyciski, znaki towarowe, oprogramowanie, symbole) stanowi własność ArcelorMittal, chyba że wskazano inaczej. Nie narusza ona praw osób trzecich. Treści nie wolno w żaden sposób wprowadzać do obrotu, rozpowszechniać, przesyłać, kopiować ani zmieniać bez uprzedniej pisemnej zgody ArcelorMittal. Korzystanie z treści platformy SteelUser bez upoważnienia jest surowo wzbronione. Stanowi ono naruszenie przepisów o ochronie własności intelektualnej, znaków towarowych oraz prawa własności przemysłowej. Użytkownicy mogą pobierać, wyświetlać i drukować treść tej strony na komputerach osobistych wyłącznie do własnego i osobistego użytku.",
	"settings.privacypolicy.Protection": "Ochrona Danych Osobowych",
	"settings.privacypolicy.Protection2years": "Jeżeli użytkownik pozostaje nieaktywny przez 2 lata, jego dostęp do SteelUser jest automatycznie anulowany. Dane osobowe, które przestaną być potrzebne do osiągania wskazanych celów, będą zniszczone, usunięte lub pozbawione szczegółów wskazujących tożsamość. ArcelorMittal stosuje wytyczne i procedury zarządzania usuwaniem danych osobowych.",
	"settings.privacypolicy.ProtectionAbuse": "Użytkownicy powstrzymają się, mają dostęp do baz danychm, od jakiegokolwiek niezgodnego z prawem ich wykorzystania  i od wszelkich działań mogących zaszkodzić życiu prywatnmu lub reputacji innych osób.",
	"settings.privacypolicy.ProtectionCommunication": "ArcelorMittal informuje użytkowników, że ich dane osobowe nie będą przykazywane osobom trzecim. Po uzyskaniu zgody na przetwarzanie danych objaśniamy w miarę potrzeby przyczyny i cele przetwarzania. Dane użytkowników są zachowywane w ścisłej tajemnicy. Użytkownik ma prawo cofnąć zgodę na przetwarzanie i przekazywanie swych danych, zwracając się po adres podany w zakończeniu tego działu. Zwracając się o informacje, zakładamy że użytkownik (i) zgadza się na przekazywanie jego danych między ArcelorMittal a podmiotami zależnymi (wymienionymi na stronie internetowej www.arcelormittal.com) oraz (ii) zezwala ArcelorMittal na korzystanie z tych danych w przyszłości w celu informowania o ArcelorMittal i produktach, które mogą interesować użytkownika.",
	"settings.privacypolicy.ProtectionResponsible": "Po udzieleniu użytkownikowi (lub wybraniu przez użytkownika) hasła dostępu do pewnych części strony SteelUser użytkownik jest zobowiązany zachować to hasło w tajemnicy. Zwracamy się do użytkowników, aby nikomu nie udostępniali haseł. Użytkownik zobowiązuje się (a) bezzwłocznie zawiadomić nas o użyciu jego hasła lub konta bez pozwolenia i o każdym innym przypadku naruszenia ochrony danych oraz (b) wylogować się ze swojego konta na zakończenie każdej sesji. Użytkownik jest zobowiązany sprawować kontrolę nad rozpowszechnianiem i wykorzystaniem swego hasła, swego konta oraz zawiadamiać nas o zamiarze zlikwidowania konta na tej stronie. Nie ponosimy odpowiedzialności za żadne straty i szkody spowodowane naruszeniem tych postanowień.",
	"settings.privacypolicy.ProtectionSecrecy": "ArcelorMittal zobowiązuje się przestrzegać zobowiązania do zachowania danych osobowych w tajemnicy. Ma obowiązek zachować poufność tych danych oraz zastosować środki techniczne i organizacyjne zapobiegające zmianom danych, utracie danych i nieuprawionemu dostępowi do danych.",
	"settings.privacypolicy.ResponsabilitiesContent": "ArcelorMittal wprowadza platformę SteelUser oferując dostępne, zweryfikowane dane i/lub narzędzia, ale ArcelorMittal nie jest odpowiedzialny za błędym brak dostępności danychm i/lub obecność wirusa platformie.",
	"settings.privacypolicy.UseCookiesInstalled": "Użytkownik odwiedzający SteelUser przyjmuje do wiadomości, że w jego oprogramowaniu do nawigacji mogą być zapisane pliki cookie. Pliki cookie umożliwiają zapisanie informacji o zachowaniu użytkownika na stronie internetowej. Służą one wyłącznie do zapewnienia poprawnego działania chronionych części strony SteelUser.",
	"settings.privacypolicy.UseCookiesNavigation": "Parametry oprogramowania informują użytkowników o użyciu ciasteczek i jak je odrzucić w następujący sposób:",
	"settings.privacypolicy.UseCookiesRefusing": "Użytkownicy są jednak poinformowanie iż ich odrzucenie spowoduje brak dostępu do prywatnej części strony, w szczególności do przeprowadzania transacji online.",
	"settings.privacypolicy.UseDataProvidedConsultrectify": "Pewni użytkownicy obejmują funkcję administratora, który zarządza profilami pracowników ich firm. Administrator jest zobowiązany powiadomić tych użytkowników o przysługujących im prawach dostępu do danych, zmiany danych i zlikwidowania ich profili. Każdy użytkownik SteelUser ma prawo sprawdzić i sprostować swoje dane osobowe, pisząc do : Arcelormital FCE SA, 24-26 boulevard D’avranches L-1160 Luxembourg, Luksemburg lub pocztą elektroniczną",
	"settings.privacypolicy.UseDataProvidedResponses": "Informujemy użytkowników, że informacje wprowadzone w platformie SteelUser, zwłaszcza w celu uzyskania dostępu do chronionych zakładek na tej stronie, mogą być wykorzystywane przez ArcelorMittal i przekazywane wydziałom zajmującym się działalnością produkcyjną i handlową w zakresie niezbędnym do przeprowadzenia transakcji.",
	"settings.privacypolicy.UseGoogleAnalytics": "Użycie Google Analytics",
	"settings.privacypolicy.UseGoogleAnalyticsContent": "Pliki cookie z Google Analytics służą do gromadzenia informacji o sposobie, w jaki użytkownicy korzystają z naszej strony. Informacje te służą nam do sporządzania raportów i pozwalają doskonalić stronę.  Tego typu pliki cookie gromadzą informacje anonimowe, takie jak liczba odwiedzających stronę internetową, poprzednio odwiedzona strona i pozostałe odwiedzane strony. Informacje o korzystaniu z danych przez Google znajdują się pod adresem:",
	"settings.privacypolicy.Worldwidetransfer": "Ogólnoświatowe przekazywanie danych osobowych",
	"settings.privacypolicy.amwebsite": "Strona internetowa ArcelorMittal",
	"settings.privacypolicy.creditsforpictures": "Kredyty za zdjęcia",
	"settings.privacypolicy.hypertextlinks": "Łącza hipertekstowe",
	"settings.privacypolicy.ifyouareusing": "Jeżeli korzystasz z",
	"settings.privacypolicy.responsabilities": "Odpowiedzialność",
	"settings.privacypolicy.tableofcontent": "Spis treści",
	"settings.privacypolicy.usecookies": "Wykorzystywanie plików cookie",
	"settings.privacypolicy.usedataprovided": "Wykorzystywanie podanych danych",
	"settings.privacypolicy.worldwidetransfercontent": "Podmioty grupy ArcelorMittal na całym świecie mają dostęp do platformy SteelUser. Dane osobowe są wykorzystywane wyłącznie w celach wskazanych w tej Polityce prywatności. Zapewniamy odpowiedni stopień ochrony i stosujemy odpowiednie środki bezpieczeństwa, aby wykluczyć przypadkowe lub niezgodne z prawem zniszczenie, utracenie, zmodyfikowanie, nieuprawnione ujawnienie lub nieuprawniony dostęp do danych osobowych. Korzystanie z platformy SteelUser oznacza zgodę na przekazywanie.",
	"settings.product": "Produkt",
	"settings.product.article": "Numer pozycji klienta",
	"settings.product.standard.dimension": "Norma + wymiary",
	"settings.product.steelgrade": "Gatunek stali",
	"settings.profile": "Profil",
	"settings.remove-service": "Usuń usługę",
	"settings.remove-service-confirmation": "Czy na pewno chcesz usunąć tę usługę",
	"settings.requested.email": "Requested Email",
	"settings.sales.framework": "Warunki Sprzedaży",
	"settings.save-changes": "Zapisz zmiany",
	"settings.scan": "Skanowanie",
	"settings.scan.beep": "Sygnał dźwiękowy",
	"settings.scan.display-tip": "Wyświetl wskazówkę",
	"settings.scan.mode": "Tryb skanowania",
	"settings.scan.mode.laser": "Tryb lasera / pojedyncza wartość",
	"settings.scan.mode.matrix": "Matryca / wiele stref",
	"settings.select.download-type": "Wybierz sposób pobierania danych:",
	"settings.select.language": "Wybierz język:",
	"settings.select.order.number": "Wybierz sposób wyświetlania numerów zamówień:",
	"settings.select.ordertracking.sortlist": "Wybierz sposób sortowania listy w sekcji śledzenia zamówień:",
	"settings.select.product": "Wybierz sposób wyświetlania produktów:",
	"settings.select.scan.beep": "Czy chcesz, aby każdemu rozpoznaniu danych towarzyszył sygnał dźwiękowy?",
	"settings.select.scan.mode": "Wybierz preferowaną metodę skanowania:",
	"settings.select.weight": "Wybierz sposób wyświetlania wagi:",
	"settings.services-mangement": "Zarządzanie usługami",
	"settings.snackbar.downloadType": "Twój sposób pobierania to {{downloadType}}.",
	"settings.snackbar.language": "Teraz ustawiony będzie język {{lang}}.",
	"settings.snackbar.order": "Obecnie wyświetlane oznaczenie zamówienia to {{order}}.",
	"settings.snackbar.product": "Obecne wskazanie produktu to {{product}}.",
	"settings.snackbar.visibility": "Obecnie można wyświetlić dane {{visibility}} dostawcy {{supplier}}.",
	"settings.snackbar.weight": "Obecne wskazanie masy to {{weight}}.",
	"settings.supplier": "Dostawca",
	"settings.survey.wot.overview": "nowej strony internetowej",
	"settings.terms.of.use": "Regulamin",
	"settings.time-format-12:00": "12:00",
	"settings.time-format-24:00": "24:00",
	"settings.update.validate": "Potwierdź",
	"settings.user-update-error": "Wystąpił błąd podczas aktualizacji użytkownika, zmiany nie zostały zapisane.",
	"settings.visibility": "Autoryzacje",
	"settings.visibility.changeimpact": "Zmiana tej wartości wpływa na inne systemy w SteelUser.",
	"settings.visibility.data": "Obecnie widzę dane (Organizacja - Dostawca)",
	"settings.visibility.helper": "Wybierz zakres do aplikacji mobilnej i internetowej",
	"settings.visibility.info": "Aurotyzacja jest taka sama na platformie SteelUser mobilnej i internetowej.",
	"settings.weight": "Waga",
	"settings.weight.gross": "Brutto",
	"settings.weight.net": "Netto",
	"share.view.share": "Udostępnij",
	"shareview.success.message": "Udostępnienie powiodło się",
	"shipment-card.data-not-found": "Shipment data not found",
	"shipment.card": "Wysyłka",
	"shipment.card.information": "Dane dotyczące wysyłki",
	"shipment.dispatch-advice": "Awizo",
	"shipment.dispatch-advice-date": "Data awiza",
	"shipment.dispatch-advice-number": "Numer awiza",
	"shipment.dispatch-date": "Data wysyłki",
	"shipment.filter.batch-number": "Numer kręgu/paczki",
	"shipment.filter.customer": "Klient",
	"shipment.filter.customer-article-reference": "Numer pozycji klienta",
	"shipment.filter.customer-order-number": "Numer zamówienia klienta",
	"shipment.filter.dispatch-advice-date": "Data awiza",
	"shipment.filter.dispatch-advice-number": "Numer awiza",
	"shipment.filter.dispatch-date": "Data wysyłki",
	"shipment.filter.mill": "Huta",
	"shipment.filter.ship-to": "Odbiorca",
	"shipment.filter.sold-to": "Klient",
	"shipment.filter.standard-steelgrade": "Norma",
	"shipment.filter.supplier-order-number": "Numer zamówienia dostawcy",
	"shipment.filter.thickness": "Grubość",
	"shipment.filter.transport-mode": "Rodzaj transportu",
	"shipment.filter.transport-reference": "Oznaczenie transportu",
	"shipment.filter.width": "Szerokość",
	"shipment.first": "Pierwszy",
	"shipment.last": "Ostatni",
	"shipment.shipped-qty-gross": "Wysłana ilość brutto (t)",
	"shipment.step": "Krok",
	"shipment.tmode.byairplane": "Transport lotniczy",
	"shipment.tmode.byinlandwaterways": "Transport rzeczny",
	"shipment.tmode.byrail": "Transport kolejowy",
	"shipment.tmode.byrail.feve": "Transport kolejowy (FEVE)",
	"shipment.tmode.byrailroad": "Transport kolejowy i drogowy",
	"shipment.tmode.byroad": "Transport drogowy",
	"shipment.tmode.bysea": "Transport morski",
	"shipment.tmode.bytrain": "Kolej",
	"shipment.tmode.notspecified": "nie określono",
	"shipment.to": "Wysyłka do",
	"shipment.transport-reference": "Oznaczenie transportu",
	"simulated.customer.updated": "Symulacja klienta została zaktualizowana.",
	"snackbar.add.existing.user.validation.mail-external": "User has been correctly created.",
	"snackbar.add.user.validation.mail-external": "User has been correctly created. An email has been sent to the new user to activate the account.",
	"snackbar.add.user.validation.mail-internal": "User has been correctly created. An email has been sent to the admin for validation.",
	"snackbar.offline": "Do zmiany ustawienia jest wymagane aktywne połączenie sieciowe",
	"snackbar.survey": "Dziękujemy za poświęcony nam czas – opinie użytkowników są dla nas cenne.",
	"sortby.cdd.asc": "CDD rosnąco",
	"sortby.cdd.desc": "CDD malejąco",
	"sortby.order.asc": "Kolejność rosnąco",
	"sortby.order.desc": "Kolejność malejąco",
	"sortby.product.asc": "Produkty rosnąco",
	"sortby.product.desc": "Produkty malejąco",
	"srvmg.requestor.description": "Pełnienie funkcji wnioskodawcy SOX",
	"srvmg.requestor.label": "Wnioskodawca",
	"srvmg.validator.description": "Pełnienie funkcji walidatora SOX",
	"srvmg.validator.label": "Walidator",
	"standard-steelgrade": "Standard steelgrade",
	"start.date": "Data rozpoczęcia",
	"status-group.blocked": "Blocked",
	"status-group.in-consignment": "Available - In consignment",
	"status-group.in-prod": "In Production",
	"status-group.in-transit": "Dostępne - w tranzycie",
	"status-group.rtt": "Dostępne - gotowe do wysyłki",
	"steelgrade-feasibility": "Steelgrade",
	"stock-alert.green": "Green",
	"stock-alert.orange": "Orange",
	"stock-alert.red": "Red",
	"submit.guarantee.request": "Prześlij swoją prośbę o gwarancję",
	"supplier.comment": "Uwagi dostawcy",
	"suppliergroup.amds": "ArcelorMittal Distribution Solutions",
	"suppliergroup.aperam": "Aperam",
	"suppliergroup.fce": "ArcelorMittal FCE",
	"survey.agree": "zgadzam się",
	"survey.amount.of.time": "czas poświęcony na wyszukanie informacji",
	"survey.answer.dialog.title": "Oceń użyteczność",
	"survey.clarity.information": "czytelność informacji",
	"survey.disagree": "nie zgadzam się",
	"survey.ease.find.information": "łatwość znajdowania informacji",
	"survey.evaluate.statement": "Oceń poniższe 3 stwierdzenia",
	"survey.header.title": "Pomóż nam w doskonaleniu",
	"survey.statements": "Dobrze oceniam",
	"survey.strongly": "Zdecydowanie",
	"table.no.results": "brak wyników",
	"table.results": "{{value}} wyników",
	"term.policy": "Zasady i polityka",
	"title.product.catalogue": "Dodaj nowy produkt do swojego katalogu",
	"title.product.order": "Wybierz produkt, który chcesz zamówić",
	"tmode.byair": "Transport lotniczy",
	"tmode.bysea": "Transport morski",
	"tmode.default": "_Domyślne",
	"tmode.inlandwaterway": "Transport rzeczny",
	"tmode.lorry": "Ciężarówka",
	"tmode.lorryrailway": "Ciężarówka+Kolej",
	"tmode.othertospecify": "Inne",
	"tmode.rail": "Kolej",
	"tmode.railwaylorry": "Pociągiem + ciężarówką",
	"total.quantity.period": "Całkowita ilość w danym okresie",
	"transport.mode": "Rodzaj transportu",
	"transport.mode.boat": "Statek",
	"transport.mode.plane": "Samolot",
	"transport.mode.train": "Pociąg",
	"transport.mode.truck": "Ciężarówka",
	"transversal.dashboard": "Panel sterowania",
	"transversal.dashboard.plural": "Panele sterowania",
	"transversal.data-administration": "Administracja",
	"transversal.data-center": "Baza danych",
	"transversal.data-center-batches": "Kręgi/paczki",
	"transversal.data-center-documents": "Dokumenty handlowe",
	"transversal.data-center-order": "Zamówienia",
	"transversal.data-center.batches": "Baza danych: Kregi/paczki",
	"transversal.data-center.plural": "Bazy danych",
	"transversal.data-center.prototype": "Prototypes",
	"transversal.data-center.users": "Użytkownicy",
	"transversal.delegated-to": "Oddelegowano do",
	"transversal.eoffer": "e-oferta",
	"transversal.equality": "e-reklamacja",
	"transversal.go-back-to-old-steeluser": "Dostęp do poprzedniego systemu",
	"transversal.guarantee-documents": "Dokumenty gwarancyjne",
	"transversal.home": "Strona główna",
	"transversal.in-a-delegation": "(w delegacji)",
	"transversal.lastbatches": "Ostatnie kręgi/paczki",
	"transversal.legal": "Prawo",
	"transversal.order-tracking": "Śledzenie zamówień",
	"transversal.order.delivery": "Zamówienia i wysyłki",
	"transversal.quality": "Jakość",
	"transversal.schedule-busiess-order": "Schedule business orders",
	"transversal.services": "Serwisy",
	"transversal.shipments": "Wysyłki",
	"transversal.simulation-of": "Symulacja",
	"transversal.steeluser": "SteelUser",
	"unit.kg": "kg",
	"unit.m2": "m²",
	"unit.pc": "Sztuki",
	"unit.to": "Tony",
	"unrecognized.batch": "Niezidentyfikowana partia",
	"upload.file.count.error.message": "-max-count- files maximum per item",
	"upload.file.error.message": "An error occured during uploading process",
	"upload.file.maxitem.error.message": "3 files maximum per item",
	"upload.file.mime.type.error.message": "PDF, DOC, XLS, PPT or images only allowed. Upload type is MIME--TYPE",
	"upload.file.name.error.message": "Invalid file name - Use alphanumeric, hyphens, spaces, underscores and at least 5 characters",
	"upload.file.size.error.message": "Max file size is 20MB",
	"upload.file.space.error.message": "Sorry: not enough space to add automatically template file as attachment",
	"upload.or": "or",
	"user.belong.to": "Jestem przedstawicielem",
	"user.card.about-cookies": "Pliki cookie to małe pliki tekstowe, które mogą być wykorzystywane przez strony internetowe w celu usprawnienia korzystania z witryny. Prawo stanowi, że możemy przechowywać pliki cookie na Twoim urządzeniu, jeśli jest to niezbędne do prawidlowego funkcjonowania niniejszej strony. W przypadku wszystkich innych rodzajów plików cookie potrzebujemy Twojej zgody. Niniejsza strona internetowa wykorzystuje różne rodzaje plików cookie. Niektóre pliki cookie umieszczane są przez usługi stron trzecich, które pojawiają się na naszych stronach. W każdej chwili możesz zmienić lub wycofać swoją zgodę, kiedy tylko zobaczysz Oświadczenie dotyczące plików cookie na naszej stronie internetowej. Aby uzyskać więcej informacji o naszej firmie, sposobach kontaktu i przetwarzania przez nas danych osobowych, zapoznaj się z naszą Polityką prywatności.",
	"user.card.about-cookies.title": "Informacje o plikach cookie",
	"user.card.accept": "Akceptuj",
	"user.card.account-info": "Informacje o koncie",
	"user.card.allowed": "Dozwolone",
	"user.card.apply": "Zastosuj",
	"user.card.audience-measurement-cookies": "Korzystamy z plików cookie służących do mierzenia oglądalności strony, których cel jest ograniczony wyłącznie do pomiaru oglądalności witryny lub aplikacji, wykrywania problemów z nawigacją, optymalizacji wydajności technicznej lub ergonomii, określania mocy niezbędnych serwerów, analizy treści tworzonych wyłączne dla potrzeb konta firmy Arcelor Mittal.",
	"user.card.audience-measurement-cookies.title": "Pliki cookie służące do mierzenia oglądalności strony",
	"user.card.cookies-exempt-from-consents.one": "Pliki cookie zachowujące wybór wyrażony przez użytkowników w repozytorium plotera.",
	"user.card.cookies-exempt-from-consents.three": "Pliki cookie umożliwiające personalizację interfejsu użytkownika (np. w celu wyboru języka lub prezentacji usługi), przy czym takie dostosowanie jest nieodłącznym i oczekiwanym elementem usługi.",
	"user.card.cookies-exempt-from-consents.title": "Pliki cookie, które nie wymagają uzyskania zgody",
	"user.card.cookies-exempt-from-consents.two": "Pliki cookie wykorzystywane do usług wymagających uwierzytelnienia w ramach serwisu, w tym służące do zapewnienia bezpieczeństwa mechanizmu uwierzytelniania, na przykład poprzez ograniczenie zautomatyzowanych lub nieoczekiwanych prób logowania.",
	"user.card.details": "Szczegóły",
	"user.card.not-allowed": "Niedozwolone",
	"user.card.notifications": "Powiadomienia",
	"user.card.notifications.no-data": "Nie masz żadnych powiadomień",
	"user.card.notifications.tab.description": "Opis",
	"user.card.notifications.tab.details": "Szczegóły",
	"user.card.notifications.tab.frequency": "Częstotliwość",
	"user.card.notifications.tab.service": "Serwis",
	"user.card.notifications.tab.subscription": "Subskrypcja",
	"user.card.notifications.title": "Powiadomienia",
	"user.card.notifications.title.desc": "Lista Twoich powiadomień",
	"user.card.personalcard": "Użytkownik",
	"user.card.personalize-privacy-settings.title": "Spersonalizuj swoje ustawienia prywatności",
	"user.card.privacy-settings": "Ustawienia prywatności",
	"user.card.reject": "Odrzuć",
	"user.card.security": "Bezpieczeństwo",
	"user.card.security.1-lowercase-letter-rule": "1 mała litera (a, b, c, d, e)",
	"user.card.security.1-number-rule": "1 cyfra (1, 2, 3, 4)",
	"user.card.security.1-special-character-rule": "1 znak specjalny (:, /, !, _, -, #, @)",
	"user.card.security.1-uppercase-letter-rule": "1 duża litera (A, B, C, D, E)",
	"user.card.security.15-character-rule": "Minimalna liczba znaków to 15",
	"user.card.security.change-login-title": "Zmień swój login",
	"user.card.security.change-password-title": "Zmień hasło",
	"user.card.security.confirm-password-match": "Hasło potwierdzające powinno być takie samo jak nowe hasło",
	"user.card.security.password-must-contain-title": "Prawidłowe hasło musi zawierać co najmniej:",
	"user.card.security.username-error": "Please enter valid username",
	"user.card.security.your-current-password": "Twoje aktualne hasło",
	"user.card.security.your-login": "Twój login",
	"user.card.security.your-new-password": "Twoje nowe hasło",
	"user.card.security.your-repeat-new-password": "Powtórz nowe hasło",
	"user.card.services": "Serwisy",
	"user.card.services.no-data": "Nie masz żadnych usług",
	"user.card.services.tab.desc": "Opis",
	"user.card.services.tab.name": "Nazwa",
	"user.card.services.tab.settings": "Ustawienia",
	"user.card.services.title": "Lista usług",
	"user.card.services.title.desc": "Lista wszystkich dostępnych usług",
	"user.card.settings": "Ustawienia",
	"user.expired": "Expired",
	"user.expiryDate": "Expiry date",
	"user.gender.mr": "Pani",
	"user.gender.mrs": "Pani",
	"user.gender.ms": "Pani",
	"user.language": "Język",
	"user.need.connection": "Aby uzyskać dostęp do tej części, musisz się uwierzytelnić.",
	"user.no.connection": "Aby uzyskać dostęp do tej części, musisz mieć prawidłowe połączenie.",
	"user.no.role": "Profil użytkownika nie pozwala składać rekalamacji. Skontaktuj się z przedstawicielem ArcelorMittalm aby uzyskać pełen dostęp do aplikacji reklamacyjnej.",
	"user.no.service": "Profil użytkownika nie pozwala składać rekalamacji. Skontaktuj się z przedstawicielem ArcelorMittalm aby uzyskać pełen dostęp do aplikacji reklamacyjnej.",
	"user.notifications.add.subscription": "Dodaj",
	"user.notifications.btn.add.subscription": "Dodaj subskrypcję",
	"user.notifications.dialog.subscription": "Dodaj subskrypcję",
	"user.notifications.dropdown.frequency": "Częstotliwość",
	"user.notifications.dropdown.services": "Usługi",
	"user.notifications.dropdown.subscription": "Subskrypcja",
	"user.notifications.select.frequency": "Wybierz częstotliwość",
	"user.notifications.select.service": "Wybierz usługę",
	"user.notifications.select.subscription": "Wybierz subskrypcję",
	"user.see.data": "Aktualnie widzę dane dla",
	"user.supplier": "Mój dostawca",
	"user.user": "Użytkownik",
	"user.validation": "Użytkownik jest wymagany",
	"user.validationDaysLeft": "ValidationDaysLeft",
	"userServiceInfo.services.management": "Aktywne usługi",
	"userServiceInfo.services.settings": "Ustawienia",
	"users.details-card.actions": "Działania",
	"users.list": "Lista użytkowników",
	"view.shared.success": "Jesteś pewny, że chcesz usunąć tę wersję roboczą?",
	"view.validation": "Widok wymagany",
	"viewby.cdd.asc": "CDD rosnąco",
	"viewby.cdd.desc": "CDD malejąco",
	"viewby.mill.asc": "Huty rosnąco",
	"viewby.mill.desc": "Huty malejąco",
	"viewby.product.asc": "Produkty rosnąco",
	"viewby.product.desc": "Produkty malejąco",
	"viewby.step": "Krok",
	"wait.message": "Nie odświerzaj strony i nie cofaj do porzednej",
	"wait.message.fastlane": "Please DO NOT PRESS back button or refresh button in your browser",
	"wait.user.validation": "Oczekuje na aktywację",
	"want.to.cancel.issue": "Do you really want to cancel this issue",
	"want.to.close": "Jesteś pewny, że chcesz zamknąć?",
	"want.to.delete.draft": "Czy na pewno chcesz usunąć tę wersję roboczą",
	"want.to.delete.notification": "Czy na pewno chcesz usunąć to powiadomienie",
	"warning-product-category": "Please select a product category.",
	"warning-standard-steelgrade": "Please select a standard steelgrade.",
	"warning-steelgrade": "Please select a steelgrade.",
	"warning-sub-category": "Please select a sub category.",
	"warning-thickness": "Please enter thickness.",
	"warning-width": "Please enter width.",
	"warning.closed.orders": "You are writing a comment on a closed order",
	"warning.maximum.1000": "Nie można pobrać więcej niż 1000 zapisów jednocześnie",
	"warning.maximum.30": "Nie można pobrać więcej niż 30 zapisów jednocześnie",
	"woe.noitems": "Brak pozycji",
	"workflow-steps.next.error": "Coś poszło nie tak. Skontaktuj się z administratorem SteelUser",
	"xcarb-document.card": "XCarb® Document",
	"xcarb.label": "XCarb®"
};
